import { ReturnStatement } from '@angular/compiler';
import { Question } from '../shared/question';
import { Response } from '../shared/response';
import { ApplicationStorage } from './applicationStorage';
//@ts-ignore
import moment from 'moment';

export class Ploom3 {

    age: any;
    segment: any;
    endgame: boolean;
    answerQuestion2Value: any;
    answerQuestion3Value: any;
    answerQuestion4Value: any;
    keepAge: any;

    selectedBrandsQuestion5: string[] = [];


    answerQuestion4_glo_uniqValue: any;
    answerQuestion4_glo_airValue: any;
    answerQuestion4_glo_x2Value: any;
    answerQuestion4_glo_proValue: any;




    answerQuestion4_iqos_ilumaValue: any;
    answerQuestion4_iqos_oneValue: any;
    answerQuestion4_iqos_primeValue: any;
    answerQuestion4_iqos_original_duoValue: any;

    answerQuestion4_lil_solidezValue: any;

    answerQuestion5Value: any;

    answerQuestion5_gloValue: any;

    question_number: number;
    //Ploom
    last_question_number_ploom: any;

    //glo
    last_question_number_glo_hyper_uniq: any;
    last_question_number_glo_hyper_x2_air: any;
    last_question_number_glo_hyper_x2: any;
    last_question_number_glo_hyper_pro: any;


    //iqos
    last_question_number_iqos_iluma: any;
    last_question_number_iqos_iluma_one: any;
    last_question_number_iqos_iluma_prime: any;
    last_question_number_iqos_iluma_original_duo: any;


    //lil
    last_question_number_lil_solidez: any;

    last_question_number_ploom_1: any;

    last_question_number_glo_uniq_1: any;
    last_question_number_glo_air_1: any;
    last_question_number_glo_x2_1: any;
    last_question_number_glo_pro_1: any;


    last_question_number_iqos_iluma_1: any;
    last_question_number_iqos_iluma_one_1: any;
    last_question_number_iqos_iluma_prime_1: any;
    last_question_number_iqos_original_1: any;

    last_question_number_lil_solidez_1: any;


    render_question5_ploom: any;
    render_question5_iqos_iluma: any;
    render_question5_iqos_iluma_one: any;
    render_question5_iqos_iluma_prime: any;
    render_question5_iqos_iluma_original_duo: any;
    render_question5_glo_uniq: any;
    render_question5_glo_air: any;
    render_question5_glo_x2: any;
    render_question5_glo_pro: any;
    render_question5_lil_solidez: any;


    questionGateAge: Question;

    question1: Question;
    question2: Question;
    question3: Question;

    //Ploom
    question4: Question;

    //glo
    question4_glo_hyper_uniq: Question;
    question4_glo_hyper_x2_air: Question;
    question4_glo_hyper_x2: Question;
    question4_glo_hyper_pro: Question;



    //iqos
    question4_iqos_iluma: Question;
    question4_iqos_iluma_one: Question;
    question4_iqos_iluma_prime: Question;
    question4_iqos_iluma_original_duo: Question;

    //lil
    question4_lil_solidez: Question;

    question5_1_Ploom: Question;

    question5_1_iqos_iluma: Question;
    question5_1_iqos_iluma_one: Question;
    question5_1_iqos_iluma_prime: Question;
    question5_1_iqos_iluma_original_duo: Question;



    question5_1_glo_uniq: Question;
    question5_1_glo_air: Question;
    question5_1_glo_x2: Question;
    question5_1_glo_pro: Question;

    question5_1_lil_solidez: Question;



    question5_2_iqos_iluma: Question;
    question5_2_iqos_iluma_one: Question;
    question5_2_iqos_iluma_prime: Question;
    question5_2_iqos_iluma_original_duo: Question;


    question5_2_Ploom: Question;


    question5_2_glo_uniq: Question;
    question5_2_glo_air: Question;
    question5_2_glo_x2: Question;
    question5_2_glo_pro: Question;

    question5_2_lil_solidez: Question;


    question5: Question;

    //glo
    question5_glo_uniq: Question;
    question5_glo_air: Question;
    question5_glo_x2: Question;
    question5_glo_pro: Question;


    //iqos
    question5_iqos_iluma: Question;
    question5_iqos_iluma_one: Question;
    question5_iqos_iluma_prime: Question;
    question5_iqos_iluma_original_duo: Question;


    question5_lil_solidez: Question;

    question6: Question;
    question7_iqos_iluma: Question;
    question7_iqos_iluma_one: Question;
    question7_iqos_iluma_prime: Question;
    question7_iqos_original_duo: Question;
    question7_ploomx: Question;
    question7_glo_uniq: Question;
    question7_glo_air: Question;
    question7_glo_x2: Question;
    question7_glo_pro: Question;
    question7_lil_solidez: Question;

    // question7_glo: Question;
    // question7_iqos: Question;
    // question7_lil: Question;
    question8_iluma: Question;
    question8_iluma_one: Question;
    question8_iluma_prime: Question;
    question8_duo: Question;
    question8_ploom: Question;
    question8_uniq: Question;
    question8_air: Question;
    question8_x2: Question;
    question8_pro: Question;
    question8_lil: Question;
    question9: Question;
    question10_Sobranie: Question;
    question10_Terea: Question;
    question10_Levia: Question;
    question10_HEETS: Question;
    question10_DELIA: Question;
    question10_Dunhill: Question;
    question10_veo: Question;
    question10_neo: Question;
    question10_Kent: Question;
    question10_Fiit: Question;
    question10_Nuso: Question;


    question11: Question;
    question12: Question;
    question13: Question;
    question14: Question;
    question15: Question;
    question16: Question;
    question17: Question;
    question18: Question;

    question15_1: Question;
    question16_1: Question;
    question17_1: Question;
    question18_1: Question;

    question15_2: Question;
    question16_2: Question;
    question17_2: Question;
    question18_2: Question;

    question19: Question;
    question20: Question;
    question21: Question;
    question22: Question;
    question23: Question;
    question24: Question;
    question25: Question;
    question26: Question;
    question27: Question;
    question28: Question;
    question29: Question;
    question30: Question;
    question31: Question;
    question32_a: Question;
    question32_b: Question;
    question32_c: Question;
    question33: Question;
    question34: Question;
    question35: Question;
    question36: Question;
    question37: Question;
    question37_a: Question;
    question37_b: Question;
    question37_c: Question;
    question37_d: Question;
    question37_e: Question;
    question38: Question;
    question39: Question;
    question40: Question;
    question41: Question;
    question42: Question;
    question43: Question;
    question44: Question;
    question45: Question;
    question46: Question;
    question47: Question;
    question48: Question;
    question49: Question;
    question50: Question;
    question51: Question;
    question52: Question;
    question53: Question;
    question54: Question;
    question55: Question;
    question56: Question;
    question57: Question;
    question58: Question;
    question59: Question;
    question60: Question;
    question61: Question;
    question62: Question;
    question63: Question;
    question64: Question;
    question65: Question;
    question66: Question;
    question67: Question;
    // question68: Question;
    // question69: Question;
    // question70: Question;








    firstShuffleIndex = 1;
    maxFirstShuffleIndex = 6;
    currentIndexToRender = 1;
    usedNumbers: number[] = []
    questionsShuffleIndexes: any;
    hasQ38BeenRendered = false;
    horizontal: string = 'horizontal';
    vertical: string = 'vertical';


    generateUniqueNumber(firstShuffleIndex: number, maxFirstShuffleIndex: number): number {
        if (this.usedNumbers.length == maxFirstShuffleIndex) {
            this.usedNumbers = [];
        }

        let shuffleIndexes = [];
        for (let i = firstShuffleIndex; i <= maxFirstShuffleIndex; i++) {
            shuffleIndexes.push(i);
        }

        let availableNumbers = shuffleIndexes.filter(num => !this.usedNumbers.includes(num));

        const randomIndex = Math.floor(Math.random() * availableNumbers.length);
        const uniqueNumber = availableNumbers[randomIndex];

        this.usedNumbers.push(uniqueNumber);

        return uniqueNumber;
    }


    getLastQuestionId(questionsShuffleIndexes: any, currentKey: string, preQ: any): number {
        const key = Object.keys(questionsShuffleIndexes).find(key => questionsShuffleIndexes[key] === questionsShuffleIndexes[currentKey] - 1);
        //@ts-ignore
        const prevKey = key ? this[key]?.id : preQ;
        return prevKey;
    }

    questions: Array<Question>;

    incrementQuestionNumber(): number {
        return ++this.question_number;
    }

    constructor(private applicationStorage: ApplicationStorage) {
        this.endgame = false;
        this.question_number = 5;

        //(0.1) AGE
        this.questionGateAge = new Question(1, [],
            'Te rugăm să confirmi vârsta (ani)',
            '',
            'free-number',
            [new Response(1, '')],
            false,
            'horizontal');



        //(0.2) GENDER
        this.question1 = new Question(2, [1],  // 1a
            'Genul',
            '',
            'radio',
            [new Response(1, 'Bărbat'),
            new Response(2, 'Femeie')],
            false,
            'vertical'

        );

        this.question1.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let questionAgeSelectedIds = this.questionGateAge.responses.filter(r => r.id);
            if (questionAgeSelectedIds.length > 0) {
                if (parseInt(questionAgeSelectedIds[0].freeMessage) >= 18) {
                    this.keepAge = questionAgeSelectedIds[0].freeMessage;
                    this.age = true;
                    this.endgame = false;

                    return true;
                } else {
                    this.question1.responses.forEach(r => {
                        r.selected = false;
                    });
                    this.endgame = true;

                }
                return false;
            } else {
                return false;
            }

        }


        //(0.3) USER STATUS
        this.question2 = new Question(3, [2],//1b
            'Ești utilizator adult existent de produse din tutun și/sau țigarete electronice sau alte produse din plante/alte produse cu nicotină care se utilizează cu dispozitive de încălzit?',
            '',
            'radio',
            [new Response(1, 'Da'),
            new Response(2, 'Nu')],
            false,
            'vertical'
        );

        this.question2.render = () => {
            if (this.endgame == true) { return false; }
            // console.log('question1:', this.question1)
            let question1SelectedIds = this.question1.responses.filter(r => r.selected);
            if (question1SelectedIds.length > 0) {
                this.endgame = false;
                return true;

            } else {
                this.question2.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;
            }
            return false;
        }


        //(1.1) HT DEVICE BRAND USAGE
        this.question3 = new Question(4, [3],//1c
            'Pe care dintre următoarele dispozitive de încălzit tutunul sau alte produse din plante cu nicotină le folosești în prezent sau le-ai încercat vreodată ca adult?',
            '',
            'checkbox',
            [new Response(1, 'Glo Hyper + uniq', [], './assets/images/glo_hyper_uniq.png', undefined, undefined, 'HT'),
            new Response(2, 'Glo Hyper X2 Air', [], './assets/images/hyperx2_air.png', undefined, undefined, 'HT'),
            new Response(3, 'Glo Hyper X2', [], './assets/images/hyperx2.png', undefined, undefined, 'HT'),
            new Response(4, 'Glo Hyper Pro', [], './assets/images/hyper_pro.png', undefined, undefined, 'HT'),
            new Response(5, 'IQOS Iluma', [], './assets/images/iluma.png', undefined, undefined, 'HT'),
            new Response(6, 'IQOS Iluma One', [], './assets/images/iluma_one.png', undefined, undefined, 'HT'),
            new Response(7, 'IQOS Iluma Prime', [], './assets/images/iluma_prime.png', undefined, undefined, 'HT'),
            new Response(8, 'IQOS Original Duo', [], './assets/images/original_duo.png', undefined, undefined, 'HT'),
            new Response(9, 'Lil Solid EZ', [], './assets/images/lil_solidez.png', undefined, undefined, 'HT'),
            new Response(10, 'Ploom', [], './assets/images/ploomx.png', undefined, undefined, 'HT'),

            ],
            false,
            'vertical',
            '',
            1,
            true
        );

        this.question3.render = () => {
            if (this.endgame == true) { return false; }
            let question2SelectedIds = this.question2.responses.filter(r => r.id);
            if (question2SelectedIds.length > 0 && question2SelectedIds[0].selected == true) {
                this.endgame = false;
                return true;
            } else {
                //@ts-ignore
                this.question3.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;
            }
            return false;
        }


        // (1.2) HT DEVICE USAGE FREQUENCY 
        //a
        this.question4_iqos_iluma = new Question(5, [4],
            'Cât de des folosești IQOS Iluma?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );

        this.question4_iqos_iluma.render = () => {
            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            if ((question3SelectedIds.includes('Ploom') && question3SelectedIds.includes("IQOS Iluma"))) {
                this.last_question_number_iqos_iluma = this.question4_iqos_iluma.id;
                this.endgame = false;
                return true;
            } else {
                // this.endgame = true;
                this.question4_iqos_iluma.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }


        // (1.2) HT DEVICE USAGE FREQUENCY 
        //a
        this.question4_iqos_iluma_one = new Question(6, [4],
            'Cât de des folosești IQOS Iluma One?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );

        this.question4_iqos_iluma_one.render = () => {
            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            if ((question3SelectedIds.includes('Ploom') && question3SelectedIds.includes("IQOS Iluma One"))) {
                this.last_question_number_iqos_iluma_one = this.question4_iqos_iluma_one.id;
                this.endgame = false;
                return true;
            } else {
                // this.endgame = true;
                this.question4_iqos_iluma_one.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }

        // (1.2) HT DEVICE USAGE FREQUENCY 
        //a
        this.question4_iqos_iluma_prime = new Question(7, [4],
            'Cât de des folosești  IQOS Iluma Prime?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );

        this.question4_iqos_iluma_prime.render = () => {
            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            if ((question3SelectedIds.includes('Ploom') && question3SelectedIds.includes("IQOS Iluma Prime"))) {
                this.last_question_number_iqos_iluma_prime = this.question4_iqos_iluma_prime.id;
                this.endgame = false;
                return true;
            } else {
                // this.endgame = true;
                this.question4_iqos_iluma_prime.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }

        // (1.2) HT DEVICE USAGE FREQUENCY 
        //a
        this.question4_iqos_iluma_original_duo = new Question(8, [4],
            'Cât de des folosești IQOS Original Duo?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );

        this.question4_iqos_iluma_original_duo.render = () => {
            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            if ((question3SelectedIds.includes('Ploom') && question3SelectedIds.includes("IQOS Original Duo"))) {
                this.last_question_number_iqos_iluma_original_duo = this.question4_iqos_iluma_original_duo.id;
                this.endgame = false;
                return true;
            } else {
                // this.endgame = true;
                this.question4_iqos_iluma_original_duo.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }


        // (1.2) HT DEVICE USAGE FREQUENCY 
        //a 
        this.question4 = new Question(9, [4],
            'Cât de des folosești Ploom?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );
        this.question4.render = () => {
            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            // this.question4.setBrandsArr(question3SelectedIds


            if (question3SelectedIds.length > 0 && question3SelectedIds.includes('Ploom')) {
                this.last_question_number_ploom = this.question4.id;
                // this.question_number += 1;
                this.endgame = false;


                return true;
            } else {
                this.endgame = true;
                this.question4.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }


        // (1.2) HT DEVICE USAGE FREQUENCY 
        //b
        this.question4_glo_hyper_uniq = new Question(10, [4],
            'Cât de des folosești Glo Hyper + uniq?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );

        this.question4_glo_hyper_uniq.render = () => {

            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            if ((question3SelectedIds.includes('Ploom') && question3SelectedIds.includes('Glo Hyper + uniq'))) {
                this.last_question_number_glo_hyper_uniq = this.question4_glo_hyper_uniq.id;
                this.endgame = false;

                return true;
            } else {
                // this.endgame = true;
                this.question4_glo_hyper_uniq.responses.forEach(r => {
                    r.selected = false;
                });

            }
            return false;

        }

        // (1.2) HT DEVICE USAGE FREQUENCY 
        //b
        this.question4_glo_hyper_x2_air = new Question(11, [4],
            'Cât de des folosești Glo Hyper X2 Air?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );

        this.question4_glo_hyper_x2_air.render = () => {

            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            if ((question3SelectedIds.includes('Ploom') && question3SelectedIds.includes('Glo Hyper X2 Air'))) {
                this.last_question_number_glo_hyper_x2_air = this.question4_glo_hyper_x2_air.id;
                this.endgame = false;

                return true;
            } else {
                // this.endgame = true;
                this.question4_glo_hyper_x2_air.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }


        // (1.2) HT DEVICE USAGE FREQUENCY 
        //b
        this.question4_glo_hyper_x2 = new Question(12, [4],
            'Cât de des folosești Glo Hyper X2?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );

        this.question4_glo_hyper_x2.render = () => {

            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            if ((question3SelectedIds.includes('Ploom') && question3SelectedIds.includes('Glo Hyper X2'))) {
                this.last_question_number_glo_hyper_x2 = this.question4_glo_hyper_x2.id;
                this.endgame = false;

                return true;
            } else {
                // this.endgame = true;
                this.question4_glo_hyper_x2.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }
        // (1.2) HT DEVICE USAGE FREQUENCY 
        //b
        this.question4_glo_hyper_pro = new Question(13, [4],
            'Cât de des folosești Glo Hyper Pro?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );

        this.question4_glo_hyper_pro.render = () => {

            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            if ((question3SelectedIds.includes('Ploom') && question3SelectedIds.includes('Glo Hyper Pro'))) {
                this.last_question_number_glo_hyper_pro = this.question4_glo_hyper_pro.id;
                this.endgame = false;

                return true;
            } else {
                // this.endgame = true;
                this.question4_glo_hyper_pro.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }


        // (1.2) HT DEVICE USAGE FREQUENCY 
        //d
        this.question4_lil_solidez = new Question(14, [4],
            'Cât de des folosești Lil Solid EZ?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );

        this.question4_lil_solidez.render = () => {
            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            if ((question3SelectedIds.includes('Ploom') && question3SelectedIds.includes("Lil Solid EZ"))) {
                this.last_question_number_lil_solidez = this.question4_lil_solidez.id;
                this.endgame = false;

                return true;
            } else {
                // this.endgame = true;
                this.question4_lil_solidez.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }




        // (1.3) HT DEVICE USAGE DURATION
        //c -iqos
        this.question5_1_iqos_iluma = new Question(15, [5],
            'Cât de des folosești IQOS Iluma într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question5_1_iqos_iluma.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Iluma') && question4_iqos_ilumaSelectedIds?.[0]?.id == 2 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_1_iqos_iluma.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        // (1.3) HT DEVICE USAGE DURATION
        //c -iqos
        this.question5_1_iqos_iluma_one = new Question(16, [6],
            'Cât de des folosești IQOS Iluma One într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question5_1_iqos_iluma_one.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Iluma One') && question4_iqos_iluma_oneSelectedIds?.[0]?.id == 2 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_1_iqos_iluma_one.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        // (1.3) HT DEVICE USAGE DURATION
        //c -iqos
        this.question5_1_iqos_iluma_prime = new Question(17, [7],
            'Cât de des folosești IQOS Iluma Prime într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question5_1_iqos_iluma_prime.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Iluma Prime') && question4_iqos_iluma_primeSelectedIds?.[0]?.id == 2 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_1_iqos_iluma_prime.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -iqos
        this.question5_1_iqos_iluma_original_duo = new Question(18, [8],
            'Cât de des folosești IQOS Original Duo într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question5_1_iqos_iluma_original_duo.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Original Duo') && question4_iqos_iluma_duoSelectedIds?.[0]?.id == 2 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_1_iqos_iluma_original_duo.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }




        // (1.3) HT DEVICE USAGE DURATION
        //c -ploom
        this.question5_1_Ploom = new Question(19, [this.question4.id],
            'Cât de des folosești Ploom într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question5_1_Ploom.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Ploom') && question4SelectedIds?.[0]?.id == 2) {
                return true;
            } else {
                this.question5_1_Ploom.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -glo
        this.question5_1_glo_uniq = new Question(20, [this.question4_glo_hyper_uniq.id],
            'Cât de des folosești Glo Hyper + uniq într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question5_1_glo_uniq.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper + uniq') && question4_glo_uniqSelectedIds?.[0]?.id == 2 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_1_glo_uniq.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -glo
        this.question5_1_glo_air = new Question(21, [this.question4_glo_hyper_x2_air.id],
            'Cât de des folosești Glo Hyper X2 Air într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question5_1_glo_air.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper X2 Air') && question4_glo_x2_airSelectedIds?.[0]?.id == 2 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_1_glo_air.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -glo
        this.question5_1_glo_x2 = new Question(22, [this.question4_glo_hyper_x2.id],
            'Cât de des folosești Glo Hyper X2 într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question5_1_glo_x2.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper X2') && question4_glo_x2SelectedIds?.[0]?.id == 2 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_1_glo_x2.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -glo
        this.question5_1_glo_pro = new Question(23, [this.question4_glo_hyper_pro.id],
            'Cât de des folosești Glo Hyper Pro într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question5_1_glo_pro.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper Pro') && question4_glo_proSelectedIds?.[0]?.id == 2 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_1_glo_pro.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -glo
        this.question5_1_lil_solidez = new Question(24, [this.question4_lil_solidez.id],
            'Cât de des folosești Lil Solid EZ într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question5_1_lil_solidez.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Lil Solid EZ') && question4_lil_solidezSelectedIds?.[0]?.id == 2 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_1_lil_solidez.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question5_2_iqos_iluma = new Question(25, [5],
            'Cât de des folosești IQOS Iluma într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question5_2_iqos_iluma.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Iluma') && question4_iqos_ilumaSelectedIds?.[0]?.id == 3 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_2_iqos_iluma.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        //c -iqos
        this.question5_2_iqos_iluma_one = new Question(26, [6],
            'Cât de des folosești IQOS Iluma One într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question5_2_iqos_iluma_one.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Iluma One') && question4_iqos_iluma_oneSelectedIds?.[0]?.id == 3 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_2_iqos_iluma_one.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        // (1.3) HT DEVICE USAGE DURATION
        //c -iqos
        this.question5_2_iqos_iluma_prime = new Question(27, [7],
            'Cât de des folosești IQOS Iluma Prime într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question5_2_iqos_iluma_prime.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Iluma Prime') && question4_iqos_iluma_primeSelectedIds?.[0]?.id == 3 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_2_iqos_iluma_prime.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -iqos
        this.question5_2_iqos_iluma_original_duo = new Question(28, [8],
            'Cât de des folosești IQOS Original Duo într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question5_2_iqos_iluma_original_duo.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Original Duo') && question4_iqos_iluma_duoSelectedIds?.[0]?.id == 3 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_2_iqos_iluma_original_duo.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }




        // (1.3) HT DEVICE USAGE DURATION
        //c -ploom
        this.question5_2_Ploom = new Question(29, [this.question4.id],
            'Cât de des folosești Ploom într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question5_2_Ploom.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Ploom') && question4SelectedIds?.[0]?.id == 3) {
                return true;
            } else {
                this.question5_2_Ploom.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -glo
        this.question5_2_glo_uniq = new Question(30, [this.question4_glo_hyper_uniq.id],
            'Cât de des folosești Glo Hyper + uniq într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question5_2_glo_uniq.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper + uniq') && question4_glo_uniqSelectedIds?.[0]?.id == 3 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_2_glo_uniq.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -glo
        this.question5_2_glo_air = new Question(31, [this.question4_glo_hyper_x2_air.id],
            'Cât de des folosești Glo Hyper X2 Air într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question5_2_glo_air.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper X2 Air') && question4_glo_x2_airSelectedIds?.[0]?.id == 3 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_2_glo_air.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -glo
        this.question5_2_glo_x2 = new Question(32, [this.question4_glo_hyper_x2.id],
            'Cât de des folosești Glo Hyper X2 într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question5_2_glo_x2.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper X2') && question4_glo_x2SelectedIds?.[0]?.id == 3 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_2_glo_x2.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -glo
        this.question5_2_glo_pro = new Question(33, [this.question4_glo_hyper_pro.id],
            'Cât de des folosești Glo Hyper Pro într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question5_2_glo_pro.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper Pro') && question4_glo_proSelectedIds?.[0]?.id == 3 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_2_glo_pro.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -glo
        this.question5_2_lil_solidez = new Question(34, [this.question4_lil_solidez.id],
            'Cât de des folosești Lil Solid EZ într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question5_2_lil_solidez.render = () => {
            if (this.endgame == true) { return false; }


            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Lil Solid EZ') && question4_lil_solidezSelectedIds?.[0]?.id == 3 && question4SelectedIds?.[0]?.id <= 3) {
                return true;
            } else {
                this.question5_2_lil_solidez.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }





        // (1.3) HT DEVICE USAGE DURATION
        //c -iqos
        this.question5_iqos_iluma = new Question(35, [this.question5_1_iqos_iluma.id, this.question5_2_iqos_iluma.id],
            'De cât timp folosești IQOS Iluma?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question5_iqos_iluma.render = () => {
            if (this.endgame == true) { return false; }


            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question5_iqos_iluma.responses = this.question5_iqos_iluma.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );

            let hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            const hasChoosenPloomResponse3 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_uniqResponse3 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_airResponse3 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_x2Response3 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_proResponse3 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_ilumaResponse3 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_oneResponse3 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_primeResponse3 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_original_duoResponse3 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenLil_solidezResponse3 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;



            const hasChoosenPloomResponse2 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_uniqResponse2 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_airResponse2 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_x2Response2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_proResponse2 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_ilumaResponse2 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_oneResponse2 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_primeResponse2 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_original_duoResponse2 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenLil_solidezResponse2 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;



            const hasChoosenPloomResponse1 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_uniqResponse1 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_airResponse1 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_x2Response1 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_proResponse1 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_ilumaResponse1 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_oneResponse1 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_primeResponse1 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_original_duoResponse1 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenLil_solidezResponse1 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;


            let question5SelectedIds = this.question5_1_Ploom.responses.filter(r => r.selected);
            let question5_glo_uniqSelectedIds = this.question5_1_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds = this.question5_1_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds = this.question5_1_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds = this.question5_1_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds = this.question5_1_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds = this.question5_1_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds = this.question5_1_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds = this.question5_1_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds = this.question5_1_lil_solidez.responses.filter(r => r.selected);

            let question5SelectedIds2 = this.question5_2_Ploom.responses.filter(r => r.selected); // daca a raspuns la 3 si are cu cat de des pe luna
            let question5_glo_uniqSelectedIds2 = this.question5_2_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds2 = this.question5_2_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds2 = this.question5_2_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds2 = this.question5_2_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds2 = this.question5_2_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds2 = this.question5_2_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds2 = this.question5_2_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds2 = this.question5_2_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds2 = this.question5_2_lil_solidez.responses.filter(r => r.selected);

            this.last_question_number_iqos_iluma_1 = this.question5_iqos_iluma.id;
            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1)) numberOfQuestionAnswered += 1;
            })

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1 || this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1 || this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1 || this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1 || this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1 || this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1 || this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1 || this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1 || this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1 || this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1 || this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloomResponse1 || hasChoosenPloomResponse2 || hasChoosenPloomResponse3) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_ilumaResponse1 || hasChoosenIqos_ilumaResponse2 || hasChoosenIqos_ilumaResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_oneResponse1 || hasChoosenIqos_iluma_oneResponse2 || hasChoosenIqos_iluma_oneResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_primeResponse1 || hasChoosenIqos_iluma_primeResponse2 || hasChoosenIqos_iluma_primeResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duoResponse1 || hasChoosenIqos_original_duoResponse2 || hasChoosenIqos_original_duoResponse3) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniqResponse1 || hasChoosenGlo_uniqResponse2 || hasChoosenGlo_uniqResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_airResponse1 || hasChoosenGlo_airResponse2 || hasChoosenGlo_airResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2Response1 || hasChoosenGlo_x2Response2 || hasChoosenGlo_x2Response3) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_proResponse1 || hasChoosenGlo_proResponse2 || hasChoosenGlo_proResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidezResponse1 || hasChoosenLil_solidezResponse2 || hasChoosenLil_solidezResponse3) hasChoosenOneOfFirstThree.push('Lil Solid EZ')

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;
            // console.log('############################')
            // console.log('a raspuns la toate:', numberOfQuestionAnswered);
            // console.log('la cate a selectat intre 1 si 3:', hasChoosenOneOfFirstThree.length)
            // console.log('numar de branduri:', selectedBrandsAtQuestion3.length)
            // console.log('a raspuns la toata toate', allquestionAnswered)

            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Iluma') && (question5_iqos_ilumaSelectedIds.length > 0 || question5_iqos_ilumaSelectedIds2.length > 0 || (hasChoosenIqos_ilumaResponse1 && selectedBrandsAtQuestion3.length == allquestionAnswered && hasChoosenPloom))) {
                this.render_question5_iqos_iluma = true;
                return true;
            } else {
                this.question5_iqos_iluma.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        // (1.3) HT DEVICE USAGE DURATION
        //c -iqos
        this.question5_iqos_iluma_one = new Question(36, [this.question5_1_iqos_iluma_one.id],
            'De cât timp folosești IQOS Iluma One?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question5_iqos_iluma_one.render = () => {
            if (this.endgame == true) { return false; }


            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question5_iqos_iluma_one.responses = this.question5_iqos_iluma_one.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );
            let hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3

            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            const hasChoosenPloomResponse3 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_uniqResponse3 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_airResponse3 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_x2Response3 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_proResponse3 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_ilumaResponse3 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_oneResponse3 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_primeResponse3 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_original_duoResponse3 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenLil_solidezResponse3 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;



            const hasChoosenPloomResponse2 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_uniqResponse2 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_airResponse2 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_x2Response2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_proResponse2 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_ilumaResponse2 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_oneResponse2 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_primeResponse2 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_original_duoResponse2 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenLil_solidezResponse2 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;



            const hasChoosenPloomResponse1 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_uniqResponse1 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_airResponse1 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_x2Response1 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_proResponse1 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_ilumaResponse1 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_oneResponse1 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_primeResponse1 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_original_duoResponse1 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenLil_solidezResponse1 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;


            let question5SelectedIds = this.question5_1_Ploom.responses.filter(r => r.selected);
            let question5_glo_uniqSelectedIds = this.question5_1_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds = this.question5_1_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds = this.question5_1_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds = this.question5_1_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds = this.question5_1_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds = this.question5_1_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds = this.question5_1_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds = this.question5_1_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds = this.question5_1_lil_solidez.responses.filter(r => r.selected);

            let question5SelectedIds2 = this.question5_2_Ploom.responses.filter(r => r.selected); // daca a raspuns la 3 si are cu cat de des pe luna
            let question5_glo_uniqSelectedIds2 = this.question5_2_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds2 = this.question5_2_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds2 = this.question5_2_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds2 = this.question5_2_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds2 = this.question5_2_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds2 = this.question5_2_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds2 = this.question5_2_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds2 = this.question5_2_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds2 = this.question5_2_lil_solidez.responses.filter(r => r.selected);

            this.last_question_number_iqos_iluma_1 = this.question5_iqos_iluma.id;
            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1)) numberOfQuestionAnswered += 1;
            })

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1 || this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1 || this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1 || this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1 || this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1 || this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1 || this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1 || this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1 || this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1 || this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1 || this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloomResponse1 || hasChoosenPloomResponse2 || hasChoosenPloomResponse3) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_ilumaResponse1 || hasChoosenIqos_ilumaResponse2 || hasChoosenIqos_ilumaResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_oneResponse1 || hasChoosenIqos_iluma_oneResponse2 || hasChoosenIqos_iluma_oneResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_primeResponse1 || hasChoosenIqos_iluma_primeResponse2 || hasChoosenIqos_iluma_primeResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duoResponse1 || hasChoosenIqos_original_duoResponse2 || hasChoosenIqos_original_duoResponse3) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniqResponse1 || hasChoosenGlo_uniqResponse2 || hasChoosenGlo_uniqResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_airResponse1 || hasChoosenGlo_airResponse2 || hasChoosenGlo_airResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2Response1 || hasChoosenGlo_x2Response2 || hasChoosenGlo_x2Response3) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_proResponse1 || hasChoosenGlo_proResponse2 || hasChoosenGlo_proResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidezResponse1 || hasChoosenLil_solidezResponse2 || hasChoosenLil_solidezResponse3) hasChoosenOneOfFirstThree.push('Lil Solid EZ')

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Iluma One') && (question5_iqos_iluma_oneSelectedIds.length > 0 || question5_iqos_iluma_oneSelectedIds2.length > 0 || (hasChoosenIqos_iluma_oneResponse1 && selectedBrandsAtQuestion3.length == allquestionAnswered && hasChoosenPloom))) {
                this.render_question5_iqos_iluma_one = true;
                return true;
            } else {
                this.question5_iqos_iluma_one.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -iqos
        this.question5_iqos_iluma_prime = new Question(37, [this.question5_1_iqos_iluma_prime.id],
            'De cât timp folosești IQOS Iluma Prime?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question5_iqos_iluma_prime.render = () => {
            if (this.endgame == true) { return false; }

            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question5_iqos_iluma_prime.responses = this.question5_iqos_iluma_prime.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            let hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3


            const hasChoosenPloomResponse3 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_uniqResponse3 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_airResponse3 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_x2Response3 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_proResponse3 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_ilumaResponse3 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_oneResponse3 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_primeResponse3 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_original_duoResponse3 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenLil_solidezResponse3 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;



            const hasChoosenPloomResponse2 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_uniqResponse2 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_airResponse2 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_x2Response2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_proResponse2 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_ilumaResponse2 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_oneResponse2 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_primeResponse2 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_original_duoResponse2 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenLil_solidezResponse2 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;



            const hasChoosenPloomResponse1 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_uniqResponse1 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_airResponse1 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_x2Response1 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_proResponse1 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_ilumaResponse1 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_oneResponse1 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_primeResponse1 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_original_duoResponse1 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenLil_solidezResponse1 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;


            let question5SelectedIds = this.question5_1_Ploom.responses.filter(r => r.selected);
            let question5_glo_uniqSelectedIds = this.question5_1_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds = this.question5_1_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds = this.question5_1_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds = this.question5_1_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds = this.question5_1_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds = this.question5_1_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds = this.question5_1_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds = this.question5_1_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds = this.question5_1_lil_solidez.responses.filter(r => r.selected);

            let question5SelectedIds2 = this.question5_2_Ploom.responses.filter(r => r.selected); // daca a raspuns la 3 si are cu cat de des pe luna
            let question5_glo_uniqSelectedIds2 = this.question5_2_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds2 = this.question5_2_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds2 = this.question5_2_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds2 = this.question5_2_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds2 = this.question5_2_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds2 = this.question5_2_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds2 = this.question5_2_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds2 = this.question5_2_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds2 = this.question5_2_lil_solidez.responses.filter(r => r.selected);

            this.last_question_number_iqos_iluma_1 = this.question5_iqos_iluma.id;
            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1)) numberOfQuestionAnswered += 1;
            })


            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1 || this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1 || this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1 || this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1 || this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1 || this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1 || this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1 || this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1 || this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1 || this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1 || this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloomResponse1 || hasChoosenPloomResponse2 || hasChoosenPloomResponse3) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_ilumaResponse1 || hasChoosenIqos_ilumaResponse2 || hasChoosenIqos_ilumaResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_oneResponse1 || hasChoosenIqos_iluma_oneResponse2 || hasChoosenIqos_iluma_oneResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_primeResponse1 || hasChoosenIqos_iluma_primeResponse2 || hasChoosenIqos_iluma_primeResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duoResponse1 || hasChoosenIqos_original_duoResponse2 || hasChoosenIqos_original_duoResponse3) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniqResponse1 || hasChoosenGlo_uniqResponse2 || hasChoosenGlo_uniqResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_airResponse1 || hasChoosenGlo_airResponse2 || hasChoosenGlo_airResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2Response1 || hasChoosenGlo_x2Response2 || hasChoosenGlo_x2Response3) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_proResponse1 || hasChoosenGlo_proResponse2 || hasChoosenGlo_proResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidezResponse1 || hasChoosenLil_solidezResponse2 || hasChoosenLil_solidezResponse3) hasChoosenOneOfFirstThree.push('Lil Solid EZ')

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Iluma Prime') && (question5_iqos_iluma_primeSelectedIds.length > 0 || question5_iqos_iluma_primeSelectedIds2.length > 0 || (hasChoosenIqos_iluma_primeResponse1 && selectedBrandsAtQuestion3.length == allquestionAnswered && hasChoosenPloom))) {
                this.render_question5_iqos_iluma_prime = true;
                return true;
            } else {
                this.question5_iqos_iluma_prime.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //c -iqos
        this.question5_iqos_iluma_original_duo = new Question(38, [this.question5_1_iqos_iluma_original_duo.id],
            'De cât timp folosești IQOS Original Duo?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question5_iqos_iluma_original_duo.render = () => {
            if (this.endgame == true) { return false; }
            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question5_iqos_iluma_original_duo.responses = this.question5_iqos_iluma_original_duo.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            let hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3


            const hasChoosenPloomResponse3 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_uniqResponse3 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_airResponse3 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_x2Response3 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_proResponse3 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_ilumaResponse3 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_oneResponse3 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_primeResponse3 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_original_duoResponse3 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenLil_solidezResponse3 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;



            const hasChoosenPloomResponse2 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_uniqResponse2 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_airResponse2 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_x2Response2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_proResponse2 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_ilumaResponse2 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_oneResponse2 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_primeResponse2 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_original_duoResponse2 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenLil_solidezResponse2 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;



            const hasChoosenPloomResponse1 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_uniqResponse1 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_airResponse1 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_x2Response1 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_proResponse1 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_ilumaResponse1 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_oneResponse1 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_primeResponse1 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_original_duoResponse1 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenLil_solidezResponse1 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;


            let question5SelectedIds = this.question5_1_Ploom.responses.filter(r => r.selected);
            let question5_glo_uniqSelectedIds = this.question5_1_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds = this.question5_1_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds = this.question5_1_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds = this.question5_1_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds = this.question5_1_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds = this.question5_1_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds = this.question5_1_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds = this.question5_1_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds = this.question5_1_lil_solidez.responses.filter(r => r.selected);

            let question5SelectedIds2 = this.question5_2_Ploom.responses.filter(r => r.selected); // daca a raspuns la 3 si are cu cat de des pe luna
            let question5_glo_uniqSelectedIds2 = this.question5_2_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds2 = this.question5_2_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds2 = this.question5_2_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds2 = this.question5_2_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds2 = this.question5_2_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds2 = this.question5_2_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds2 = this.question5_2_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds2 = this.question5_2_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds2 = this.question5_2_lil_solidez.responses.filter(r => r.selected);

            this.last_question_number_iqos_iluma_1 = this.question5_iqos_iluma.id;
            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1)) numberOfQuestionAnswered += 1;
            })

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1 || this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1 || this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1 || this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1 || this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1 || this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1 || this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1 || this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1 || this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1 || this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1 || this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloomResponse1 || hasChoosenPloomResponse2 || hasChoosenPloomResponse3) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_ilumaResponse1 || hasChoosenIqos_ilumaResponse2 || hasChoosenIqos_ilumaResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_oneResponse1 || hasChoosenIqos_iluma_oneResponse2 || hasChoosenIqos_iluma_oneResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_primeResponse1 || hasChoosenIqos_iluma_primeResponse2 || hasChoosenIqos_iluma_primeResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duoResponse1 || hasChoosenIqos_original_duoResponse2 || hasChoosenIqos_original_duoResponse3) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniqResponse1 || hasChoosenGlo_uniqResponse2 || hasChoosenGlo_uniqResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_airResponse1 || hasChoosenGlo_airResponse2 || hasChoosenGlo_airResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2Response1 || hasChoosenGlo_x2Response2 || hasChoosenGlo_x2Response3) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_proResponse1 || hasChoosenGlo_proResponse2 || hasChoosenGlo_proResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidezResponse1 || hasChoosenLil_solidezResponse2 || hasChoosenLil_solidezResponse3) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('IQOS Original Duo') && (question5_iqos_iluma_duoSelectedIds.length > 0 || question5_iqos_iluma_duoSelectedIds2.length > 0 || (hasChoosenIqos_original_duoResponse1 && selectedBrandsAtQuestion3.length == allquestionAnswered && hasChoosenPloom))) {
                this.render_question5_iqos_iluma_original_duo = true;
                return true;
            } else {
                this.question5_iqos_iluma_original_duo.responses.forEach(r => {
                    r.selected = false;
                });
            }

            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //a -ploom
        this.question5 = new Question(39, [this.question5_1_Ploom.id],
            'De cât timp folosești Ploom?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question5.render = () => {
            if (this.endgame == true) { return false; }


            // Data lansării Ploom
            const ploomLaunchDate = moment('2023-10-23'); // 02 octombrie 2023
            const currentDate = moment(); // Data curentă

            // Calculăm diferența în luni și ani de la lansare până la data curentă
            const monthsSinceLaunch = currentDate.diff(ploomLaunchDate, 'months', true); // Diferența în luni
            const yearsSinceLaunch = currentDate.diff(ploomLaunchDate, 'years', true); // Diferența în ani

            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Funcție pentru a obține răspunsuri relevante pe baza lansării și vârstei utilizatorului
            const getRelevantResponses = (monthsSinceLaunch: number, yearsSinceLegalSmoking: number) => {
                let maxYearsUsage = Math.min(yearsSinceLaunch, yearsSinceLegalSmoking); // Maximul de ani de utilizare posibil

                if (maxYearsUsage < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5];
                } else if (maxYearsUsage < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5];
                } else if (maxYearsUsage < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6];
                } else if (maxYearsUsage < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7];
                } else if (maxYearsUsage < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8];
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9];
                }
            };

            // Obținem lista de ID-uri relevante bazată pe combinația de criterii
            const relevantResponseIds = getRelevantResponses(monthsSinceLaunch, yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question5.responses = this.question5.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );

            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3

            const hasChoosenPloomResponse3 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_uniqResponse3 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_airResponse3 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_x2Response3 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_proResponse3 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_ilumaResponse3 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_oneResponse3 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_primeResponse3 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_original_duoResponse3 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenLil_solidezResponse3 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;



            const hasChoosenPloomResponse2 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_uniqResponse2 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_airResponse2 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_x2Response2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_proResponse2 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_ilumaResponse2 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_oneResponse2 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_primeResponse2 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_original_duoResponse2 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenLil_solidezResponse2 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;



            const hasChoosenPloomResponse1 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_uniqResponse1 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_airResponse1 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_x2Response1 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_proResponse1 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_ilumaResponse1 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_oneResponse1 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_primeResponse1 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_original_duoResponse1 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenLil_solidezResponse1 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;


            let question5SelectedIds = this.question5_1_Ploom.responses.filter(r => r.selected);
            let question5_glo_uniqSelectedIds = this.question5_1_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds = this.question5_1_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds = this.question5_1_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds = this.question5_1_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds = this.question5_1_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds = this.question5_1_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds = this.question5_1_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds = this.question5_1_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds = this.question5_1_lil_solidez.responses.filter(r => r.selected);

            let question5SelectedIds2 = this.question5_2_Ploom.responses.filter(r => r.selected); // daca a raspuns la 3 si are cu cat de des pe luna
            let question5_glo_uniqSelectedIds2 = this.question5_2_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds2 = this.question5_2_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds2 = this.question5_2_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds2 = this.question5_2_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds2 = this.question5_2_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds2 = this.question5_2_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds2 = this.question5_2_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds2 = this.question5_2_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds2 = this.question5_2_lil_solidez.responses.filter(r => r.selected);

            this.last_question_number_iqos_iluma_1 = this.question5_iqos_iluma.id;
            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1)) numberOfQuestionAnswered += 1;
            })

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1 || this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1 || this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1 || this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1 || this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1 || this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1 || this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1 || this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1 || this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1 || this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1 || this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloomResponse1 || hasChoosenPloomResponse2 || hasChoosenPloomResponse3) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_ilumaResponse1 || hasChoosenIqos_ilumaResponse2 || hasChoosenIqos_ilumaResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_oneResponse1 || hasChoosenIqos_iluma_oneResponse2 || hasChoosenIqos_iluma_oneResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_primeResponse1 || hasChoosenIqos_iluma_primeResponse2 || hasChoosenIqos_iluma_primeResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duoResponse1 || hasChoosenIqos_original_duoResponse2 || hasChoosenIqos_original_duoResponse3) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniqResponse1 || hasChoosenGlo_uniqResponse2 || hasChoosenGlo_uniqResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_airResponse1 || hasChoosenGlo_airResponse2 || hasChoosenGlo_airResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2Response1 || hasChoosenGlo_x2Response2 || hasChoosenGlo_x2Response3) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_proResponse1 || hasChoosenGlo_proResponse2 || hasChoosenGlo_proResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidezResponse1 || hasChoosenLil_solidezResponse2 || hasChoosenLil_solidezResponse3) hasChoosenOneOfFirstThree.push('Lil Solid EZ')

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Ploom') && (question5SelectedIds.length > 0 || question5SelectedIds2.length > 0 || (hasChoosenPloomResponse1 && selectedBrandsAtQuestion3.length == allquestionAnswered && hasChoosenPloom))) {

                return true;
            }

            else {
                this.question5.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //b -glo
        this.question5_glo_uniq = new Question(40, [this.question5_1_glo_uniq.id],
            'De cât timp folosești Glo Hyper + uniq?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question5_glo_uniq.render = () => {
            if (this.endgame == true) { return false; }

            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question5_glo_uniq.responses = this.question5_glo_uniq.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );

            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            let hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3


            const hasChoosenPloomResponse3 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_uniqResponse3 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_airResponse3 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_x2Response3 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_proResponse3 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_ilumaResponse3 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_oneResponse3 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_primeResponse3 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_original_duoResponse3 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenLil_solidezResponse3 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;



            const hasChoosenPloomResponse2 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_uniqResponse2 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_airResponse2 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_x2Response2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_proResponse2 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_ilumaResponse2 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_oneResponse2 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_primeResponse2 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_original_duoResponse2 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenLil_solidezResponse2 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;



            const hasChoosenPloomResponse1 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_uniqResponse1 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_airResponse1 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_x2Response1 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_proResponse1 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_ilumaResponse1 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_oneResponse1 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_primeResponse1 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_original_duoResponse1 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenLil_solidezResponse1 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;


            let question5SelectedIds = this.question5_1_Ploom.responses.filter(r => r.selected);
            let question5_glo_uniqSelectedIds = this.question5_1_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds = this.question5_1_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds = this.question5_1_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds = this.question5_1_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds = this.question5_1_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds = this.question5_1_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds = this.question5_1_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds = this.question5_1_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds = this.question5_1_lil_solidez.responses.filter(r => r.selected);

            let question5SelectedIds2 = this.question5_2_Ploom.responses.filter(r => r.selected); // daca a raspuns la 3 si are cu cat de des pe luna
            let question5_glo_uniqSelectedIds2 = this.question5_2_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds2 = this.question5_2_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds2 = this.question5_2_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds2 = this.question5_2_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds2 = this.question5_2_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds2 = this.question5_2_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds2 = this.question5_2_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds2 = this.question5_2_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds2 = this.question5_2_lil_solidez.responses.filter(r => r.selected);

            this.last_question_number_iqos_iluma_1 = this.question5_iqos_iluma.id;
            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1)) numberOfQuestionAnswered += 1;
            })

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1 || this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1 || this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1 || this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1 || this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1 || this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1 || this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1 || this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1 || this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1 || this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1 || this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloomResponse1 || hasChoosenPloomResponse2 || hasChoosenPloomResponse3) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_ilumaResponse1 || hasChoosenIqos_ilumaResponse2 || hasChoosenIqos_ilumaResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_oneResponse1 || hasChoosenIqos_iluma_oneResponse2 || hasChoosenIqos_iluma_oneResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_primeResponse1 || hasChoosenIqos_iluma_primeResponse2 || hasChoosenIqos_iluma_primeResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duoResponse1 || hasChoosenIqos_original_duoResponse2 || hasChoosenIqos_original_duoResponse3) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniqResponse1 || hasChoosenGlo_uniqResponse2 || hasChoosenGlo_uniqResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_airResponse1 || hasChoosenGlo_airResponse2 || hasChoosenGlo_airResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2Response1 || hasChoosenGlo_x2Response2 || hasChoosenGlo_x2Response3) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_proResponse1 || hasChoosenGlo_proResponse2 || hasChoosenGlo_proResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidezResponse1 || hasChoosenLil_solidezResponse2 || hasChoosenLil_solidezResponse3) hasChoosenOneOfFirstThree.push('Lil Solid EZ')

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper + uniq') && (question5_glo_uniqSelectedIds.length > 0 || question5_glo_uniqSelectedIds2.length > 0 || (hasChoosenGlo_uniqResponse1 && selectedBrandsAtQuestion3.length == allquestionAnswered && hasChoosenPloom))) {
                return true;

            } else {
                this.question5_glo_uniq.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //b -glo
        this.question5_glo_air = new Question(41, [this.question5_1_glo_air.id],
            'De cât timp folosești Glo Hyper X2 Air?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question5_glo_air.render = () => {
            if (this.endgame == true) { return false; }

            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question5_glo_air.responses = this.question5_glo_air.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );

            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            let hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3


            const hasChoosenPloomResponse3 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_uniqResponse3 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_airResponse3 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_x2Response3 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_proResponse3 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_ilumaResponse3 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_oneResponse3 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_primeResponse3 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_original_duoResponse3 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenLil_solidezResponse3 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;



            const hasChoosenPloomResponse2 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_uniqResponse2 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_airResponse2 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_x2Response2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_proResponse2 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_ilumaResponse2 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_oneResponse2 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_primeResponse2 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_original_duoResponse2 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenLil_solidezResponse2 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;



            const hasChoosenPloomResponse1 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_uniqResponse1 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_airResponse1 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_x2Response1 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_proResponse1 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_ilumaResponse1 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_oneResponse1 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_primeResponse1 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_original_duoResponse1 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenLil_solidezResponse1 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;


            let question5SelectedIds = this.question5_1_Ploom.responses.filter(r => r.selected);
            let question5_glo_uniqSelectedIds = this.question5_1_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds = this.question5_1_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds = this.question5_1_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds = this.question5_1_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds = this.question5_1_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds = this.question5_1_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds = this.question5_1_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds = this.question5_1_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds = this.question5_1_lil_solidez.responses.filter(r => r.selected);

            let question5SelectedIds2 = this.question5_2_Ploom.responses.filter(r => r.selected); // daca a raspuns la 3 si are cu cat de des pe luna
            let question5_glo_uniqSelectedIds2 = this.question5_2_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds2 = this.question5_2_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds2 = this.question5_2_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds2 = this.question5_2_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds2 = this.question5_2_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds2 = this.question5_2_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds2 = this.question5_2_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds2 = this.question5_2_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds2 = this.question5_2_lil_solidez.responses.filter(r => r.selected);

            this.last_question_number_iqos_iluma_1 = this.question5_iqos_iluma.id;
            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1)) numberOfQuestionAnswered += 1;
            })

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1 || this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1 || this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1 || this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1 || this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1 || this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1 || this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1 || this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1 || this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1 || this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1 || this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloomResponse1 || hasChoosenPloomResponse2 || hasChoosenPloomResponse3) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_ilumaResponse1 || hasChoosenIqos_ilumaResponse2 || hasChoosenIqos_ilumaResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_oneResponse1 || hasChoosenIqos_iluma_oneResponse2 || hasChoosenIqos_iluma_oneResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_primeResponse1 || hasChoosenIqos_iluma_primeResponse2 || hasChoosenIqos_iluma_primeResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duoResponse1 || hasChoosenIqos_original_duoResponse2 || hasChoosenIqos_original_duoResponse3) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniqResponse1 || hasChoosenGlo_uniqResponse2 || hasChoosenGlo_uniqResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_airResponse1 || hasChoosenGlo_airResponse2 || hasChoosenGlo_airResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2Response1 || hasChoosenGlo_x2Response2 || hasChoosenGlo_x2Response3) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_proResponse1 || hasChoosenGlo_proResponse2 || hasChoosenGlo_proResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidezResponse1 || hasChoosenLil_solidezResponse2 || hasChoosenLil_solidezResponse3) hasChoosenOneOfFirstThree.push('Lil Solid EZ')

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper X2 Air') && (question5_glo_x2_airSelectedIds.length > 0 || question5_glo_x2_airSelectedIds2.length > 0 || (hasChoosenGlo_airResponse1 && selectedBrandsAtQuestion3.length == allquestionAnswered && hasChoosenPloom))) {
                this.render_question5_glo_air = true;
                return true;
            } else {
                this.question5_glo_air.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        // (1.3) HT DEVICE USAGE DURATION
        //b -glo
        this.question5_glo_x2 = new Question(42, [this.question5_1_glo_x2.id],
            'De cât timp folosești Glo Hyper X2?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question5_glo_x2.render = () => {
            if (this.endgame == true) { return false; }

            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question5_glo_x2.responses = this.question5_glo_x2.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );

            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            let hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3


            const hasChoosenPloomResponse3 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_uniqResponse3 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_airResponse3 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_x2Response3 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_proResponse3 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_ilumaResponse3 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_oneResponse3 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_primeResponse3 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_original_duoResponse3 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenLil_solidezResponse3 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;



            const hasChoosenPloomResponse2 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_uniqResponse2 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_airResponse2 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_x2Response2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_proResponse2 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_ilumaResponse2 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_oneResponse2 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_primeResponse2 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_original_duoResponse2 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenLil_solidezResponse2 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;



            const hasChoosenPloomResponse1 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_uniqResponse1 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_airResponse1 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_x2Response1 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_proResponse1 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_ilumaResponse1 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_oneResponse1 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_primeResponse1 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_original_duoResponse1 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenLil_solidezResponse1 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;


            let question5SelectedIds = this.question5_1_Ploom.responses.filter(r => r.selected);
            let question5_glo_uniqSelectedIds = this.question5_1_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds = this.question5_1_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds = this.question5_1_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds = this.question5_1_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds = this.question5_1_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds = this.question5_1_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds = this.question5_1_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds = this.question5_1_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds = this.question5_1_lil_solidez.responses.filter(r => r.selected);

            let question5SelectedIds2 = this.question5_2_Ploom.responses.filter(r => r.selected); // daca a raspuns la 3 si are cu cat de des pe luna
            let question5_glo_uniqSelectedIds2 = this.question5_2_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds2 = this.question5_2_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds2 = this.question5_2_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds2 = this.question5_2_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds2 = this.question5_2_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds2 = this.question5_2_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds2 = this.question5_2_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds2 = this.question5_2_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds2 = this.question5_2_lil_solidez.responses.filter(r => r.selected);

            this.last_question_number_iqos_iluma_1 = this.question5_iqos_iluma.id;
            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1)) numberOfQuestionAnswered += 1;
            })


            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1 || this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1 || this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1 || this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1 || this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1 || this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1 || this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1 || this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1 || this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1 || this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1 || this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloomResponse1 || hasChoosenPloomResponse2 || hasChoosenPloomResponse3) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_ilumaResponse1 || hasChoosenIqos_ilumaResponse2 || hasChoosenIqos_ilumaResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_oneResponse1 || hasChoosenIqos_iluma_oneResponse2 || hasChoosenIqos_iluma_oneResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_primeResponse1 || hasChoosenIqos_iluma_primeResponse2 || hasChoosenIqos_iluma_primeResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duoResponse1 || hasChoosenIqos_original_duoResponse2 || hasChoosenIqos_original_duoResponse3) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniqResponse1 || hasChoosenGlo_uniqResponse2 || hasChoosenGlo_uniqResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_airResponse1 || hasChoosenGlo_airResponse2 || hasChoosenGlo_airResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2Response1 || hasChoosenGlo_x2Response2 || hasChoosenGlo_x2Response3) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_proResponse1 || hasChoosenGlo_proResponse2 || hasChoosenGlo_proResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidezResponse1 || hasChoosenLil_solidezResponse2 || hasChoosenLil_solidezResponse3) hasChoosenOneOfFirstThree.push('Lil Solid EZ')

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper X2') && (question5_glo_x2SelectedIds.length > 0 || question5_glo_x2SelectedIds2.length > 0 || (hasChoosenGlo_x2Response1 && selectedBrandsAtQuestion3.length == allquestionAnswered && hasChoosenPloom))) {
                this.render_question5_glo_x2 = true;
                return true;
            } else {
                this.question5_glo_x2.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.3) HT DEVICE USAGE DURATION
        //b -glo
        this.question5_glo_pro = new Question(43, [this.question5_1_glo_pro.id],
            'De cât timp folosești Glo Hyper Pro?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question5_glo_pro.render = () => {
            if (this.endgame == true) { return false; }
            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question5_glo_pro.responses = this.question5_glo_pro.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            let hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3



            const hasChoosenPloomResponse3 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_uniqResponse3 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_airResponse3 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_x2Response3 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_proResponse3 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_ilumaResponse3 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_oneResponse3 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_primeResponse3 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_original_duoResponse3 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenLil_solidezResponse3 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;



            const hasChoosenPloomResponse2 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_uniqResponse2 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_airResponse2 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_x2Response2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_proResponse2 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_ilumaResponse2 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_oneResponse2 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_primeResponse2 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_original_duoResponse2 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenLil_solidezResponse2 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;



            const hasChoosenPloomResponse1 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_uniqResponse1 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_airResponse1 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_x2Response1 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_proResponse1 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_ilumaResponse1 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_oneResponse1 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_primeResponse1 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_original_duoResponse1 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenLil_solidezResponse1 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;


            let question5SelectedIds = this.question5_1_Ploom.responses.filter(r => r.selected);
            let question5_glo_uniqSelectedIds = this.question5_1_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds = this.question5_1_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds = this.question5_1_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds = this.question5_1_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds = this.question5_1_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds = this.question5_1_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds = this.question5_1_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds = this.question5_1_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds = this.question5_1_lil_solidez.responses.filter(r => r.selected);

            let question5SelectedIds2 = this.question5_2_Ploom.responses.filter(r => r.selected); // daca a raspuns la 3 si are cu cat de des pe luna
            let question5_glo_uniqSelectedIds2 = this.question5_2_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds2 = this.question5_2_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds2 = this.question5_2_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds2 = this.question5_2_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds2 = this.question5_2_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds2 = this.question5_2_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds2 = this.question5_2_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds2 = this.question5_2_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds2 = this.question5_2_lil_solidez.responses.filter(r => r.selected);

            this.last_question_number_iqos_iluma_1 = this.question5_iqos_iluma.id;
            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1)) numberOfQuestionAnswered += 1;
            })

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1 || this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1 || this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1 || this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1 || this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1 || this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1 || this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1 || this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1 || this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1 || this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1 || this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloomResponse1 || hasChoosenPloomResponse2 || hasChoosenPloomResponse3) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_ilumaResponse1 || hasChoosenIqos_ilumaResponse2 || hasChoosenIqos_ilumaResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_oneResponse1 || hasChoosenIqos_iluma_oneResponse2 || hasChoosenIqos_iluma_oneResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_primeResponse1 || hasChoosenIqos_iluma_primeResponse2 || hasChoosenIqos_iluma_primeResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duoResponse1 || hasChoosenIqos_original_duoResponse2 || hasChoosenIqos_original_duoResponse3) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniqResponse1 || hasChoosenGlo_uniqResponse2 || hasChoosenGlo_uniqResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_airResponse1 || hasChoosenGlo_airResponse2 || hasChoosenGlo_airResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2Response1 || hasChoosenGlo_x2Response2 || hasChoosenGlo_x2Response3) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_proResponse1 || hasChoosenGlo_proResponse2 || hasChoosenGlo_proResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidezResponse1 || hasChoosenLil_solidezResponse2 || hasChoosenLil_solidezResponse3) hasChoosenOneOfFirstThree.push('Lil Solid EZ')

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Glo Hyper Pro') && (question5_glo_proSelectedIds.length > 0 || question5_glo_proSelectedIds2.length > 0 || (hasChoosenGlo_proResponse1 && selectedBrandsAtQuestion3.length == allquestionAnswered && hasChoosenPloom))) {
                this.render_question5_glo_pro = true;
                return true;
            } else {
                this.question5_glo_pro.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }




        // (1.3) HT DEVICE USAGE DURATION
        //d -lil
        this.question5_lil_solidez = new Question(44, [this.question5_1_lil_solidez.id],
            'De cât timp folosești Lil Solid EZ?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question5_lil_solidez.render = () => {
            if (this.endgame == true) { return false; }
            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question5_lil_solidez.responses = this.question5_lil_solidez.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3

            const hasChoosenPloomResponse3 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_uniqResponse3 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_airResponse3 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_x2Response3 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenGlo_proResponse3 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_ilumaResponse3 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_oneResponse3 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_iluma_primeResponse3 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenIqos_original_duoResponse3 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosenLil_solidezResponse3 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;



            const hasChoosenPloomResponse2 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_uniqResponse2 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_airResponse2 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_x2Response2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenGlo_proResponse2 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_ilumaResponse2 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_oneResponse2 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_iluma_primeResponse2 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenIqos_original_duoResponse2 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosenLil_solidezResponse2 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;



            const hasChoosenPloomResponse1 = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_uniqResponse1 = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_airResponse1 = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_x2Response1 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenGlo_proResponse1 = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_ilumaResponse1 = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_oneResponse1 = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_iluma_primeResponse1 = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenIqos_original_duoResponse1 = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosenLil_solidezResponse1 = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;


            let question5SelectedIds = this.question5_1_Ploom.responses.filter(r => r.selected);
            let question5_glo_uniqSelectedIds = this.question5_1_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds = this.question5_1_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds = this.question5_1_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds = this.question5_1_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds = this.question5_1_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds = this.question5_1_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds = this.question5_1_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds = this.question5_1_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds = this.question5_1_lil_solidez.responses.filter(r => r.selected);

            let question5SelectedIds2 = this.question5_2_Ploom.responses.filter(r => r.selected); // daca a raspuns la 3 si are cu cat de des pe luna
            let question5_glo_uniqSelectedIds2 = this.question5_2_glo_uniq.responses.filter(r => r.selected);
            let question5_glo_x2_airSelectedIds2 = this.question5_2_glo_air.responses.filter(r => r.selected);
            let question5_glo_x2SelectedIds2 = this.question5_2_glo_x2.responses.filter(r => r.selected);
            let question5_glo_proSelectedIds2 = this.question5_2_glo_pro.responses.filter(r => r.selected);
            let question5_iqos_ilumaSelectedIds2 = this.question5_2_iqos_iluma.responses.filter(r => r.selected);
            let question5_iqos_iluma_oneSelectedIds2 = this.question5_2_iqos_iluma_one.responses.filter(r => r.selected);
            let question5_iqos_iluma_primeSelectedIds2 = this.question5_2_iqos_iluma_prime.responses.filter(r => r.selected);
            let question5_iqos_iluma_duoSelectedIds2 = this.question5_2_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question5lil_solidezSelectedIds2 = this.question5_2_lil_solidez.responses.filter(r => r.selected);

            this.last_question_number_iqos_iluma_1 = this.question5_iqos_iluma.id;
            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1)) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1)) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1)) numberOfQuestionAnswered += 1;
            })


            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && ((hasChoosenPloomResponse2 && question5SelectedIds.length != 0) || (hasChoosenPloomResponse3 && question5SelectedIds2.length != 0) || hasChoosenPloomResponse1 || this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma' && ((hasChoosenIqos_ilumaResponse2 && question5_iqos_ilumaSelectedIds.length != 0) || (hasChoosenIqos_ilumaResponse3 && question5_iqos_ilumaSelectedIds2.length != 0) || hasChoosenIqos_ilumaResponse1 || this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && ((hasChoosenIqos_iluma_oneResponse2 && question5_iqos_iluma_oneSelectedIds.length != 0) || (hasChoosenIqos_iluma_oneResponse3 && question5_iqos_iluma_oneSelectedIds2.length != 0) || hasChoosenIqos_iluma_oneResponse1 || this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && ((hasChoosenIqos_iluma_primeResponse2 && question5_iqos_iluma_primeSelectedIds.length != 0) || (hasChoosenIqos_iluma_primeResponse3 && question5_iqos_iluma_primeSelectedIds2.length != 0) || hasChoosenIqos_iluma_primeResponse1 || this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && ((hasChoosenIqos_original_duoResponse2 && question5_iqos_iluma_duoSelectedIds.length != 0) || (hasChoosenIqos_original_duoResponse3 && question5_iqos_iluma_duoSelectedIds2.length != 0) || hasChoosenIqos_original_duoResponse1 || this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && ((hasChoosenGlo_uniqResponse2 && question5_glo_uniqSelectedIds.length != 0) || (hasChoosenGlo_uniqResponse3 && question5_glo_uniqSelectedIds2.length != 0) || hasChoosenGlo_uniqResponse1 || this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && ((hasChoosenGlo_airResponse2 && question5_glo_x2_airSelectedIds.length != 0) || (hasChoosenGlo_airResponse3 && question5_glo_x2_airSelectedIds2.length != 0) || hasChoosenGlo_airResponse1 || this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && ((hasChoosenGlo_x2Response2 && question5_glo_x2SelectedIds.length != 0) || (hasChoosenGlo_x2Response3 && question5_glo_x2SelectedIds2.length != 0) || hasChoosenGlo_x2Response1 || this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && ((hasChoosenGlo_proResponse2 && question5_glo_proSelectedIds.length != 0) || (hasChoosenGlo_proResponse3 && question5_glo_proSelectedIds2.length != 0) || hasChoosenGlo_proResponse1 || this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && ((hasChoosenLil_solidezResponse2 && question5lil_solidezSelectedIds.length != 0) || (hasChoosenLil_solidezResponse3 && question5lil_solidezSelectedIds2.length != 0) || hasChoosenLil_solidezResponse1 || this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloomResponse1 || hasChoosenPloomResponse2 || hasChoosenPloomResponse3) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_ilumaResponse1 || hasChoosenIqos_ilumaResponse2 || hasChoosenIqos_ilumaResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_oneResponse1 || hasChoosenIqos_iluma_oneResponse2 || hasChoosenIqos_iluma_oneResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_primeResponse1 || hasChoosenIqos_iluma_primeResponse2 || hasChoosenIqos_iluma_primeResponse3) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duoResponse1 || hasChoosenIqos_original_duoResponse2 || hasChoosenIqos_original_duoResponse3) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniqResponse1 || hasChoosenGlo_uniqResponse2 || hasChoosenGlo_uniqResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_airResponse1 || hasChoosenGlo_airResponse2 || hasChoosenGlo_airResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2Response1 || hasChoosenGlo_x2Response2 || hasChoosenGlo_x2Response3) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_proResponse1 || hasChoosenGlo_proResponse2 || hasChoosenGlo_proResponse3) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidezResponse1 || hasChoosenLil_solidezResponse2 || hasChoosenLil_solidezResponse3) hasChoosenOneOfFirstThree.push('Lil Solid EZ')

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;
            // console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^');
            // console.log('numberOfQuestionAnswered:', numberOfQuestionAnswered)
            // console.log('hasChoosenOneOfFirstThree.length:', hasChoosenOneOfFirstThree.length)

            // console.log('yeyyyyyyyyyyyyy:', hasAnsweredAllQuestionsBeforeShowingThis)
            if (hasAnsweredAllQuestionsBeforeShowingThis && question3SelectedIds.includes('Lil Solid EZ') && (question5lil_solidezSelectedIds.length > 0 || question5lil_solidezSelectedIds2.length > 0 || (hasChoosenLil_solidezResponse1 && selectedBrandsAtQuestion3.length == allquestionAnswered && hasChoosenPloom))) {
                // this.render_question5_lil_solidez = true;
                return true;
            } else {
                this.question5_lil_solidez.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.4) HT DEVICE P7D USAGE (RETENTION)
        this.question6 = new Question(45, [4],
            'Pe care dintre următoarele le-ai folosit în ultimele 7 zile?',
            '',
            'checkbox',
            [new Response(1, 'IQOS Iluma', [], './assets/images/iluma.png'),
            new Response(2, 'IQOS Iluma One', [], './assets/images/iluma_one.png'),
            new Response(3, 'IQOS Iluma Prime', [], './assets/images/iluma_prime.png'),
            new Response(4, 'IQOS Original Duo', [], './assets/images/original_duo.png'),
            new Response(5, 'Ploom', [], './assets/images/ploomx.png'),
            new Response(6, 'Glo Hyper + uniq', [], './assets/images/glo_hyper_uniq.png'),
            new Response(7, 'Glo Hyper X2 Air', [], './assets/images/hyperx2_air.png'),
            new Response(8, 'Glo Hyper X2 ', [], './assets/images/hyperx2.png'),
            new Response(9, 'Glo Hyper Pro', [], './assets/images/hyper_pro.png'),
            new Response(10, 'Lil Solid EZ', [], './assets/images/lil_solidez.png'),
            ],
            false,
            'vertical',
            '',
            1,
            false

        );


        this.question6.render = () => {
            if (this.endgame == true) { return false; }
            const selectedIdsPloomQuestion5 = this.question5.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion5_uniq = this.question5_glo_uniq.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion5_air = this.question5_glo_air.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion5_x2 = this.question5_glo_x2.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion5_pro = this.question5_glo_pro.responses?.filter(resp => resp?.selected);
            const selectedIdsiQuestion5_iluma = this.question5_iqos_iluma.responses?.filter(resp => resp?.selected);
            const selectedIdsiQuestion5_one = this.question5_iqos_iluma_one.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion5_prime = this.question5_iqos_iluma_prime.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion5_duo = this.question5_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion5_lil_solidez = this.question5_lil_solidez.responses?.filter(resp => resp?.selected);

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;


            let rendererPloomX = (rsp: Response): boolean => {
                return hasChoosenPloom;
            }

            let rendererGlo_uniq = (rsp: Response): boolean => {
                return hasChoosenGlo_uniq;
            }
            let rendererGlo_air = (rsp: Response): boolean => {
                return hasChoosenGlo_air;

            }
            let rendererGlo_x2 = (rsp: Response): boolean => {
                return hasChoosenGlo_x2;

            }
            let rendererGlo_pro = (rsp: Response): boolean => {
                return hasChoosenGlo_pro;
            }

            let rendererIqos_iluma = (rsp: Response): boolean => {
                return hasChoosenIqos_iluma;
            }

            let rendererIqos_iluma_one = (rsp: Response): boolean => {
                return hasChoosenIqos_iluma_one;
            }
            let rendererIqos_iluma_prime = (rsp: Response): boolean => {
                return hasChoosenIqos_iluma_prime;
            }
            let rendererIqos_original_duo = (rsp: Response): boolean => {
                return hasChoosenIqos_original_duo;
            }

            let rendererLil_solidez = (rsp: Response): boolean => {
                return hasChoosenLil_solidez;
            }

            this.question6.responses[0].render = rendererIqos_iluma;
            this.question6.responses[1].render = rendererIqos_iluma_one;
            this.question6.responses[2].render = rendererIqos_iluma_prime;
            this.question6.responses[3].render = rendererIqos_original_duo;
            this.question6.responses[4].render = rendererPloomX;
            this.question6.responses[5].render = rendererGlo_uniq;
            this.question6.responses[6].render = rendererGlo_air;
            this.question6.responses[7].render = rendererGlo_x2;
            this.question6.responses[8].render = rendererGlo_pro;
            this.question6.responses[9].render = rendererLil_solidez;

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && hasChoosenPloom && selectedIdsPloomQuestion5.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && selectedIdsiQuestion5_iluma.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && selectedIdsiQuestion5_one.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && selectedIdsQuestion5_prime.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && selectedIdsQuestion5_duo.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && selectedIdsQuestion5_uniq.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && selectedIdsQuestion5_air.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && selectedIdsQuestion5_x2.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && selectedIdsQuestion5_pro.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && selectedIdsQuestion5_lil_solidez.length != 0) numberOfQuestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;


            // console.log("test: ", hasAnsweredAllQuestionsBeforeShowingThis, numberOfQuestionAnswered, hasChoosenOneOfFirstThree.length)
            if (hasAnsweredAllQuestionsBeforeShowingThis && (hasChoosenIqos_iluma || hasChoosenIqos_iluma_one || hasChoosenIqos_iluma_prime || hasChoosenIqos_original_duo || hasChoosenPloom || hasChoosenGlo_uniq || hasChoosenGlo_air || hasChoosenGlo_x2 || hasChoosenGlo_pro || hasChoosenLil_solidez)) {

                return true;
            } else {
                this.question6.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        // (1.5) HT DEVICE BRAND USAGE
        //a
        this.question7_iqos_iluma = new Question(46, [this.question6.id, this.question4_iqos_iluma.id, this.question3.id],
            'Câte rezerve / stick-uri concepute pentru dispozitivul IQOS Iluma folosești, în medie, pe zi? ',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }

        );
        this.question7_iqos_iluma.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            let question6SelectedIds = this.question6.responses.filter(r => r.selected).map(resp => resp.text);
            // console.log("aici sunt: ", this.question7_iqos_iluma.responses)
            if (question6SelectedIds.length > 0 && hasChoosenIqos_iluma && selectedBrandsAtQuestion3.includes('IQOS Iluma')) {
                return true;
            } else {
                this.question7_iqos_iluma.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }


        this.question7_iqos_iluma_one = new Question(47, [this.question6.id, this.question4_iqos_iluma_one.id, this.question3.id],
            'Câte rezerve / stick-uri concepute pentru dispozitivul IQOS Iluma One folosești, în medie, pe zi? ',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }
        );
        this.question7_iqos_iluma_one.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;


            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question6SelectedIds = this.question6.responses.filter(r => r.selected).map(resp => resp.text);

            if (question6SelectedIds.length > 0 && hasChoosenIqos_iluma_one && selectedBrandsAtQuestion3.includes('IQOS Iluma One')) {
                return true;
            } else {
                this.question7_iqos_iluma_one.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }

        this.question7_iqos_iluma_prime = new Question(48, [this.question6.id, this.question4_iqos_iluma_prime.id, this.question3.id],
            'Câte rezerve / stick-uri concepute pentru dispozitivul IQOS Iluma Prime folosești, în medie, pe zi? ',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }

        );
        this.question7_iqos_iluma_prime.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;


            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            let question6SelectedIds = this.question6.responses.filter(r => r.selected).map(resp => resp.text);

            if (question6SelectedIds.length > 0 && hasChoosenIqos_iluma_prime && selectedBrandsAtQuestion3.includes('IQOS Iluma Prime')) {

                return true;
            } else {
                this.question7_iqos_iluma_prime.responses.forEach(r => {

                    r.freeMessage = '';
                });
            }
            return false;
        }


        this.question7_iqos_original_duo = new Question(49, [this.question6.id, this.question4_iqos_iluma_original_duo.id, this.question3.id],
            'Câte rezerve / stick-uri concepute pentru dispozitivul IQOS Original Duo folosești, în medie, pe zi?',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }

        );
        this.question7_iqos_original_duo.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);



            let question6SelectedIds = this.question6.responses.filter(r => r.selected).map(resp => resp.text);

            if (question6SelectedIds.length > 0 && hasChoosenIqos_original_duo && selectedBrandsAtQuestion3.includes('IQOS Original Duo')) {

                return true;
            } else {
                this.question7_iqos_original_duo.responses.forEach(r => {

                    r.freeMessage = '';
                });
            }
            return false;
        }


        this.question7_ploomx = new Question(50, [this.question6.id, this.question4.id, this.question3.id],
            'Câte rezerve / stick-uri concepute pentru dispozitivul Ploom folosești, în medie, pe zi? ',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }

        );
        this.question7_ploomx.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenPloomx = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);


            let question6SelectedIds = this.question6.responses.filter(r => r.selected).map(resp => resp.text);

            if (question6SelectedIds.length > 0 && hasChoosenPloomx && selectedBrandsAtQuestion3.includes('Ploom')) {

                return true;
            } else {
                this.question7_ploomx.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }


        this.question7_glo_uniq = new Question(51, [this.question6.id, this.question4_glo_hyper_uniq.id, this.question3.id],
            'Câte rezerve / stick-uri concepute pentru dispozitivul Glo Hyper + uniq folosești, în medie, pe zi? ',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }

        );
        this.question7_glo_uniq.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenGLo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);


            let question6SelectedIds = this.question6.responses.filter(r => r.selected).map(resp => resp.text);

            if (question6SelectedIds.length > 0 && hasChoosenGLo_uniq && selectedBrandsAtQuestion3.includes('Glo Hyper + uniq')) {

                return true;
            } else {
                this.question7_glo_uniq.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }

        this.question7_glo_air = new Question(52, [this.question6.id, this.question4_glo_hyper_x2_air.id, this.question3.id],
            'Câte rezerve / stick-uri concepute pentru dispozitivul Glo Hyper X2 Air folosești, în medie, pe zi? ',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }

        );
        this.question7_glo_air.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);


            let question6SelectedIds = this.question6.responses.filter(r => r.selected).map(resp => resp.text);

            if (question6SelectedIds.length > 0 && hasChoosenGlo_air && selectedBrandsAtQuestion3.includes('Glo Hyper X2 Air')) {

                return true;
            } else {
                this.question7_glo_air.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }

        this.question7_glo_x2 = new Question(53, [this.question6.id, this.question4_glo_hyper_x2.id, this.question3.id],
            'Câte rezerve / stick-uri concepute pentru dispozitivul Glo Hyper X2 folosești, în medie, pe zi? ',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }

        );
        this.question7_glo_x2.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);


            let question6SelectedIds = this.question6.responses.filter(r => r.selected).map(resp => resp.text);

            if (question6SelectedIds.length > 0 && hasChoosenGlo_x2 && selectedBrandsAtQuestion3.includes('Glo Hyper X2')) {

                return true;
            } else {
                this.question7_glo_x2.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }

        this.question7_glo_pro = new Question(54, [this.question6.id, this.question4_glo_hyper_pro.id, this.question3.id],
            'Câte rezerve / stick-uri concepute pentru dispozitivul Glo Hyper Pro folosești, în medie, pe zi? ',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }

        );
        this.question7_glo_pro.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);


            let question6SelectedIds = this.question6.responses.filter(r => r.selected).map(resp => resp.text);

            if (question6SelectedIds.length > 0 && hasChoosenGlo_pro && selectedBrandsAtQuestion3.includes('Glo Hyper Pro')) {

                return true;
            } else {
                this.question7_glo_pro.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }

        this.question7_lil_solidez = new Question(55, [this.question6.id, this.question4_lil_solidez.id, this.question3.id],
            'Câte rezerve / stick-uri concepute pentru dispozitivul Lil Solid EZ folosești, în medie, pe zi? ',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }

        );
        this.question7_lil_solidez.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            let question6SelectedIds = this.question6.responses.filter(r => r.selected).map(resp => resp.text);
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            if (question6SelectedIds.length > 0 && hasChoosenLil_solidez && selectedBrandsAtQuestion3.includes('Lil Solid EZ')) {

                return true;
            } else {
                this.question7_lil_solidez.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }

        //b posibil aici sa fie pt ceva lista
        this.question8_iluma = new Question(56, [this.question7_iqos_iluma.id],
            'Câte dispozitive de IQOS Iluma folosești tu personal?',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 10 }
        );


        this.question8_iluma.render = () => {
            if (this.endgame == true) { return false; }

            let question7Score_iluma = this.question7_iqos_iluma.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_one = this.question7_iqos_iluma_one.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_prime = this.question7_iqos_iluma_prime.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_original_duo = this.question7_iqos_original_duo.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_ploomx = this.question7_ploomx.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_uniq = this.question7_glo_uniq.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_air = this.question7_glo_air.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_x2 = this.question7_glo_x2.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_pro = this.question7_glo_pro.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_lil_solidez = this.question7_lil_solidez.responses.filter(r => r.id).map(resp => resp.freeMessage);

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && question7Score_iluma.length != 0 && parseInt(question7Score_iluma[0]) >= 1 && parseInt(question7Score_iluma[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && question7Score_iluma_one.length != 0 && parseInt(question7Score_iluma_one[0]) >= 1 && parseInt(question7Score_iluma_one[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && question7Score_iluma_prime.length != 0 && parseInt(question7Score_iluma_prime[0]) >= 1 && parseInt(question7Score_iluma_prime[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && question7Score_original_duo.length != 0 && parseInt(question7Score_original_duo[0]) >= 1 && parseInt(question7Score_original_duo[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Ploom' && hasChoosenPloom && question7Score_ploomx.length != 0 && parseInt(question7Score_ploomx[0]) >= 1 && parseInt(question7Score_ploomx[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && question7Score_glo_uniq.length != 0 && parseInt(question7Score_glo_uniq[0]) >= 1 && parseInt(question7Score_glo_uniq[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && question7Score_glo_air.length != 0 && parseInt(question7Score_glo_air[0]) >= 1 && parseInt(question7Score_glo_air[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && question7Score_glo_x2.length != 0 && parseInt(question7Score_glo_x2[0]) >= 1 && parseInt(question7Score_glo_x2[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && question7Score_glo_pro.length != 0 && parseInt(question7Score_glo_pro[0]) >= 1 && parseInt(question7Score_glo_pro[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && question7Score_lil_solidez.length != 0 && parseInt(question7Score_lil_solidez[0]) >= 1 && parseInt(question7Score_lil_solidez[0]) <= 100) numberOfQuestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && hasChoosenIqos_iluma) {
                return true;
            } else {
                this.question8_iluma.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }

        //b posibil aici sa fie pt ceva lista
        this.question8_iluma_one = new Question(57, [this.question7_iqos_iluma_one.id],
            'Câte dispozitive de IQOS Iluma One folosești tu personal?',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 10 }
        );


        this.question8_iluma_one.render = () => {
            if (this.endgame == true) { return false; }

            let question7Score_iluma = this.question7_iqos_iluma.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_one = this.question7_iqos_iluma_one.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_prime = this.question7_iqos_iluma_prime.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_original_duo = this.question7_iqos_original_duo.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_ploomx = this.question7_ploomx.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_uniq = this.question7_glo_uniq.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_air = this.question7_glo_air.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_x2 = this.question7_glo_x2.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_pro = this.question7_glo_pro.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_lil_solidez = this.question7_lil_solidez.responses.filter(r => r.id).map(resp => resp.freeMessage);

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && question7Score_iluma.length != 0 && parseInt(question7Score_iluma[0]) >= 1 && parseInt(question7Score_iluma[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && question7Score_iluma_one.length != 0 && parseInt(question7Score_iluma_one[0]) >= 1 && parseInt(question7Score_iluma_one[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && question7Score_iluma_prime.length != 0 && parseInt(question7Score_iluma_prime[0]) >= 1 && parseInt(question7Score_iluma_prime[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && question7Score_original_duo.length != 0 && parseInt(question7Score_original_duo[0]) >= 1 && parseInt(question7Score_original_duo[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Ploom' && hasChoosenPloom && question7Score_ploomx.length != 0 && parseInt(question7Score_ploomx[0]) >= 1 && parseInt(question7Score_ploomx[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && question7Score_glo_uniq.length != 0 && parseInt(question7Score_glo_uniq[0]) >= 1 && parseInt(question7Score_glo_uniq[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && question7Score_glo_air.length != 0 && parseInt(question7Score_glo_air[0]) >= 1 && parseInt(question7Score_glo_air[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && question7Score_glo_x2.length != 0 && parseInt(question7Score_glo_x2[0]) >= 1 && parseInt(question7Score_glo_x2[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && question7Score_glo_pro.length != 0 && parseInt(question7Score_glo_pro[0]) >= 1 && parseInt(question7Score_glo_pro[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && question7Score_lil_solidez.length != 0 && parseInt(question7Score_lil_solidez[0]) >= 1 && parseInt(question7Score_lil_solidez[0]) <= 100) numberOfQuestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && hasChoosenIqos_iluma_one) {
                return true;
            } else {
                this.question8_iluma_one.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }


        //b posibil aici sa fie pt ceva lista
        this.question8_iluma_prime = new Question(58, [this.question7_iqos_iluma_prime.id],
            'Câte dispozitive de IQOS Iluma Prime folosești tu personal?',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 10 }

        );


        this.question8_iluma_prime.render = () => {
            if (this.endgame == true) { return false; }

            let question7Score_iluma = this.question7_iqos_iluma.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_one = this.question7_iqos_iluma_one.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_prime = this.question7_iqos_iluma_prime.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_original_duo = this.question7_iqos_original_duo.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_ploomx = this.question7_ploomx.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_uniq = this.question7_glo_uniq.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_air = this.question7_glo_air.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_x2 = this.question7_glo_x2.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_pro = this.question7_glo_pro.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_lil_solidez = this.question7_lil_solidez.responses.filter(r => r.id).map(resp => resp.freeMessage);

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && question7Score_iluma.length != 0 && parseInt(question7Score_iluma[0]) >= 1 && parseInt(question7Score_iluma[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && question7Score_iluma_one.length != 0 && parseInt(question7Score_iluma_one[0]) >= 1 && parseInt(question7Score_iluma_one[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && question7Score_iluma_prime.length != 0 && parseInt(question7Score_iluma_prime[0]) >= 1 && parseInt(question7Score_iluma_prime[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && question7Score_original_duo.length != 0 && parseInt(question7Score_original_duo[0]) >= 1 && parseInt(question7Score_original_duo[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Ploom' && hasChoosenPloom && question7Score_ploomx.length != 0 && parseInt(question7Score_ploomx[0]) >= 1 && parseInt(question7Score_ploomx[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && question7Score_glo_uniq.length != 0 && parseInt(question7Score_glo_uniq[0]) >= 1 && parseInt(question7Score_glo_uniq[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && question7Score_glo_air.length != 0 && parseInt(question7Score_glo_air[0]) >= 1 && parseInt(question7Score_glo_air[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && question7Score_glo_x2.length != 0 && parseInt(question7Score_glo_x2[0]) >= 1 && parseInt(question7Score_glo_x2[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && question7Score_glo_pro.length != 0 && parseInt(question7Score_glo_pro[0]) >= 1 && parseInt(question7Score_glo_pro[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && question7Score_lil_solidez.length != 0 && parseInt(question7Score_lil_solidez[0]) >= 1 && parseInt(question7Score_lil_solidez[0]) <= 100) numberOfQuestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && hasChoosenIqos_iluma_prime) {
                return true;
            } else {
                this.question8_iluma_prime.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        } //b posibil aici sa fie pt ceva lista
        this.question8_duo = new Question(59, [this.question7_iqos_original_duo.id],
            'Câte dispozitive de IQOS Original Duo folosești tu personal?',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 10 }

        );


        this.question8_duo.render = () => {
            if (this.endgame == true) { return false; }

            let question7Score_iluma = this.question7_iqos_iluma.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_one = this.question7_iqos_iluma_one.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_prime = this.question7_iqos_iluma_prime.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_original_duo = this.question7_iqos_original_duo.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_ploomx = this.question7_ploomx.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_uniq = this.question7_glo_uniq.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_air = this.question7_glo_air.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_x2 = this.question7_glo_x2.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_pro = this.question7_glo_pro.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_lil_solidez = this.question7_lil_solidez.responses.filter(r => r.id).map(resp => resp.freeMessage);

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && question7Score_iluma.length != 0 && parseInt(question7Score_iluma[0]) >= 1 && parseInt(question7Score_iluma[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && question7Score_iluma_one.length != 0 && parseInt(question7Score_iluma_one[0]) >= 1 && parseInt(question7Score_iluma_one[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && question7Score_iluma_prime.length != 0 && parseInt(question7Score_iluma_prime[0]) >= 1 && parseInt(question7Score_iluma_prime[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && question7Score_original_duo.length != 0 && parseInt(question7Score_original_duo[0]) >= 1 && parseInt(question7Score_original_duo[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Ploom' && hasChoosenPloom && question7Score_ploomx.length != 0 && parseInt(question7Score_ploomx[0]) >= 1 && parseInt(question7Score_ploomx[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && question7Score_glo_uniq.length != 0 && parseInt(question7Score_glo_uniq[0]) >= 1 && parseInt(question7Score_glo_uniq[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && question7Score_glo_air.length != 0 && parseInt(question7Score_glo_air[0]) >= 1 && parseInt(question7Score_glo_air[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && question7Score_glo_x2.length != 0 && parseInt(question7Score_glo_x2[0]) >= 1 && parseInt(question7Score_glo_x2[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && question7Score_glo_pro.length != 0 && parseInt(question7Score_glo_pro[0]) >= 1 && parseInt(question7Score_glo_pro[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && question7Score_lil_solidez.length != 0 && parseInt(question7Score_lil_solidez[0]) >= 1 && parseInt(question7Score_lil_solidez[0]) <= 100) numberOfQuestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && hasChoosenIqos_original_duo) {
                return true;
            } else {
                this.question8_duo.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        } //b posibil aici sa fie pt ceva lista
        this.question8_ploom = new Question(60, [this.question7_ploomx.id],
            'Câte dispozitive de Ploom folosești tu personal?',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 10 }

        );


        this.question8_ploom.render = () => {
            if (this.endgame == true) { return false; }

            let question7Score_iluma = this.question7_iqos_iluma.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_one = this.question7_iqos_iluma_one.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_prime = this.question7_iqos_iluma_prime.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_original_duo = this.question7_iqos_original_duo.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_ploomx = this.question7_ploomx.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_uniq = this.question7_glo_uniq.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_air = this.question7_glo_air.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_x2 = this.question7_glo_x2.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_pro = this.question7_glo_pro.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_lil_solidez = this.question7_lil_solidez.responses.filter(r => r.id).map(resp => resp.freeMessage);

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && question7Score_iluma.length != 0 && parseInt(question7Score_iluma[0]) >= 1 && parseInt(question7Score_iluma[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && question7Score_iluma_one.length != 0 && parseInt(question7Score_iluma_one[0]) >= 1 && parseInt(question7Score_iluma_one[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && question7Score_iluma_prime.length != 0 && parseInt(question7Score_iluma_prime[0]) >= 1 && parseInt(question7Score_iluma_prime[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && question7Score_original_duo.length != 0 && parseInt(question7Score_original_duo[0]) >= 1 && parseInt(question7Score_original_duo[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Ploom' && hasChoosenPloom && question7Score_ploomx.length != 0 && parseInt(question7Score_ploomx[0]) >= 1 && parseInt(question7Score_ploomx[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && question7Score_glo_uniq.length != 0 && parseInt(question7Score_glo_uniq[0]) >= 1 && parseInt(question7Score_glo_uniq[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && question7Score_glo_air.length != 0 && parseInt(question7Score_glo_air[0]) >= 1 && parseInt(question7Score_glo_air[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && question7Score_glo_x2.length != 0 && parseInt(question7Score_glo_x2[0]) >= 1 && parseInt(question7Score_glo_x2[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && question7Score_glo_pro.length != 0 && parseInt(question7Score_glo_pro[0]) >= 1 && parseInt(question7Score_glo_pro[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && question7Score_lil_solidez.length != 0 && parseInt(question7Score_lil_solidez[0]) >= 1 && parseInt(question7Score_lil_solidez[0]) <= 100) numberOfQuestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && hasChoosenPloom) {
                return true;
            } else {
                this.question8_ploom.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        } //b posibil aici sa fie pt ceva lista
        this.question8_uniq = new Question(61, [this.question7_glo_uniq.id],
            'Câte dispozitive de Glo Hyper + uniq folosești tu personal?',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 10 }

        );


        this.question8_uniq.render = () => {
            if (this.endgame == true) { return false; }

            let question7Score_iluma = this.question7_iqos_iluma.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_one = this.question7_iqos_iluma_one.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_prime = this.question7_iqos_iluma_prime.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_original_duo = this.question7_iqos_original_duo.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_ploomx = this.question7_ploomx.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_uniq = this.question7_glo_uniq.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_air = this.question7_glo_air.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_x2 = this.question7_glo_x2.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_pro = this.question7_glo_pro.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_lil_solidez = this.question7_lil_solidez.responses.filter(r => r.id).map(resp => resp.freeMessage);

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && question7Score_iluma.length != 0 && parseInt(question7Score_iluma[0]) >= 1 && parseInt(question7Score_iluma[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && question7Score_iluma_one.length != 0 && parseInt(question7Score_iluma_one[0]) >= 1 && parseInt(question7Score_iluma_one[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && question7Score_iluma_prime.length != 0 && parseInt(question7Score_iluma_prime[0]) >= 1 && parseInt(question7Score_iluma_prime[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && question7Score_original_duo.length != 0 && parseInt(question7Score_original_duo[0]) >= 1 && parseInt(question7Score_original_duo[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Ploom' && hasChoosenPloom && question7Score_ploomx.length != 0 && parseInt(question7Score_ploomx[0]) >= 1 && parseInt(question7Score_ploomx[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && question7Score_glo_uniq.length != 0 && parseInt(question7Score_glo_uniq[0]) >= 1 && parseInt(question7Score_glo_uniq[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && question7Score_glo_air.length != 0 && parseInt(question7Score_glo_air[0]) >= 1 && parseInt(question7Score_glo_air[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && question7Score_glo_x2.length != 0 && parseInt(question7Score_glo_x2[0]) >= 1 && parseInt(question7Score_glo_x2[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && question7Score_glo_pro.length != 0 && parseInt(question7Score_glo_pro[0]) >= 1 && parseInt(question7Score_glo_pro[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && question7Score_lil_solidez.length != 0 && parseInt(question7Score_lil_solidez[0]) >= 1 && parseInt(question7Score_lil_solidez[0]) <= 100) numberOfQuestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && hasChoosenGlo_uniq) {
                return true;
            } else {
                this.question8_uniq.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        } //b posibil aici sa fie pt ceva lista
        this.question8_air = new Question(62, [this.question7_glo_air.id],
            'Câte dispozitive de Glo Hyper X2 Air folosești tu personal?',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 10 }

        );


        this.question8_air.render = () => {
            if (this.endgame == true) { return false; }

            let question7Score_iluma = this.question7_iqos_iluma.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_one = this.question7_iqos_iluma_one.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_prime = this.question7_iqos_iluma_prime.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_original_duo = this.question7_iqos_original_duo.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_ploomx = this.question7_ploomx.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_uniq = this.question7_glo_uniq.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_air = this.question7_glo_air.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_x2 = this.question7_glo_x2.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_pro = this.question7_glo_pro.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_lil_solidez = this.question7_lil_solidez.responses.filter(r => r.id).map(resp => resp.freeMessage);

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && question7Score_iluma.length != 0 && parseInt(question7Score_iluma[0]) >= 1 && parseInt(question7Score_iluma[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && question7Score_iluma_one.length != 0 && parseInt(question7Score_iluma_one[0]) >= 1 && parseInt(question7Score_iluma_one[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && question7Score_iluma_prime.length != 0 && parseInt(question7Score_iluma_prime[0]) >= 1 && parseInt(question7Score_iluma_prime[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && question7Score_original_duo.length != 0 && parseInt(question7Score_original_duo[0]) >= 1 && parseInt(question7Score_original_duo[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Ploom' && hasChoosenPloom && question7Score_ploomx.length != 0 && parseInt(question7Score_ploomx[0]) >= 1 && parseInt(question7Score_ploomx[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && question7Score_glo_uniq.length != 0 && parseInt(question7Score_glo_uniq[0]) >= 1 && parseInt(question7Score_glo_uniq[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && question7Score_glo_air.length != 0 && parseInt(question7Score_glo_air[0]) >= 1 && parseInt(question7Score_glo_air[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && question7Score_glo_x2.length != 0 && parseInt(question7Score_glo_x2[0]) >= 1 && parseInt(question7Score_glo_x2[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && question7Score_glo_pro.length != 0 && parseInt(question7Score_glo_pro[0]) >= 1 && parseInt(question7Score_glo_pro[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && question7Score_lil_solidez.length != 0 && parseInt(question7Score_lil_solidez[0]) >= 1 && parseInt(question7Score_lil_solidez[0]) <= 100) numberOfQuestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && hasChoosenGlo_air) {
                return true;
            } else {
                this.question8_air.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        } //b posibil aici sa fie pt ceva lista
        this.question8_x2 = new Question(63, [this.question7_glo_x2.id],
            'Câte dispozitive de Glo Hyper X2 folosești tu personal?',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 10 }

        );


        this.question8_x2.render = () => {
            if (this.endgame == true) { return false; }

            let question7Score_iluma = this.question7_iqos_iluma.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_one = this.question7_iqos_iluma_one.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_prime = this.question7_iqos_iluma_prime.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_original_duo = this.question7_iqos_original_duo.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_ploomx = this.question7_ploomx.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_uniq = this.question7_glo_uniq.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_air = this.question7_glo_air.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_x2 = this.question7_glo_x2.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_pro = this.question7_glo_pro.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_lil_solidez = this.question7_lil_solidez.responses.filter(r => r.id).map(resp => resp.freeMessage);

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && question7Score_iluma.length != 0 && parseInt(question7Score_iluma[0]) >= 1 && parseInt(question7Score_iluma[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && question7Score_iluma_one.length != 0 && parseInt(question7Score_iluma_one[0]) >= 1 && parseInt(question7Score_iluma_one[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && question7Score_iluma_prime.length != 0 && parseInt(question7Score_iluma_prime[0]) >= 1 && parseInt(question7Score_iluma_prime[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && question7Score_original_duo.length != 0 && parseInt(question7Score_original_duo[0]) >= 1 && parseInt(question7Score_original_duo[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Ploom' && hasChoosenPloom && question7Score_ploomx.length != 0 && parseInt(question7Score_ploomx[0]) >= 1 && parseInt(question7Score_ploomx[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && question7Score_glo_uniq.length != 0 && parseInt(question7Score_glo_uniq[0]) >= 1 && parseInt(question7Score_glo_uniq[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && question7Score_glo_air.length != 0 && parseInt(question7Score_glo_air[0]) >= 1 && parseInt(question7Score_glo_air[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && question7Score_glo_x2.length != 0 && parseInt(question7Score_glo_x2[0]) >= 1 && parseInt(question7Score_glo_x2[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && question7Score_glo_pro.length != 0 && parseInt(question7Score_glo_pro[0]) >= 1 && parseInt(question7Score_glo_pro[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && question7Score_lil_solidez.length != 0 && parseInt(question7Score_lil_solidez[0]) >= 1 && parseInt(question7Score_lil_solidez[0]) <= 100) numberOfQuestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && hasChoosenGlo_x2) {
                return true;
            } else {
                this.question8_x2.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        } //b posibil aici sa fie pt ceva lista


        this.question8_pro = new Question(64, [this.question7_glo_pro.id],
            'Câte dispozitive de Glo Hyper Pro folosești tu personal?',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 10 }

        );


        this.question8_pro.render = () => {
            if (this.endgame == true) { return false; }

            let question7Score_iluma = this.question7_iqos_iluma.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_one = this.question7_iqos_iluma_one.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_prime = this.question7_iqos_iluma_prime.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_original_duo = this.question7_iqos_original_duo.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_ploomx = this.question7_ploomx.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_uniq = this.question7_glo_uniq.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_air = this.question7_glo_air.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_x2 = this.question7_glo_x2.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_pro = this.question7_glo_pro.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_lil_solidez = this.question7_lil_solidez.responses.filter(r => r.id).map(resp => resp.freeMessage);

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && question7Score_iluma.length != 0 && parseInt(question7Score_iluma[0]) >= 1 && parseInt(question7Score_iluma[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && question7Score_iluma_one.length != 0 && parseInt(question7Score_iluma_one[0]) >= 1 && parseInt(question7Score_iluma_one[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && question7Score_iluma_prime.length != 0 && parseInt(question7Score_iluma_prime[0]) >= 1 && parseInt(question7Score_iluma_prime[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && question7Score_original_duo.length != 0 && parseInt(question7Score_original_duo[0]) >= 1 && parseInt(question7Score_original_duo[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Ploom' && hasChoosenPloom && question7Score_ploomx.length != 0 && parseInt(question7Score_ploomx[0]) >= 1 && parseInt(question7Score_ploomx[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && question7Score_glo_uniq.length != 0 && parseInt(question7Score_glo_uniq[0]) >= 1 && parseInt(question7Score_glo_uniq[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && question7Score_glo_air.length != 0 && parseInt(question7Score_glo_air[0]) >= 1 && parseInt(question7Score_glo_air[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && question7Score_glo_x2.length != 0 && parseInt(question7Score_glo_x2[0]) >= 1 && parseInt(question7Score_glo_x2[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && question7Score_glo_pro.length != 0 && parseInt(question7Score_glo_pro[0]) >= 1 && parseInt(question7Score_glo_pro[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && question7Score_lil_solidez.length != 0 && parseInt(question7Score_lil_solidez[0]) >= 1 && parseInt(question7Score_lil_solidez[0]) <= 100) numberOfQuestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && hasChoosenGlo_pro) {
                return true;
            } else {
                this.question8_pro.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        } //b posibil aici sa fie pt ceva lista
        this.question8_lil = new Question(65, [this.question7_lil_solidez.id],
            'Câte dispozitive de Lil Solid EZ folosești tu personal?',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 10 }

        );


        this.question8_lil.render = () => {
            if (this.endgame == true) { return false; }

            let question7Score_iluma = this.question7_iqos_iluma.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_one = this.question7_iqos_iluma_one.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_iluma_prime = this.question7_iqos_iluma_prime.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_original_duo = this.question7_iqos_original_duo.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_ploomx = this.question7_ploomx.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_uniq = this.question7_glo_uniq.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_air = this.question7_glo_air.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_x2 = this.question7_glo_x2.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_glo_pro = this.question7_glo_pro.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question7Score_lil_solidez = this.question7_lil_solidez.responses.filter(r => r.id).map(resp => resp.freeMessage);

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && question7Score_iluma.length != 0 && parseInt(question7Score_iluma[0]) >= 1 && parseInt(question7Score_iluma[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && question7Score_iluma_one.length != 0 && parseInt(question7Score_iluma_one[0]) >= 1 && parseInt(question7Score_iluma_one[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && question7Score_iluma_prime.length != 0 && parseInt(question7Score_iluma_prime[0]) >= 1 && parseInt(question7Score_iluma_prime[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && question7Score_original_duo.length != 0 && parseInt(question7Score_original_duo[0]) >= 1 && parseInt(question7Score_original_duo[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Ploom' && hasChoosenPloom && question7Score_ploomx.length != 0 && parseInt(question7Score_ploomx[0]) >= 1 && parseInt(question7Score_ploomx[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && question7Score_glo_uniq.length != 0 && parseInt(question7Score_glo_uniq[0]) >= 1 && parseInt(question7Score_glo_uniq[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && question7Score_glo_air.length != 0 && parseInt(question7Score_glo_air[0]) >= 1 && parseInt(question7Score_glo_air[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && question7Score_glo_x2.length != 0 && parseInt(question7Score_glo_x2[0]) >= 1 && parseInt(question7Score_glo_x2[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && question7Score_glo_pro.length != 0 && parseInt(question7Score_glo_pro[0]) >= 1 && parseInt(question7Score_glo_pro[0]) <= 100) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && question7Score_lil_solidez.length != 0 && parseInt(question7Score_lil_solidez[0]) >= 1 && parseInt(question7Score_lil_solidez[0]) <= 100) numberOfQuestionAnswered += 1;
            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && hasChoosenLil_solidez) {
                let question8FreeMessage_lil = this.question8_lil.responses.filter(r => r.id).map(resp => resp.freeMessage);
                // console.log('question8FreeMessage_iluma', question8FreeMessage_lil);
                return true;
            } else {
                this.question8_lil.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }



        // ???????????
        this.question9 = new Question(66, [this.question8_iluma.id, this.question8_iluma_one.id, this.question8_iluma_prime.id, this.question8_duo.id, this.question8_ploom.id, this.question8_uniq.id, this.question8_air.id, this.question8_x2.id, this.question8_pro.id, this.question8_lil.id],
            'Ce mărci de rezerve cu tutun de încălzit sau  produse din plante cu nicotină ai încercat vreodată?',
            '',
            'checkbox-free',
            [new Response(1, 'Sobranie pentru Ploom'),
            new Response(2, 'Terea'),
            new Response(3, 'Levia'),
            new Response(4, 'HEETS'),
            new Response(5, 'DELIA'),
            new Response(6, 'Dunhill pentru glo'),
            new Response(7, 'veo'),
            new Response(8, 'neo'),
            new Response(9, 'Kent pentru glo'),
            new Response(10, 'Fiit'),
            new Response(11, 'Nuso'),
            new Response(12, 'Altă variantă'),
            ],
            false,
            'vertical'
        );

        this.question9.render = () => {
            if (this.endgame == true) { return false; }

            let question9SelectedIds = this.question9.responses.filter(r => r.selected)

            if (!question9SelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses && this.question9.responses[11]) {
                    this.question9.responses[11].freeMessage = "";
                }
            }

            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            let question8FreeMessage_iluma = this.question8_iluma.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question8FreeMessage_one = this.question8_iluma_one.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question8FreeMessage_prime = this.question8_iluma_prime.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question8FreeMessage_duo = this.question8_duo.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question8FreeMessage_ploom = this.question8_ploom.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question8FreeMessage_uniq = this.question8_uniq.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question8FreeMessage_air = this.question8_air.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question8FreeMessage_x2 = this.question8_x2.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question8FreeMessage_pro = this.question8_pro.responses.filter(r => r.id).map(resp => resp.freeMessage);
            let question8FreeMessage_lil = this.question8_lil.responses.filter(r => r.id).map(resp => resp.freeMessage);

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'IQOS Iluma' && hasChoosenIqos_iluma && question8FreeMessage_iluma.length != 0 && parseInt(question8FreeMessage_iluma[0]) >= 1 && parseInt(question8FreeMessage_iluma[0]) <= 10) numberOfQuestionAnswered += 1;
                if (brand == 'Ploom' && hasChoosenPloom && question8FreeMessage_ploom.length != 0 && parseInt(question8FreeMessage_ploom[0]) >= 1 && parseInt(question8FreeMessage_ploom[0]) <= 10) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && hasChoosenIqos_iluma_one && question8FreeMessage_one.length != 0 && parseInt(question8FreeMessage_one[0]) >= 1 && parseInt(question8FreeMessage_one[0]) <= 10) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && hasChoosenIqos_iluma_prime && question8FreeMessage_prime.length != 0 && parseInt(question8FreeMessage_prime[0]) >= 1 && parseInt(question8FreeMessage_prime[0]) <= 10) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && hasChoosenIqos_original_duo && question8FreeMessage_duo.length != 0 && parseInt(question8FreeMessage_duo[0]) >= 1 && parseInt(question8FreeMessage_duo[0]) <= 10) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && hasChoosenGlo_uniq && question8FreeMessage_uniq.length != 0 && parseInt(question8FreeMessage_uniq[0]) >= 1 && parseInt(question8FreeMessage_uniq[0]) <= 10) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && hasChoosenGlo_air && question8FreeMessage_air.length != 0 && parseInt(question8FreeMessage_air[0]) >= 1 && parseInt(question8FreeMessage_air[0]) <= 10) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && hasChoosenGlo_x2 && question8FreeMessage_x2.length != 0 && parseInt(question8FreeMessage_x2[0]) >= 1 && parseInt(question8FreeMessage_x2[0]) <= 10) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && hasChoosenGlo_pro && question8FreeMessage_pro.length != 0 && parseInt(question8FreeMessage_pro[0]) >= 1 && parseInt(question8FreeMessage_pro[0]) <= 10) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && hasChoosenLil_solidez && question8FreeMessage_lil.length != 0 && parseInt(question8FreeMessage_lil[0]) >= 1 && parseInt(question8FreeMessage_lil[0]) <= 10) numberOfQuestionAnswered += 1;
            })


            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenPloom) hasChoosenOneOfFirstThree.push('Ploom')
            if (hasChoosenIqos_iluma) hasChoosenOneOfFirstThree.push('IQOS Iluma')
            if (hasChoosenIqos_iluma_one) hasChoosenOneOfFirstThree.push('IQOS Iluma One')
            if (hasChoosenIqos_iluma_prime) hasChoosenOneOfFirstThree.push('IQOS Iluma Prime')
            if (hasChoosenIqos_original_duo) hasChoosenOneOfFirstThree.push('IQOS Original Duo')
            if (hasChoosenGlo_uniq) hasChoosenOneOfFirstThree.push('Glo Hyper + uniq')
            if (hasChoosenGlo_air) hasChoosenOneOfFirstThree.push('Glo Hyper X2 Air')
            if (hasChoosenGlo_x2) hasChoosenOneOfFirstThree.push('Glo Hyper X2')
            if (hasChoosenGlo_pro) hasChoosenOneOfFirstThree.push('Glo Hyper Pro')
            if (hasChoosenLil_solidez) hasChoosenOneOfFirstThree.push('Lil Solid EZ')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;


            if (hasAnsweredAllQuestionsBeforeShowingThis
                && (hasChoosenIqos_iluma || hasChoosenIqos_iluma_one || hasChoosenIqos_iluma_prime || hasChoosenIqos_original_duo
                    || hasChoosenPloom || hasChoosenGlo_uniq || hasChoosenGlo_air || hasChoosenGlo_x2 || hasChoosenGlo_pro
                    || hasChoosenLil_solidez)) {
                return true;
            } else {
                this.question9.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question10_Sobranie = new Question(67, [this.question9.id],
            'Ce variantă de Sobranie pentru Ploom sticks ai încercat? ',
            '',
            'checkbox-free',
            this.question10ResponsesSobranie,
            false,
            'vertical'
        );
        this.question10_Sobranie.render = () => {
            if (this.endgame == true) { return false; }

            let selectedQuestion9 = this.question9.responses.filter(r => r.selected);
            let question10_SobranieSelectedIds = this.question10_Sobranie.responses.filter(r => r.selected)

            if (!question10_SobranieSelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question10_Sobranie.responses && this.question10_Sobranie.responses[8]) {
                    this.question10_Sobranie.responses[8].freeMessage = "";
                }
            }

            if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Sobranie pentru Ploom') && selectedQuestion9.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses?.[11]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Sobranie pentru Ploom')) {
                return true;
            }
            else {
                this.question10_Sobranie.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question10_Terea = new Question(68, [this.question9.id],
            'Ce variantă de Terea sticks ai încercat? ',
            '',
            'checkbox-free',
            this.question10ResponsesTerea,
            false,
            'vertical'
        );
        this.question10_Terea.render = () => {
            if (this.endgame == true) { return false; }

            let selectedQuestion9 = this.question9.responses.filter(r => r.selected);

            let question10_TereaSelectedIds = this.question10_Terea.responses.filter(r => r.selected)

            if (!question10_TereaSelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question10_Terea.responses && this.question10_Terea.responses[14]) {
                    this.question10_Terea.responses[14].freeMessage = "";
                }
            }

            if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Terea') && selectedQuestion9.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses?.[11]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Terea')) {
                return true;
            } else {
                this.question10_Terea.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question10_Levia = new Question(69, [this.question9.id],
            'Ce variantă de Levia sticks ai încercat? ',
            '',
            'checkbox-free',
            this.question10ResponsesLevia,
            false,
            'vertical'
        );
        this.question10_Levia.render = () => {
            if (this.endgame == true) { return false; }

            let selectedQuestion9 = this.question9.responses.filter(r => r.selected);
            let question10_LeviaSelectedIds = this.question10_Levia.responses.filter(r => r.selected)

            if (!question10_LeviaSelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question10_Levia.responses && this.question10_Levia.responses[2]) {
                    this.question10_Levia.responses[2].freeMessage = "";
                }
            }


            if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Levia') && selectedQuestion9.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses?.[11]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Levia')) {
                return true;
            } else {
                this.question10_Levia.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question10_HEETS = new Question(70, [this.question9.id],
            'Ce variantă de HEETS sticks ai încercat? ',
            '',
            'checkbox-free',
            this.question10ResponsesHeets,
            false,
            'vertical'
        );
        this.question10_HEETS.render = () => {
            if (this.endgame == true) { return false; }

            let selectedQuestion9 = this.question9.responses.filter(r => r.selected);

            let question10_heetsSelectedIds = this.question10_HEETS.responses.filter(r => r.selected)

            if (!question10_heetsSelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question10_HEETS.responses && this.question10_HEETS.responses[19]) {
                    this.question10_HEETS.responses[19].freeMessage = "";
                }
            }


            if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('HEETS') && selectedQuestion9.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses?.[11]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('HEETS')) {
                return true;
            } else {
                this.question10_HEETS.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question10_DELIA = new Question(71, [this.question9.id],
            'Ce variantă de DELIA sticks ai încercat? ',
            '',
            'checkbox-free',
            this.question10ResponsesDelia,
            false,
            'vertical'
        );
        this.question10_DELIA.render = () => {
            if (this.endgame == true) { return false; }

            let selectedQuestion9 = this.question9.responses.filter(r => r.selected);

            let question10_DeliaSelectedIds = this.question10_DELIA.responses.filter(r => r.selected)

            if (!question10_DeliaSelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question10_DELIA.responses && this.question10_DELIA.responses[3]) {
                    this.question10_DELIA.responses[3].freeMessage = "";
                }
            }
            if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('DELIA') && selectedQuestion9.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses?.[11]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('DELIA')) {
                return true;
            } else {
                this.question10_DELIA.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question10_Dunhill = new Question(72, [this.question9.id],
            'Ce variantă de Dunhill pentru glo sticks ai încercat? ',
            '',
            'checkbox-free',
            this.question10ResponsesDunhill,
            false,
            'vertical'
        );
        this.question10_Dunhill.render = () => {
            if (this.endgame == true) { return false; }

            let selectedQuestion9 = this.question9.responses.filter(r => r.selected);

            let question10_DunhillSelectedIds = this.question10_Dunhill.responses.filter(r => r.selected)

            if (!question10_DunhillSelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question10_Dunhill.responses && this.question10_Dunhill.responses[4]) {
                    this.question10_Dunhill.responses[4].freeMessage = "";
                }
            }

            if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Dunhill pentru glo') && selectedQuestion9.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses?.[11]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Dunhill pentru glo')) {
                return true;
            } else {
                this.question10_Dunhill.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }
        this.question10_veo = new Question(73, [this.question9.id],
            'Ce variantă de veo ai încercat? ',
            '',
            'checkbox-free',
            this.question10ResponsesVeo,
            false,
            'vertical'
        );
        this.question10_veo.render = () => {
            if (this.endgame == true) { return false; }

            let selectedQuestion9 = this.question9.responses.filter(r => r.selected);


            let question10_VeoSelectedIds = this.question10_veo.responses.filter(r => r.selected)

            if (!question10_VeoSelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question10_veo.responses && this.question10_veo.responses[5]) {
                    this.question10_veo.responses[5].freeMessage = "";
                }
            }
            if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('veo') && selectedQuestion9.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses?.[11]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('veo')) {
                return true;
            } else {
                this.question10_veo.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question10_neo = new Question(74, [this.question9.id],
            'Ce variantă de neo sticks ai încercat? ',
            '',
            'checkbox-free',
            this.question10ResponsesNeo,
            false,
            'vertical'
        );
        this.question10_neo.render = () => {
            if (this.endgame == true) { return false; }

            let selectedQuestion9 = this.question9.responses.filter(r => r.selected);

            let question10_neoSelectedIds = this.question10_neo.responses.filter(r => r.selected)

            if (!question10_neoSelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question10_neo.responses && this.question10_neo.responses[18]) {
                    this.question10_neo.responses[18].freeMessage = "";
                }
            }


            if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('neo') && selectedQuestion9.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses?.[11]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('neo')) {
                return true;
            } else {
                this.question10_neo.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }
        this.question10_Kent = new Question(75, [this.question9.id],
            'Ce variantă de Kent pentru glo sticks ai încercat? ',
            '',
            'checkbox-free',
            this.question10ResponsesKent,
            false,
            'vertical'
        );
        this.question10_Kent.render = () => {
            if (this.endgame == true) { return false; }

            let selectedQuestion9 = this.question9.responses.filter(r => r.selected);

            let question10_kentSelectedIds = this.question10_Kent.responses.filter(r => r.selected)

            if (!question10_kentSelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question10_Kent.responses && this.question10_Kent.responses[20]) {
                    this.question10_Kent.responses[20].freeMessage = "";
                }
            }


            if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Kent pentru glo') && selectedQuestion9.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses?.[11]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Kent pentru glo')) {
                return true;
            } else {
                this.question10_Kent.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }
        this.question10_Fiit = new Question(76, [this.question9.id],
            'Ce variantă de Fiit sticks ai încercat? ',
            '',
            'checkbox-free',
            this.question10ResponsesFiit,
            false,
            'vertical'
        );
        this.question10_Fiit.render = () => {
            if (this.endgame == true) { return false; }

            let selectedQuestion9 = this.question9.responses.filter(r => r.selected);

            let question10_FiitSelectedIds = this.question10_Fiit.responses.filter(r => r.selected)

            if (!question10_FiitSelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question10_Fiit.responses && this.question10_Fiit.responses[6]) {
                    this.question10_Fiit.responses[6].freeMessage = "";
                }
            }

            if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Fiit') && selectedQuestion9.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses?.[11]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Fiit')) {
                return true;
            } else {
                this.question10_Fiit.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        // aici

        this.question10_Nuso = new Question(77, [this.question9.id],
            'Ce variantă de Nuso sticks ai încercat? ',
            '',
            'checkbox-free',
            this.question10ResponsesNuso,
            false,
            'vertical'
        );
        this.question10_Nuso.render = () => {
            if (this.endgame == true) { return false; }

            let selectedQuestion9 = this.question9.responses.filter(r => r.selected);

            let question10_NusoSelectedIds = this.question10_Nuso.responses.filter(r => r.selected)

            if (!question10_NusoSelectedIds.map(r => r.text).includes('Altă variantă')) {
                if (this.question10_Nuso.responses && this.question10_Nuso.responses[5]) {
                    this.question10_Nuso.responses[5].freeMessage = "";
                }
            }

            if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Nuso') && selectedQuestion9.map(r => r.text).includes('Altă variantă')) {
                if (this.question9.responses?.[11]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (selectedQuestion9.length > 0 && selectedQuestion9.map(r => r.text).includes('Nuso')) {
                return true;
            } else {
                this.question10_Nuso.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }
        // ttttttttttttttttttttttttttttttttttttttttt

        //d
        this.question11 = new Question(78, [this.question9.id],
            'Pe care o folosești cel mai des?',
            '',
            'radio',
            [new Response(1, 'Sobranie pentru Ploom'),
            new Response(2, 'Terea'),
            new Response(3, 'Levia'),
            new Response(4, 'HEETS'),
            new Response(5, 'DELIA'),
            new Response(6, 'Dunhill pentru glo'),
            new Response(7, 'veo'),
            new Response(8, 'neo'),
            new Response(9, 'Kent pentru glo'),
            new Response(10, 'Fiit'),
            new Response(11, 'Nuso'),
            new Response(12, this.question9.responses.filter(r => r.id)[11]?.freeMessage),

            ],
            false,
            'vertical'
        );


        this.question11.render = () => {
            if (this.endgame == true) { return false; }

            let question11ResponseRenderer = (rsp: Response): boolean => {
                if (this.endgame == true) { return false; }
                let question9SelectedIds = this.question9.responses.filter(r => r.selected).map(r => r.id);
                return question9SelectedIds.indexOf(rsp.id) >= 0;
            }


            this.question11.responses[0].render = question11ResponseRenderer;
            this.question11.responses[1].render = question11ResponseRenderer;
            this.question11.responses[2].render = question11ResponseRenderer;
            this.question11.responses[3].render = question11ResponseRenderer;
            this.question11.responses[4].render = question11ResponseRenderer;
            this.question11.responses[5].render = question11ResponseRenderer;
            this.question11.responses[6].render = question11ResponseRenderer;
            this.question11.responses[7].render = question11ResponseRenderer;
            this.question11.responses[8].render = question11ResponseRenderer;
            this.question11.responses[9].render = question11ResponseRenderer;
            this.question11.responses[10].render = question11ResponseRenderer;
            this.question11.responses[11].render = question11ResponseRenderer;

            this.question11.responses[11].text = this.question9.responses.filter(r => r.id)[11]?.freeMessage;


            let question9Selected = this.question9.responses.filter(r => r.id)[11]?.freeMessage;




            const selectedSobranie = this.question10_Sobranie.responses?.filter(resp => resp?.selected);
            const selectedTerea = this.question10_Terea.responses?.filter(resp => resp?.selected);
            const selectedLevia = this.question10_Levia.responses?.filter(resp => resp?.selected);
            const selectedHeets = this.question10_HEETS.responses?.filter(resp => resp?.selected);
            const selectedDELIA = this.question10_DELIA.responses?.filter(resp => resp?.selected);
            const selectedDunhill = this.question10_Dunhill.responses?.filter(resp => resp?.selected);
            const selectedVeo = this.question10_veo.responses?.filter(resp => resp?.selected);
            const selectedNeo = this.question10_neo.responses?.filter(resp => resp?.selected);
            const selectedKent = this.question10_Kent.responses?.filter(resp => resp?.selected);
            const selectedFiit = this.question10_Fiit.responses?.filter(resp => resp?.selected);
            const selectedNuso = this.question10_Nuso.responses?.filter(resp => resp?.selected);

            const selectedSobranieFreeMessage = this.question10_Sobranie.responses?.[8]?.freeMessage
            const selectedTereaFreeMessage = this.question10_Terea.responses?.[14]?.freeMessage;
            const selectedLeviaFreeMessage = this.question10_Levia.responses?.[2]?.freeMessage;
            const selectedHeetsFreeMessage = this.question10_HEETS.responses?.[19]?.freeMessage;
            const selectedDELIAFreeMessage = this.question10_DELIA.responses?.[3]?.freeMessage;
            const selectedDunhillFreeMessage = this.question10_Dunhill.responses?.[4]?.freeMessage;
            const selectedVeoFreeMessage = this.question10_veo.responses?.[5]?.freeMessage;
            const selectedNeoFreeMessage = this.question10_neo.responses?.[18]?.freeMessage;
            const selectedKentFreeMessage = this.question10_Kent.responses?.[20]?.freeMessage;
            const selectedFiitFreeMessage = this.question10_Fiit.responses?.[6]?.freeMessage;
            const selectedNusoFreeMessage = this.question10_Nuso.responses?.[5]?.freeMessage;


            if (this.question10_Sobranie.responses?.[8]?.selected) {
                if (!selectedSobranieFreeMessage) return false;
            }


            if (this.question10_Terea.responses?.[14]?.selected) {
                if (!selectedTereaFreeMessage) return false;
            }


            if (this.question10_Levia.responses?.[2]?.selected) {
                if (!selectedLeviaFreeMessage) return false;
            }
            if (this.question10_HEETS.responses?.[19]?.selected) {
                if (!selectedHeetsFreeMessage) return false;
            }
            if (this.question10_DELIA.responses?.[3]?.selected) {
                if (!selectedDELIAFreeMessage) return false;
            }
            if (this.question10_Dunhill.responses?.[4]?.selected) {
                if (!selectedDunhillFreeMessage) return false;
            }
            if (this.question10_veo.responses?.[5]?.selected) {
                if (!selectedVeoFreeMessage) return false;
            }
            if (this.question10_neo.responses?.[18]?.selected) {
                if (!selectedNeoFreeMessage) return false;
            }
            if (this.question10_Kent.responses?.[20]?.selected) {
                if (!selectedKentFreeMessage) return false;
            }
            if (this.question10_Fiit.responses?.[6]?.selected) {
                if (!selectedFiitFreeMessage) return false;
            }
            if (this.question10_Nuso.responses?.[5]?.selected) {
                if (!selectedNusoFreeMessage) return false;
            }

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion9 = this.question9.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            // (selectedResponseQ9.map(q => q.id).includes(12) && selectedResponseQ9.find(q => q.id == 12)?.freeMessage))



            selectedBrandsAtQuestion9.map(brand => {
                if (brand == 'Sobranie pentru Ploom' && selectedSobranie.length != 0) {
                    if (this.question10_Sobranie.responses?.[8]?.selected) {
                        if (selectedSobranieFreeMessage) {
                            numberOfQuestionAnswered += 1
                        }
                    } else {
                        numberOfQuestionAnswered += 1

                    }
                }

                if (brand == 'Terea' && selectedTerea.length != 0) {
                    if (this.question10_Terea.responses?.[14]?.selected) {
                        if (selectedTereaFreeMessage) {
                            numberOfQuestionAnswered += 1;
                        }
                    } else {
                        numberOfQuestionAnswered += 1;
                    }
                }

                if (brand == 'Levia' && selectedLevia.length != 0) {
                    if (this.question10_Levia.responses?.[2]?.selected) {
                        if (selectedLeviaFreeMessage) {
                            numberOfQuestionAnswered += 1;
                        }
                    } else {
                        numberOfQuestionAnswered += 1;
                    }
                }

                if (brand == 'HEETS' && selectedHeets.length != 0) {
                    if (this.question10_HEETS.responses?.[19]?.selected) {
                        if (selectedHeetsFreeMessage) {
                            numberOfQuestionAnswered += 1;
                        }
                    } else {
                        numberOfQuestionAnswered += 1;
                    }
                }

                if (brand == 'DELIA' && selectedDELIA.length != 0) {
                    if (this.question10_DELIA.responses?.[3]?.selected) {
                        if (selectedDELIAFreeMessage) {
                            numberOfQuestionAnswered += 1;
                        }
                    } else {
                        numberOfQuestionAnswered += 1;
                    }
                }

                if (brand == 'Dunhill pentru glo' && selectedDunhill.length != 0) {
                    if (this.question10_Dunhill.responses?.[4]?.selected) {
                        if (selectedDunhillFreeMessage) {
                            numberOfQuestionAnswered += 1;
                        }
                    } else {
                        numberOfQuestionAnswered += 1;
                    }
                }

                if (brand == 'veo' && selectedVeo.length != 0) {
                    if (this.question10_veo.responses?.[5]?.selected) {
                        if (selectedVeoFreeMessage) {
                            numberOfQuestionAnswered += 1;
                        }
                    } else {
                        numberOfQuestionAnswered += 1;
                    }
                }

                if (brand == 'neo' && selectedNeo.length != 0) {
                    if (this.question10_neo.responses?.[18]?.selected) {
                        if (selectedNeoFreeMessage) {
                            numberOfQuestionAnswered += 1;
                        }
                    } else {
                        numberOfQuestionAnswered += 1;
                    }
                }

                if (brand == 'Kent pentru glo' && selectedKent.length != 0) {
                    if (this.question10_Kent.responses?.[20]?.selected) {
                        if (selectedKentFreeMessage) {
                            numberOfQuestionAnswered += 1;
                        }
                    } else {
                        numberOfQuestionAnswered += 1;
                    }
                }

                if (brand == 'Fiit' && selectedFiit.length != 0) {
                    if (this.question10_Fiit.responses?.[6]?.selected) {
                        if (selectedFiitFreeMessage) {
                            numberOfQuestionAnswered += 1;
                        }
                    } else {
                        numberOfQuestionAnswered += 1;
                    }
                }

                if (brand == 'Nuso' && selectedNuso.length != 0) {
                    if (this.question10_Nuso.responses?.[5]?.selected) {
                        if (selectedNusoFreeMessage) {
                            numberOfQuestionAnswered += 1;
                        }
                    } else {
                        numberOfQuestionAnswered += 1;
                    }
                }

                if (brand == 'Altă variantă' && question9Selected && question9Selected.trim() !== '') {
                    numberOfQuestionAnswered += 1;
                }



            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion9.length;


            if (hasAnsweredAllQuestionsBeforeShowingThis && selectedBrandsAtQuestion9.length > 1) {
                return true;
            } else {
                this.question11.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (1.6) PLOOM SOURCE OF AWARENESS 

        this.question12 = new Question(79, [this.question11.id],
            'Cum ai aflat de Ploom?',
            '',
            'checkbox-free',
            [new Response(1, 'De la alți adulți,consumatori existenți (Ex.: prieteni/ familie/colegi/cunoștințe)'),
            new Response(2, 'De la vânzătorii din magazinul de unde îmi cumpăr de obicei produsele cu nicotină'),
            new Response(3, 'Am văzut într-un magazin de unde am cumpărat produse cu nicotină'),
            new Response(4, 'Am văzut într-o locație HoReCa (cafenea/bar/restaurant/club/pub)'),
            new Response(5, 'De la brand ambasadori (persoane care prezintă produse cu nicotină) într-un bar/restaurant/club/pub'),
            new Response(6, 'De la brand ambasadori (persoane care prezintă produse cu nicotină) într-un magazin/ chioșc'),
            new Response(7, 'De pe afișele cu prețuri din magazinele de unde cumpăr produse cu nicotină'),
            new Response(8, 'De pe internet'),
            new Response(9, 'Am primit un email'),
            new Response(10, 'Am primit un SMS'),
            new Response(11, 'De pe un cartonaș aflat în interiorul pachetului de țigarete'),
            new Response(12, 'Din altă sursă')
            ],
            false,
            'vertical'
        );

        this.question12.render = () => {
            if (this.endgame == true) { return false; }

            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            let question11SelectedIds = this.question11.responses.filter(r => r.selected);

            let question12SelectedIds = this.question12.responses.filter(r => r.selected)

            if (!question12SelectedIds.map(r => r.text).includes('Din altă sursă')) {
                if (this.question12.responses && this.question12.responses[11]) {
                    this.question12.responses[11].freeMessage = "";
                }
            }

            const selectedSobranie = this.question10_Sobranie.responses?.filter(resp => resp?.selected);
            const selectedTerea = this.question10_Terea.responses?.filter(resp => resp?.selected);
            const selectedLevia = this.question10_Levia.responses?.filter(resp => resp?.selected);
            const selectedHeets = this.question10_HEETS.responses?.filter(resp => resp?.selected);
            const selectedDELIA = this.question10_DELIA.responses?.filter(resp => resp?.selected);
            const selectedDunhill = this.question10_Dunhill.responses?.filter(resp => resp?.selected);
            const selectedVeo = this.question10_veo.responses?.filter(resp => resp?.selected);
            const selectedNeo = this.question10_neo.responses?.filter(resp => resp?.selected);
            const selectedKent = this.question10_Kent.responses?.filter(resp => resp?.selected);
            const selectedFiit = this.question10_Fiit.responses?.filter(resp => resp?.selected);
            const selectedNuso = this.question10_Nuso.responses?.filter(resp => resp?.selected);



            const selectedSobranieFreeMessage = this.question10_Sobranie.responses?.[8]?.freeMessage
            const selectedTereaFreeMessage = this.question10_Terea.responses?.[14]?.freeMessage;
            const selectedLeviaFreeMessage = this.question10_Levia.responses?.[2]?.freeMessage;
            const selectedHeetsFreeMessage = this.question10_HEETS.responses?.[19]?.freeMessage;
            const selectedDELIAFreeMessage = this.question10_DELIA.responses?.[3]?.freeMessage;
            const selectedDunhillFreeMessage = this.question10_Dunhill.responses?.[4]?.freeMessage;
            const selectedVeoFreeMessage = this.question10_veo.responses?.[5]?.freeMessage;
            const selectedNeoFreeMessage = this.question10_neo.responses?.[18]?.freeMessage;
            const selectedKentFreeMessage = this.question10_Kent.responses?.[20]?.freeMessage;
            const selectedFiitFreeMessage = this.question10_Fiit.responses?.[6]?.freeMessage;
            const selectedNusoFreeMessage = this.question10_Nuso.responses?.[5]?.freeMessage;


            if (this.question10_Sobranie.responses?.[8]?.selected) {
                if (!selectedSobranieFreeMessage) return false;
            }


            if (this.question10_Terea.responses?.[14]?.selected) {
                if (!selectedTereaFreeMessage) return false;
            }


            if (this.question10_Levia.responses?.[2]?.selected) {
                if (!selectedLeviaFreeMessage) return false;
            }
            if (this.question10_HEETS.responses?.[19]?.selected) {
                if (!selectedHeetsFreeMessage) return false;
            }
            if (this.question10_DELIA.responses?.[3]?.selected) {
                if (!selectedDELIAFreeMessage) return false;
            }
            if (this.question10_Dunhill.responses?.[4]?.selected) {
                if (!selectedDunhillFreeMessage) return false;
            }
            if (this.question10_veo.responses?.[5]?.selected) {
                if (!selectedVeoFreeMessage) return false;
            }
            if (this.question10_neo.responses?.[18]?.selected) {
                if (!selectedNeoFreeMessage) return false;
            }
            if (this.question10_Kent.responses?.[20]?.selected) {
                if (!selectedKentFreeMessage) return false;
            }
            if (this.question10_Fiit.responses?.[6]?.selected) {
                if (!selectedFiitFreeMessage) return false;
            }
            if (this.question10_Nuso.responses?.[5]?.selected) {
                if (!selectedNusoFreeMessage) return false;
            }





            let numberOfQuestionAnswered = 0;
            if (this.question10_Sobranie.render() && selectedSobranie.length > 0) numberOfQuestionAnswered += 1
            if (this.question10_Terea.render() && selectedTerea.length > 0) numberOfQuestionAnswered += 1;
            if (this.question10_Levia.render() && selectedLevia.length > 0) numberOfQuestionAnswered += 1;
            if (this.question10_HEETS.render() && selectedHeets.length > 0) numberOfQuestionAnswered += 1;
            if (this.question10_DELIA.render() && selectedDELIA.length > 0) numberOfQuestionAnswered += 1;
            if (this.question10_Dunhill.render() && selectedDunhill.length > 0) numberOfQuestionAnswered += 1;
            if (this.question10_veo.render() && selectedVeo.length > 0) numberOfQuestionAnswered += 1;
            if (this.question10_neo.render() && selectedNeo.length > 0) numberOfQuestionAnswered += 1;
            if (this.question10_Kent.render() && selectedKent.length > 0) numberOfQuestionAnswered += 1;
            if (this.question10_Fiit.render() && selectedFiit.length > 0) numberOfQuestionAnswered += 1;
            if (this.question10_Nuso.render() && selectedNuso.length > 0) numberOfQuestionAnswered += 1;

            let selectedBrandsAtQuestion9 = this.question9.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion9.length;


            if (question3SelectedIds.includes('Ploom')) {
                if (this.question11.render() && selectedBrandsAtQuestion9.length > 1 && question11SelectedIds.length > 0) {
                    return true
                }
                else if (hasAnsweredAllQuestionsBeforeShowingThis && selectedBrandsAtQuestion9.length == 1) {
                    return true;
                } else if (selectedBrandsAtQuestion9.length == 1 && this.question9.responses.filter(r => r.id)[11]?.freeMessage) {
                    return true;
                }
                else {
                    this.question12.responses.forEach(r => {
                        r.selected = false;
                    });
                }
                return false;

            } return false;
        }

        // (1.7) SALES CHANNEL FOR PLOOM PURCHASE
        this.question13 = new Question(80, [this.question12.id],
            'De unde ai achiziționat dispozitivul Ploom pe care îl folosești tu personal cel mai des în prezent?',
            '',
            'radio-free',
            [
                new Response(1, 'Magazin specializat al mărcii Ploom / O insulă Ploom din Mall'),
                new Response(2, 'Hipermarket / supermarket'),
                new Response(3, 'Internet/magazine online/Marketplace, cu excepția magazinului online Ploom (www.ploom.ro)'),
                new Response(4, 'Magazin alimentar / Minimarket'),
                new Response(5, 'Tutungerie / Magazin de tutun / Specialiști în tutun'),
                new Response(6, 'Benzinărie'),
                new Response(7, 'Site-ul mărcii Ploom (www.ploom.ro)'),
                new Response(8, 'Magazine specializate în țigări electronice / Magazine specializate pentru vape'),
                new Response(9, 'L-am primit cadou'),
                new Response(10, 'De la brand ambasadoare / brand ambasadori'),
                new Response(11, 'Chioșc'),
                new Response(12, 'Restaurant / Cafenea / Bar / Pub / Club'),
                new Response(13, 'Aeroport / Duty free'),
                new Response(14, 'Din altă parte')
            ],

            false,
            'vertical'
        );
        this.question13.render = () => {
            if (this.endgame == true) { return false; }
            let question3SelectedIds = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            let question12SelectedIds = this.question12.responses.filter(r => r.selected).map(r => r.text);
            let question13SelectedIds = this.question13.responses.filter(r => r.selected)

            if (!question13SelectedIds.map(r => r.text).includes('Din altă parte')) {
                if (this.question13.responses && this.question13.responses[13]) {
                    this.question13.responses[13].freeMessage = "";
                }
            }


            if (question3SelectedIds.includes('Ploom')) {
                if (question12SelectedIds.includes('Din altă sursă')) {
                    if (this.question12.responses?.[11]?.freeMessage) {
                        return true;
                    }
                    else { return false; }
                } else if (question12SelectedIds.length > 0) {
                    return true;
                } else {
                    this.question13.responses.forEach(r => {
                        r.selected = false;
                        r.freeMessage = ''
                    });
                }
            }
            return false;
        }


        //(2.1) OTHER CATEGORY USAGE
        this.question14 = new Question(81, [this.question13.id],
            'Pe care dintre următoarele produse cu nicotină le-ai încercat/folosit în trecut ca adult? Bifează toate categoriile încercate vreodată și cele pe care le folosești in prezent',
            '',
            'checkbox',
            [new Response(1, 'Țigarete (țigarete convenționale, în pachet)', [], './assets/images/rmc.png'),
            new Response(2, 'Tutun rulat', [], './assets/images/fct.png'),
            new Response(3, 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri', [], './assets/images/ecig.png'),
            new Response(4, 'Pliculețe cu nicotină (Pouch-uri cu nicotină)', [], './assets/images/nic.png')
            ],
            false,
            'horizontal',
            '',
            2
        );

        this.question14.render = () => {
            if (this.endgame == true) { return false; }
            let question13SelectedIds = this.question13.responses.filter(r => r.selected);
            if (question13SelectedIds.length > 0 && (!question13SelectedIds.map(q => q.id).includes(14) || (question13SelectedIds.map(q => q.id).includes(14) && question13SelectedIds.find(q => q.id == 14)?.freeMessage)) ? true : false) {
                return true;
            } else {
                this.question14.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }




        //(2.2) OTHER CATEGORY USAGE FREQUENCY 
        this.question15 = new Question(82, [this.question14.id],
            'Cât de des folosești țigarete (țigarete convenționale, în pachet)?',
            '',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );
        this.question15.render = () => {
            if (this.endgame == true) { return false; }
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);
            if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Țigarete (țigarete convenționale, în pachet)')) {
                return true;
            } else {
                this.question15.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        //(2.2) OTHER CATEGORY USAGE FREQUENCY 
        this.question16 = new Question(83, [this.question14.id],
            'Cât de des folosești tutun rulat?',
            '',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );
        this.question16.render = () => {
            if (this.endgame == true) { return false; }
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);
            if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Tutun rulat')) {
                return true;
            } else {
                this.question16.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        //(2.2) OTHER CATEGORY USAGE FREQUENCY 
        this.question17 = new Question(84, [this.question14.id],
            'Cât de des folosești țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri?',
            '',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );
        this.question17.render = () => {
            if (this.endgame == true) { return false; }
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);
            if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')) {
                return true;
            } else {
                this.question17.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        //(2.2) OTHER CATEGORY USAGE FREQUENCY 
        this.question18 = new Question(85, [this.question14.id],
            'Cât de des folosești pliculețe cu nicotină (Pouch-uri cu nicotină)?',
            '',
            'radio',
            [new Response(1, 'Zilnic (cel puțin o dată pe zi)'),
            new Response(2, 'Săptămânal (cel puțin o dată pe săptămână)'),
            new Response(3, 'Lunar (cel puțin o dată în ultimele 4 săptămâni)'),
            new Response(4, 'Am încercat/folosit cel puțin o dată, dar nu am continuat'),
            new Response(5, 'Am folosit în mod regulat în trecut, dar nu mai folosesc')],
            false,
            'vertical'
        );
        this.question18.render = () => {
            if (this.endgame == true) { return false; }
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);
            if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)')) {
                return true;
            } else {
                this.question18.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }




        this.question15_1 = new Question(86, [this.question15.id],
            'Cât de des folosești țigarete (țigarete convenționale, în pachet) într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question15_1.render = () => {
            if (this.endgame == true) { return false; }

            let question15SelectedIds = this.question15.responses.filter(r => r.selected);
            let question16SelectedIds = this.question16.responses.filter(r => r.selected);
            let question17SelectedIds = this.question17.responses.filter(r => r.selected);
            let question18SelectedIds = this.question18.responses.filter(r => r.selected);



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && question15SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && question16SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && question17SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && question18SelectedIds.length != 0) numberOfQuestionAnswered += 1;

            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion14.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question15SelectedIds?.[0]?.id == 2 && selectedBrandsAtQuestion14.includes('Țigarete (țigarete convenționale, în pachet)')) {
                return true;
            } else {
                this.question15_1.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question16_1 = new Question(87, [this.question15.id],
            'Cât de des folosești tutun rulat într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question16_1.render = () => {
            if (this.endgame == true) { return false; }

            let question15SelectedIds = this.question15.responses.filter(r => r.selected);
            let question16SelectedIds = this.question16.responses.filter(r => r.selected);
            let question17SelectedIds = this.question17.responses.filter(r => r.selected);
            let question18SelectedIds = this.question18.responses.filter(r => r.selected);



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && question15SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && question16SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && question17SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && question18SelectedIds.length != 0) numberOfQuestionAnswered += 1;

            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion14.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question16SelectedIds?.[0]?.id == 2 && selectedBrandsAtQuestion14.includes('Tutun rulat')) {
                return true;
            }
            else {
                this.question16_1.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question17_1 = new Question(88, [this.question15.id],
            'Cât de des folosești țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question17_1.render = () => {
            if (this.endgame == true) { return false; }

            let question15SelectedIds = this.question15.responses.filter(r => r.selected);
            let question16SelectedIds = this.question16.responses.filter(r => r.selected);
            let question17SelectedIds = this.question17.responses.filter(r => r.selected);
            let question18SelectedIds = this.question18.responses.filter(r => r.selected);



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && question15SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && question16SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && question17SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && question18SelectedIds.length != 0) numberOfQuestionAnswered += 1;

            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion14.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question17SelectedIds?.[0]?.id == 2 && selectedBrandsAtQuestion14.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')) {
                return true;
            } else {
                this.question17_1.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question18_1 = new Question(89, [this.question15.id],
            'Cât de des folosești pliculețe cu nicotină (Pouch-uri cu nicotină) într-o săptămână?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe săptămână'),
            new Response(2, 'De 2-3 ori pe săptămână'),
            new Response(3, 'O dată pe săptămână'),],
            false,
            'vertical'
        );

        this.question18_1.render = () => {
            if (this.endgame == true) { return false; }

            let question15SelectedIds = this.question15.responses.filter(r => r.selected);
            let question16SelectedIds = this.question16.responses.filter(r => r.selected);
            let question17SelectedIds = this.question17.responses.filter(r => r.selected);
            let question18SelectedIds = this.question18.responses.filter(r => r.selected);



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && question15SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && question16SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && question17SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && question18SelectedIds.length != 0) numberOfQuestionAnswered += 1;

            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion14.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question18SelectedIds?.[0]?.id == 2 && selectedBrandsAtQuestion14.includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)')) {
                return true;
            } else {
                this.question18_1.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }




        this.question15_2 = new Question(90, [this.question15.id],
            'Cât de des folosești țigarete (țigarete convenționale, în pachet) într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question15_2.render = () => {
            if (this.endgame == true) { return false; }

            let question15SelectedIds = this.question15.responses.filter(r => r.selected);
            let question16SelectedIds = this.question16.responses.filter(r => r.selected);
            let question17SelectedIds = this.question17.responses.filter(r => r.selected);
            let question18SelectedIds = this.question18.responses.filter(r => r.selected);



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && question15SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && question16SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && question17SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && question18SelectedIds.length != 0) numberOfQuestionAnswered += 1;

            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion14.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question15SelectedIds?.[0]?.id == 3 && selectedBrandsAtQuestion14.includes('Țigarete (țigarete convenționale, în pachet)')) {
                return true;
            } else {
                this.question15_2.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question16_2 = new Question(91, [this.question15.id],
            'Cât de des folosești tutun rulat într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question16_2.render = () => {
            if (this.endgame == true) { return false; }

            let question15SelectedIds = this.question15.responses.filter(r => r.selected);
            let question16SelectedIds = this.question16.responses.filter(r => r.selected);
            let question17SelectedIds = this.question17.responses.filter(r => r.selected);
            let question18SelectedIds = this.question18.responses.filter(r => r.selected);



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && question15SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && question16SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && question17SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && question18SelectedIds.length != 0) numberOfQuestionAnswered += 1;

            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion14.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question16SelectedIds?.[0]?.id == 3 && selectedBrandsAtQuestion14.includes('Tutun rulat')) {
                return true;
            }
            else {
                this.question16_2.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question17_2 = new Question(92, [this.question15.id],
            'Cât de des folosești țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question17_2.render = () => {
            if (this.endgame == true) { return false; }

            let question15SelectedIds = this.question15.responses.filter(r => r.selected);
            let question16SelectedIds = this.question16.responses.filter(r => r.selected);
            let question17SelectedIds = this.question17.responses.filter(r => r.selected);
            let question18SelectedIds = this.question18.responses.filter(r => r.selected);



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && question15SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && question16SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && question17SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && question18SelectedIds.length != 0) numberOfQuestionAnswered += 1;

            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion14.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question17SelectedIds?.[0]?.id == 3 && selectedBrandsAtQuestion14.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')) {
                return true;
            } else {
                this.question17_2.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question18_2 = new Question(93, [this.question15.id],
            'Cât de des folosești pliculețe cu nicotină (Pouch-uri cu nicotină) într-o lună?  ',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'De 4-5 ori pe lună'),
            new Response(2, 'De 2-3 ori pe lună'),
            new Response(3, 'O dată pe lună'),],
            false,
            'vertical'
        );

        this.question18_2.render = () => {
            if (this.endgame == true) { return false; }

            let question15SelectedIds = this.question15.responses.filter(r => r.selected);
            let question16SelectedIds = this.question16.responses.filter(r => r.selected);
            let question17SelectedIds = this.question17.responses.filter(r => r.selected);
            let question18SelectedIds = this.question18.responses.filter(r => r.selected);



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && question15SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && question16SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && question17SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && question18SelectedIds.length != 0) numberOfQuestionAnswered += 1;

            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion14.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && question18SelectedIds?.[0]?.id == 3 && selectedBrandsAtQuestion14.includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)')) {
                return true;
            } else {
                this.question18_2.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        this.question19 = new Question(94, [this.question15_1.id],
            'De cât timp folosești țigarete (țigarete convenționale, în pachet)?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question19.render = () => {
            if (this.endgame == true) { return false; }


            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question19.responses = this.question19.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );


            const hasChoosen15R1 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen16R1 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen17R1 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen18R1 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;

            const hasChoosen15R2 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen16R2 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen17R2 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen18R2 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;

            const hasChoosen15R3 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen16R3 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen17R3 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen18R3 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;

            let question15_1SelectedIds = this.question15_1.responses.filter(r => r.selected);
            let question16_1SelectedIds = this.question16_1.responses.filter(r => r.selected);
            let question17_1SelectedIds = this.question17_1.responses.filter(r => r.selected);
            let question18_1SelectedIds = this.question18_1.responses.filter(r => r.selected);

            let question15_2SelectedIds = this.question15_2.responses.filter(r => r.selected);
            let question16_2SelectedIds = this.question16_2.responses.filter(r => r.selected);
            let question17_2SelectedIds = this.question17_2.responses.filter(r => r.selected);
            let question18_2SelectedIds = this.question18_2.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && ((hasChoosen15R2 && question15_1SelectedIds.length != 0) || (hasChoosen15R3 && question15_2SelectedIds.length != 0) || hasChoosen15R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && ((hasChoosen16R2 && question16_1SelectedIds.length != 0) || (hasChoosen16R3 && question16_2SelectedIds.length != 0) || hasChoosen16R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && ((hasChoosen17R2 && question17_1SelectedIds.length != 0) || (hasChoosen17R3 && question17_2SelectedIds.length != 0) || hasChoosen17R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && ((hasChoosen18R2 && question18_1SelectedIds.length != 0) || (hasChoosen18R3 && question18_2SelectedIds.length != 0) || hasChoosen18R1)) numberOfQuestionAnswered += 1;

            })


            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && ((hasChoosen15R2 && question15_1SelectedIds.length != 0) || (hasChoosen15R3 && question15_2SelectedIds.length != 0) || hasChoosen15R1 || this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Tutun rulat' && ((hasChoosen16R2 && question16_1SelectedIds.length != 0) || (hasChoosen16R3 && question16_2SelectedIds.length != 0) || hasChoosen16R1 || this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && ((hasChoosen17R2 && question17_1SelectedIds.length != 0) || (hasChoosen17R3 && question17_2SelectedIds.length != 0) || hasChoosen17R1 || this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && ((hasChoosen18R2 && question18_1SelectedIds.length != 0) || (hasChoosen18R3 && question18_2SelectedIds.length != 0) || hasChoosen18R1 || this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;

            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosen15R1 || hasChoosen15R2 || hasChoosen15R3) hasChoosenOneOfFirstThree.push('Țigarete (țigarete convenționale, în pachet)')
            if (hasChoosen16R1 || hasChoosen16R2 || hasChoosen16R3) hasChoosenOneOfFirstThree.push('Tutun rulat')
            if (hasChoosen17R1 || hasChoosen17R2 || hasChoosen17R3) hasChoosenOneOfFirstThree.push('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')
            if (hasChoosen18R1 || hasChoosen18R2 || hasChoosen18R3) hasChoosenOneOfFirstThree.push('Pliculețe cu nicotină (Pouch-uri cu nicotină)')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && (question15_1SelectedIds?.length > 0 || question15_2SelectedIds?.length > 0 || (hasChoosen15R1 && selectedBrandsAtQuestion14.length == allquestionAnswered))) {
                return true;
            } else {
                this.question19.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        this.question20 = new Question(95, [this.question16_1.id],
            'De cât timp folosești tutun rulat?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question20.render = () => {
            if (this.endgame == true) { return false; }


            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question20.responses = this.question20.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );

            const hasChoosen15R1 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen16R1 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen17R1 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen18R1 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;

            const hasChoosen15R2 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen16R2 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen17R2 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen18R2 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;

            const hasChoosen15R3 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen16R3 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen17R3 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen18R3 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;

            let question15_1SelectedIds = this.question15_1.responses.filter(r => r.selected);
            let question16_1SelectedIds = this.question16_1.responses.filter(r => r.selected);
            let question17_1SelectedIds = this.question17_1.responses.filter(r => r.selected);
            let question18_1SelectedIds = this.question18_1.responses.filter(r => r.selected);

            let question15_2SelectedIds = this.question15_2.responses.filter(r => r.selected);
            let question16_2SelectedIds = this.question16_2.responses.filter(r => r.selected);
            let question17_2SelectedIds = this.question17_2.responses.filter(r => r.selected);
            let question18_2SelectedIds = this.question18_2.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && ((hasChoosen15R2 && question15_1SelectedIds.length != 0) || (hasChoosen15R3 && question15_2SelectedIds.length != 0) || hasChoosen15R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && ((hasChoosen16R2 && question16_1SelectedIds.length != 0) || (hasChoosen16R3 && question16_2SelectedIds.length != 0) || hasChoosen16R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && ((hasChoosen17R2 && question17_1SelectedIds.length != 0) || (hasChoosen17R3 && question17_2SelectedIds.length != 0) || hasChoosen17R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && ((hasChoosen18R2 && question18_1SelectedIds.length != 0) || (hasChoosen18R3 && question18_2SelectedIds.length != 0) || hasChoosen18R1)) numberOfQuestionAnswered += 1;

            })

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && ((hasChoosen15R2 && question15_1SelectedIds.length != 0) || (hasChoosen15R3 && question15_2SelectedIds.length != 0) || hasChoosen15R1 || this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Tutun rulat' && ((hasChoosen16R2 && question16_1SelectedIds.length != 0) || (hasChoosen16R3 && question16_2SelectedIds.length != 0) || hasChoosen16R1 || this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && ((hasChoosen17R2 && question17_1SelectedIds.length != 0) || (hasChoosen17R3 && question17_2SelectedIds.length != 0) || hasChoosen17R1 || this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && ((hasChoosen18R2 && question18_1SelectedIds.length != 0) || (hasChoosen18R3 && question18_2SelectedIds.length != 0) || hasChoosen18R1 || this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;

            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosen15R1 || hasChoosen15R2 || hasChoosen15R3) hasChoosenOneOfFirstThree.push('Țigarete (țigarete convenționale, în pachet)')
            if (hasChoosen16R1 || hasChoosen16R2 || hasChoosen16R3) hasChoosenOneOfFirstThree.push('Tutun rulat')
            if (hasChoosen17R1 || hasChoosen17R2 || hasChoosen17R3) hasChoosenOneOfFirstThree.push('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')
            if (hasChoosen18R1 || hasChoosen18R2 || hasChoosen18R3) hasChoosenOneOfFirstThree.push('Pliculețe cu nicotină (Pouch-uri cu nicotină)')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && (question16_1SelectedIds?.length > 0 || question16_2SelectedIds?.length > 0 || (hasChoosen16R1 && selectedBrandsAtQuestion14.length == allquestionAnswered))) {
                return true;
            } else {
                this.question20.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }




        this.question21 = new Question(96, [this.question17_1.id],
            'De cât timp folosești țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question21.render = () => {
            if (this.endgame == true) { return false; }
            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question21.responses = this.question21.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );
            const hasChoosen15R1 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen16R1 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen17R1 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen18R1 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;

            const hasChoosen15R2 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen16R2 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen17R2 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen18R2 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;

            const hasChoosen15R3 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen16R3 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen17R3 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen18R3 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;

            let question15_1SelectedIds = this.question15_1.responses.filter(r => r.selected);
            let question16_1SelectedIds = this.question16_1.responses.filter(r => r.selected);
            let question17_1SelectedIds = this.question17_1.responses.filter(r => r.selected);
            let question18_1SelectedIds = this.question18_1.responses.filter(r => r.selected);

            let question15_2SelectedIds = this.question15_2.responses.filter(r => r.selected);
            let question16_2SelectedIds = this.question16_2.responses.filter(r => r.selected);
            let question17_2SelectedIds = this.question17_2.responses.filter(r => r.selected);
            let question18_2SelectedIds = this.question18_2.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && ((hasChoosen15R2 && question15_1SelectedIds.length != 0) || (hasChoosen15R3 && question15_2SelectedIds.length != 0) || hasChoosen15R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && ((hasChoosen16R2 && question16_1SelectedIds.length != 0) || (hasChoosen16R3 && question16_2SelectedIds.length != 0) || hasChoosen16R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && ((hasChoosen17R2 && question17_1SelectedIds.length != 0) || (hasChoosen17R3 && question17_2SelectedIds.length != 0) || hasChoosen17R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && ((hasChoosen18R2 && question18_1SelectedIds.length != 0) || (hasChoosen18R3 && question18_2SelectedIds.length != 0) || hasChoosen18R1)) numberOfQuestionAnswered += 1;

            })

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && ((hasChoosen15R2 && question15_1SelectedIds.length != 0) || (hasChoosen15R3 && question15_2SelectedIds.length != 0) || hasChoosen15R1 || this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Tutun rulat' && ((hasChoosen16R2 && question16_1SelectedIds.length != 0) || (hasChoosen16R3 && question16_2SelectedIds.length != 0) || hasChoosen16R1 || this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && ((hasChoosen17R2 && question17_1SelectedIds.length != 0) || (hasChoosen17R3 && question17_2SelectedIds.length != 0) || hasChoosen17R1 || this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && ((hasChoosen18R2 && question18_1SelectedIds.length != 0) || (hasChoosen18R3 && question18_2SelectedIds.length != 0) || hasChoosen18R1 || this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;

            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosen15R1 || hasChoosen15R2 || hasChoosen15R3) hasChoosenOneOfFirstThree.push('Țigarete (țigarete convenționale, în pachet)')
            if (hasChoosen16R1 || hasChoosen16R2 || hasChoosen16R3) hasChoosenOneOfFirstThree.push('Tutun rulat')
            if (hasChoosen17R1 || hasChoosen17R2 || hasChoosen17R3) hasChoosenOneOfFirstThree.push('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')
            if (hasChoosen18R1 || hasChoosen18R2 || hasChoosen18R3) hasChoosenOneOfFirstThree.push('Pliculețe cu nicotină (Pouch-uri cu nicotină)')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && (question17_1SelectedIds?.length > 0 || question17_2SelectedIds?.length > 0 || (hasChoosen17R1 && selectedBrandsAtQuestion14.length == allquestionAnswered))) {
                return true;
            } else {
                this.question21.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question22 = new Question(97, [this.question18_1.id],
            'De cât timp folosești pliculețe cu nicotină (Pouch-uri cu nicotină)?',
            'Bifează un singur răspuns',
            'radio',
            [new Response(1, 'Mai puțin de o lună'),
            new Response(2, '1 - 2 luni'),
            new Response(3, '2 - 3 luni'),
            new Response(4, '3 - 6 luni'),
            new Response(5, '6 luni - 1 an'),
            new Response(6, '1 - 2 ani'),
            new Response(7, '2 - 3 ani'),
            new Response(8, '3 - 5 ani'),
            new Response(9, 'Mai mult de 5 ani')],
            false,
            'vertical'
        );

        this.question22.render = () => {
            if (this.endgame == true) { return false; }

            const legalSmokingAge = 18; // Vârsta legală pentru a începe să fumezi
            const yearsSinceLegalSmoking = this.keepAge - legalSmokingAge; // Ani de când utilizatorul are voie să fumeze

            // Definim o funcție care determină răspunsurile pe care le putem afișa în funcție de ani de fumat legal
            const getRelevantResponses = (years: number) => {
                if (years < 0.5) { // Dacă utilizatorul poate fuma de mai puțin de 6 luni
                    return [1, 2, 3, 4, 5]; // Afișăm primele 3 opțiuni
                } else if (years < 1) { // Dacă poate fuma de mai puțin de 1 an
                    return [1, 2, 3, 4, 5]; // Afișăm opțiunile 1-4
                } else if (years < 2) { // Dacă poate fuma de mai puțin de 2 ani
                    return [1, 2, 3, 4, 5, 6]; // Afișăm opțiunile 1-6
                } else if (years < 3) { // Dacă poate fuma de mai puțin de 3 ani
                    return [1, 2, 3, 4, 5, 6, 7]; // Afișăm opțiunile 1-7
                } else if (years < 5) { // Dacă poate fuma de mai puțin de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8]; // Afișăm opțiunile 1-8
                } else { // Dacă poate fuma de mai mult de 5 ani
                    return [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Afișăm toate opțiunile
                }
            };

            // Obținem lista de ID-uri relevante
            const relevantResponseIds = getRelevantResponses(yearsSinceLegalSmoking);

            // Filtrăm răspunsurile pentru a afișa doar pe cele relevante
            this.question22.responses = this.question22.responses.filter(response =>
                relevantResponseIds.includes(response.id)
            );
            const hasChoosen15R1 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen16R1 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen17R1 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;
            const hasChoosen18R1 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 1;

            const hasChoosen15R2 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen16R2 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen17R2 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;
            const hasChoosen18R2 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 2;

            const hasChoosen15R3 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen16R3 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen17R3 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;
            const hasChoosen18R3 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id == 3;

            let question15_1SelectedIds = this.question15_1.responses.filter(r => r.selected);
            let question16_1SelectedIds = this.question16_1.responses.filter(r => r.selected);
            let question17_1SelectedIds = this.question17_1.responses.filter(r => r.selected);
            let question18_1SelectedIds = this.question18_1.responses.filter(r => r.selected);

            let question15_2SelectedIds = this.question15_2.responses.filter(r => r.selected);
            let question16_2SelectedIds = this.question16_2.responses.filter(r => r.selected);
            let question17_2SelectedIds = this.question17_2.responses.filter(r => r.selected);
            let question18_2SelectedIds = this.question18_2.responses.filter(r => r.selected);

            let numberOfQuestionAnswered = 0;
            let allquestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && ((hasChoosen15R2 && question15_1SelectedIds.length != 0) || (hasChoosen15R3 && question15_2SelectedIds.length != 0) || hasChoosen15R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && ((hasChoosen16R2 && question16_1SelectedIds.length != 0) || (hasChoosen16R3 && question16_2SelectedIds.length != 0) || hasChoosen16R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && ((hasChoosen17R2 && question17_1SelectedIds.length != 0) || (hasChoosen17R3 && question17_2SelectedIds.length != 0) || hasChoosen17R1)) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && ((hasChoosen18R2 && question18_1SelectedIds.length != 0) || (hasChoosen18R3 && question18_2SelectedIds.length != 0) || hasChoosen18R1)) numberOfQuestionAnswered += 1;

            })

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && ((hasChoosen15R2 && question15_1SelectedIds.length != 0) || (hasChoosen15R3 && question15_2SelectedIds.length != 0) || hasChoosen15R1 || this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Tutun rulat' && ((hasChoosen16R2 && question16_1SelectedIds.length != 0) || (hasChoosen16R3 && question16_2SelectedIds.length != 0) || hasChoosen16R1 || this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && ((hasChoosen17R2 && question17_1SelectedIds.length != 0) || (hasChoosen17R3 && question17_2SelectedIds.length != 0) || hasChoosen17R1 || this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && ((hasChoosen18R2 && question18_1SelectedIds.length != 0) || (hasChoosen18R3 && question18_2SelectedIds.length != 0) || hasChoosen18R1 || this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id >= 4)) allquestionAnswered += 1;

            })
            const hasChoosenOneOfFirstThree = [];
            if (hasChoosen15R1 || hasChoosen15R2 || hasChoosen15R3) hasChoosenOneOfFirstThree.push('Țigarete (țigarete convenționale, în pachet)')
            if (hasChoosen16R1 || hasChoosen16R2 || hasChoosen16R3) hasChoosenOneOfFirstThree.push('Tutun rulat')
            if (hasChoosen17R1 || hasChoosen17R2 || hasChoosen17R3) hasChoosenOneOfFirstThree.push('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')
            if (hasChoosen18R1 || hasChoosen18R2 || hasChoosen18R3) hasChoosenOneOfFirstThree.push('Pliculețe cu nicotină (Pouch-uri cu nicotină)')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis && (question18_1SelectedIds?.length > 0 || question18_2SelectedIds?.length > 0 || (hasChoosen18R1 && selectedBrandsAtQuestion14.length == allquestionAnswered))) {
                return true;
            } else {
                this.question22.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }




        // (2.4) 
        this.question23 = new Question(98, [this.question14.id],
            'Pe care dintre următoarele le-ai folosit în ultimele 7 zile?',
            '',
            'checkbox',
            [new Response(1, 'Țigarete (țigarete convenționale, în pachet)', [], './assets/images/rmc.png'),
            new Response(2, 'Tutun rulat', [], './assets/images/fct.png'),
            new Response(3, 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri', [], './assets/images/ecig.png'),
            new Response(4, 'Pliculețe cu nicotină (Pouch-uri cu nicotină)', [], './assets/images/nic.png')
            ],
            false,
            'horizontal',
            '',
            2
        );


        this.question23.render = () => {
            if (this.endgame == true) { return false; }
            let question15SelectedIds = this.question19.responses.filter(r => r.selected);
            let question16SelectedIds = this.question20.responses.filter(r => r.selected);
            let question17SelectedIds = this.question21.responses.filter(r => r.selected);
            let question18SelectedIds = this.question22.responses.filter(r => r.selected);


            const hasChoosenQuestion15 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenQuestion16 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenQuestion17 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenQuestion18 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;


            let rendererQ15 = (rsp: Response): boolean => {
                return hasChoosenQuestion15;
            }

            let rendererQ16 = (rsp: Response): boolean => {
                return hasChoosenQuestion16;
            }
            let rendererQ17 = (rsp: Response): boolean => {
                return hasChoosenQuestion17;

            }
            let rendererQ18 = (rsp: Response): boolean => {
                return hasChoosenQuestion18;

            }
            this.question23.responses[0].render = rendererQ15;
            this.question23.responses[1].render = rendererQ16;
            this.question23.responses[2].render = rendererQ17;
            this.question23.responses[3].render = rendererQ18;

            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && question15SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && question16SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && question17SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && question18SelectedIds.length != 0) numberOfQuestionAnswered += 1;

            })

            const hasChoosenOneOfFirstThree = [];
            if (hasChoosenQuestion15) hasChoosenOneOfFirstThree.push('Țigarete (țigarete convenționale, în pachet)')
            if (hasChoosenQuestion16) hasChoosenOneOfFirstThree.push('Tutun rulat')
            if (hasChoosenQuestion17) hasChoosenOneOfFirstThree.push('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')
            if (hasChoosenQuestion18) hasChoosenOneOfFirstThree.push('Pliculețe cu nicotină (Pouch-uri cu nicotină)')


            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == hasChoosenOneOfFirstThree.length;

            if (hasAnsweredAllQuestionsBeforeShowingThis
                && (hasChoosenQuestion15 || hasChoosenQuestion16 || hasChoosenQuestion17 || hasChoosenQuestion18)) {
                return true;
            } else {
                this.question23.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (2.5) OTHER CATEGORY BRAND / DEVICE USAGE
        //RMC:  a
        this.question24 = new Question(99, [this.question15.id],
            'Câte țigarete (țigarete convenționale, în pachet) fumezi în medie pe zi? Număr de țigarete:',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }

        );
        this.question24.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenQ15 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let question23SelectedIds = this.question23.responses.filter(r => r.selected).map(resp => resp.text);
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);

            if (question23SelectedIds.length > 0 && hasChoosenQ15 && question14SelectedIds.includes('Țigarete (țigarete convenționale, în pachet)')) {
                return true;

            } else {
                this.question24.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }



        // b
        this.question25 = new Question(100, [this.question24.id],
            'Ce marcă de țigarete (țigarete convenționale, în pachet) fumezi CEL MAI DES?',
            '',
            'radio-free',
            this.question25Responses,
            false,
            'horizontal'
        );

        this.question25.render = () => {
            if (this.endgame == true) { return false; }
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);
            let question24SelectedIds = this.question24.responses.filter(r => r.id);
            let question25SelectedIds = this.question25.responses.filter(r => r.selected)

            // console.log("aaaaaaa: ", question17SelectedIds);
            if (!question25SelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question25.responses && this.question25.responses[51]) {
                    this.question25.responses[51].freeMessage = "";
                }
            }

            if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Țigarete (țigarete convenționale, în pachet)') && question24SelectedIds.length > 0 && (parseInt(question24SelectedIds[0].freeMessage) >= 1 && parseInt(question24SelectedIds[0].freeMessage) <= 100)) {
                return true;
            } else {
                this.question25.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        //FCT
        //c
        this.question26 = new Question(101, [this.question16.id],
            'În medie, câte țigarete cu tutun rulate de tine în foițe sau cu ajutorul unor tuburi speciale fumezi pe zi? Număr de țigarete cu tutun rulat:',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }

        );
        this.question26.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenQ16 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenQ15 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;



            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);

            let question23SelectedIds = this.question23.responses.filter(r => r.selected);
            let question25SelectedIds = this.question25.responses.filter(r => r.selected)

            if (hasChoosenQ16 && hasChoosenQ15 && question14SelectedIds.includes('Tutun rulat')) {
                if (question25SelectedIds.length > 0 && question25SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question25.responses?.[51].freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question25SelectedIds.length > 0 && !question25SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;

                }
            } else if (hasChoosenQ16 && question14SelectedIds.includes('Tutun rulat')) {
                return question23SelectedIds.length > 0
            } else {
                this.question26.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;

        }


        // d
        this.question27 = new Question(102, [this.question26.id],
            'Ce marcă de tutun rulat fumezi CEL MAI DES?',
            '',
            'radio-free',
            this.question27Responses,
            false,
            'vertical'
        );
        this.question27.render = () => {
            if (this.endgame == true) { return false; }
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);
            let question26SelectedIds = this.question26.responses.filter(r => r.id);
            let question27SelectedIds = this.question27.responses.filter(r => r.selected)

            if (!question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question27.responses && this.question27.responses[30]) {
                    this.question27.responses[30].freeMessage = "";
                }
            }

            if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Tutun rulat') && question26SelectedIds.length > 0 && (parseInt(question26SelectedIds[0].freeMessage) >= 1 && parseInt(question26SelectedIds[0].freeMessage) <= 100)) {
                return true;
            } else {
                this.question27.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        //Nicotine Pouches: 
        //e
        this.question28 = new Question(103, [this.question18.id],
            'În medie, câte pliculețe cu nicotină (Pouch-uri cu nicotină) folosești pe zi? Număr de pliculețe cu nicotină (Pouch-uri cu nicotină):',
            '',
            'free-number-warning',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 1, max: 100 }
        );
        this.question28.render = () => {
            if (this.endgame == true) { return false; }

            let question23SelectedIds = this.question23.responses.filter(r => r.selected);

            // return question23SelectedIds.length > 0 && hasChoosenQ17;

            const hasChoosenQ18 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            const hasChoosenQ16 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenQ15 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);

            let question25SelectedIds = this.question25.responses.filter(r => r.selected)
            let question27SelectedIds = this.question27.responses.filter(r => r.selected)

            // de aici
            if (hasChoosenQ18 && hasChoosenQ15 && hasChoosenQ16 && question14SelectedIds.includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)')) {
                if (question27SelectedIds.length > 0 && question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question27.responses?.[30].freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question27SelectedIds.length > 0 && !question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;

                }
            } else if (hasChoosenQ18 && hasChoosenQ16 && question14SelectedIds.includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)')) {
                if (question27SelectedIds.length > 0 && question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question27.responses?.[30].freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question27SelectedIds.length > 0 && !question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;

                }
            } else if (hasChoosenQ18 && hasChoosenQ15 && question14SelectedIds.includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)')) {
                if (question25SelectedIds.length > 0 && question25SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question25.responses?.[51].freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question25SelectedIds.length > 0 && !question25SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;

                }
            } else if (hasChoosenQ18 && question14SelectedIds.includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)')) {
                return question23SelectedIds.length > 0
            } else {
                return false
            }
            return false;
        }




        // f
        this.question29 = new Question(104, [this.question28.id],
            'Ce marcă de pliculețe cu nicotină (Pouch-uri cu nicotină) folosești CEL MAI DES?',
            '',
            'radio-free',
            this.question29Responses,
            false
        );
        this.question29.render = () => {
            if (this.endgame == true) { return false; }
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);
            let question28SelectedIds = this.question28.responses.filter(r => r.id);
            // console.log("aaaaaaa: ", question17SelectedIds);
            let question29SelectedIds = this.question29.responses.filter(r => r.selected)

            if (!question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question29.responses && this.question29.responses[24]) {
                    this.question29.responses[24].freeMessage = "";
                }
            }


            return question14SelectedIds.length > 0 && question14SelectedIds.includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)') && question28SelectedIds.length > 0 && (parseInt(question28SelectedIds[0].freeMessage) >= 1 && parseInt(question28SelectedIds[0].freeMessage) <= 100);
        }


        //Electronic Cigarettes Products (E-vape): 
        //g
        this.question30 = new Question(105, [this.question17.id],
            'Ce tipuri de țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri ai încercat vreodată?',
            '',
            'checkbox',
            this.question30Responses,
            false,
            'vertical',
            '',
            2
        );
        // console.log('OBIECT:', this.question30Responses)

        this.question30.render = () => {
            if (this.endgame == true) { return false; }

            const hasChoosenQ18 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenQ17 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            const hasChoosenQ16 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenQ15 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            let question23SelectedIds = this.question23.responses.filter(r => r.selected)
            let question25SelectedIds = this.question25.responses.filter(r => r.selected)
            let question27SelectedIds = this.question27.responses.filter(r => r.selected)
            let question29SelectedIds = this.question29.responses.filter(r => r.selected)

            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);


            if (hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ15 && hasChoosenQ16 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')) {
                if (question29SelectedIds.length > 0 && question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question29.responses?.[24].freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question29SelectedIds.length > 0 && !question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;

                }
            } else if (hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ16 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')) {
                if (question29SelectedIds.length > 0 && question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question29.responses?.[24].freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question29SelectedIds.length > 0 && !question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;

                }
            } else if (hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ15 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')) {
                if (question29SelectedIds.length > 0 && question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question29.responses?.[24].freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question29SelectedIds.length > 0 && !question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;

                }
            } else if (hasChoosenQ17 && hasChoosenQ16 && hasChoosenQ15 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')) {
                if (question27SelectedIds.length > 0 && question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question27.responses?.[30].freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question27SelectedIds.length > 0 && !question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;

                }
            } else if (hasChoosenQ18 && hasChoosenQ17 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')) {
                if (question29SelectedIds.length > 0 && question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question29.responses?.[24].freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question29SelectedIds.length > 0 && !question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;

                }
            } else if (hasChoosenQ17 && hasChoosenQ16 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')) {
                if (question27SelectedIds.length > 0 && question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question27.responses?.[30].freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question27SelectedIds.length > 0 && !question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;

                }
            } else if (hasChoosenQ17 && hasChoosenQ15 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')) {
                if (question25SelectedIds.length > 0 && question25SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question25.responses?.[51].freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question25SelectedIds.length > 0 && !question25SelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;

                }
            } else if (hasChoosenQ17) {
                return question23SelectedIds.length > 0
            } else {
                this.question30.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        // h
        this.question31 = new Question(106, [this.question30.id],
            'Ce tip de țigarete electronice (de unică folosință, cu capsule sau rezervor) folosești CEL MAI DES?',
            '',
            'radio',
            this.question31Responses,
            false,
            'vertical'
        );
        this.question31.render = () => {
            if (this.endgame == true) { return false; }

            let question31ResponseRenderer = (rsp: Response): boolean => {
                if (this.endgame == true) { return false; }
                let question30SelectedIds = this.question30.responses.filter(r => r.selected).map(r => r.id);
                return question30SelectedIds.indexOf(rsp.id) >= 0;
            }


            this.question31.responses[0].render = question31ResponseRenderer;
            this.question31.responses[1].render = question31ResponseRenderer;
            this.question31.responses[2].render = question31ResponseRenderer;

            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);
            let question30SelectedIds = this.question30.responses.filter(r => r.selected);
            // console.log("aaaaaaa111111: ", question30SelectedIds);

            if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && question30SelectedIds.length > 1) {
                return true;
            } else {
                this.question31.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }



        // i
        this.question32_a = new Question(107, [this.question31.id],
            'Ce marcă de țigări electronice de unică folosință folosești CEL MAI DES?',
            '',
            'radio-free',
            this.question32_aResponses,
            false,
            'vertical'
        );
        this.question32_a.render = () => {
            if (this.endgame == true) { return false; }
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);
            let question31SelectedIds = this.question31.responses.filter(r => r.selected).map(resp => resp.text);
            let question30SelectedIds = this.question30.responses.filter(r => r.selected).map(resp => resp.text);

            let question32_aSelectedIds = this.question32_a.responses.filter(r => r.selected)

            if (!question32_aSelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question32_a.responses && this.question32_a.responses[30]) {
                    this.question32_a.responses[30].freeMessage = "";
                }
            }
            if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && question31SelectedIds.length > 0 && question31SelectedIds.includes('Țigări electronice de unică folosință')) {
                return true;
            } else if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && question30SelectedIds.length == 1 && question30SelectedIds.includes('Țigări electronice de unică folosință')) {
                return true;
            } else {
                this.question32_a.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }

        this.question32_b = new Question(108, [this.question31.id],
            'Ce marcă de vaporizatoare/țigări electronice cu rezervor încorporat re-încărcabil folosești CEL MAI DES?',
            '',
            'radio-free',
            this.question32_bResponses,
            false,
            'vertical'
        );
        this.question32_b.render = () => {
            if (this.endgame == true) { return false; }
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);
            let question31SelectedIds = this.question31.responses.filter(r => r.selected).map(resp => resp.text);
            let question30SelectedIds = this.question30.responses.filter(r => r.selected).map(resp => resp.text);

            let question32_bSelectedIds = this.question32_b.responses.filter(r => r.selected)

            if (!question32_bSelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question32_b.responses && this.question32_b.responses[9]) {
                    this.question32_b.responses[9].freeMessage = "";
                }
            }

            // console.log("aaaaaaa23222: ", question31SelectedIds);
            if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && question31SelectedIds.length > 0 && question31SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                return true;
            } else if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && question30SelectedIds.length == 1 && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                return true;
            } else {
                this.question32_b.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }

        this.question32_c = new Question(109, [this.question31.id],
            'Ce marcă de Țigarete electronice cu pod-uri/capsule cu lichid folosești CEL MAI DES?',
            '',
            'radio-free',
            this.question32_cResponses,
            false,
            'vertical'
        );
        this.question32_c.render = () => {
            if (this.endgame == true) { return false; }
            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text);
            let question31SelectedIds = this.question31.responses.filter(r => r.selected).map(resp => resp.text);
            let question30SelectedIds = this.question30.responses.filter(r => r.selected).map(resp => resp.text);


            let question32_cSelectedIds = this.question32_c.responses.filter(r => r.selected)

            if (!question32_cSelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question32_c.responses && this.question32_c.responses[10]) {
                    this.question32_c.responses[10].freeMessage = "";
                }
            }
            // console.log("aaaaaaa23222: ", question31SelectedIds);
            // console.log("aaaaaaa23222: ", question31SelectedIds);
            if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && question31SelectedIds.length > 0 && question31SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                return true;
            } else if (question14SelectedIds.length > 0 && question14SelectedIds.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && question30SelectedIds.length == 1 && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                return true;
            } else {
                this.question32_c.responses.forEach(r => {
                    r.selected = false;
                });


            }
            return false;
        }



        //j
        this.question33 = new Question(110, [this.question30.id],
            'În medie, câte țigarete electronice de unică folosință folosești pe săptămână? Număr de țigarete electronice de unică folosință:',
            '',
            'free-number-warning-reset',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 0, max: 35 }

        );
        this.question33.render = () => {
            if (this.endgame == true) { return false; }

            let question30SelectedIds = this.question30.responses.filter(r => r.selected).map(resp => resp.text);
            let question32_aSelectedIds = this.question32_a.responses.filter(r => r.selected)
            let question32_bSelectedIds = this.question32_b.responses.filter(r => r.selected)
            let question32_cSelectedIds = this.question32_c.responses.filter(r => r.selected)
            let question31SelectedIds = this.question31.responses.filter(r => r.selected).map(resp => resp.text);


            if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid') && question31SelectedIds.length > 0) {
                if (question31SelectedIds.includes('Țigări electronice de unică folosință')) {
                    this.question33.description = '';
                    this.question33.warning.min = 1
                    if (question32_aSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question32_a.responses?.[30]?.freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question32_aSelectedIds.length > 0 && !question32_aSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question31SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                    this.question33.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';
                    if (question32_bSelectedIds.map(r => r.text).includes('Altă variantă')) {
                        if (this.question32_b.responses?.[9]?.freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question32_bSelectedIds.length > 0 && !question32_bSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question31SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                    this.question33.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';
                    if (question32_cSelectedIds.map(r => r.text).includes('Altă variantă')) {
                        if (this.question32_c.responses?.[10]?.freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question32_cSelectedIds.length > 0 && !question32_cSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;
                    } else {
                        return false;
                    }
                }

            } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question31SelectedIds.length > 0) {

                if (question31SelectedIds.includes('Țigări electronice de unică folosință')) {
                    this.question33.description = '';
                    this.question33.warning.min = 1
                    if (question32_aSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question32_a.responses?.[30]?.freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question32_aSelectedIds.length > 0 && !question32_aSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question31SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                    this.question33.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';
                    if (question32_bSelectedIds.map(r => r.text).includes('Altă variantă')) {
                        if (this.question32_b.responses?.[9]?.freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question32_bSelectedIds.length > 0 && !question32_bSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid') && question31SelectedIds.length > 0) {


                if (question31SelectedIds.includes('Țigări electronice de unică folosință')) {
                    this.question33.description = '';
                    this.question33.warning.min = 1
                    if (question32_aSelectedIds.map(r => r.text).includes('Altă variantă')) {
                        if (this.question32_a.responses?.[30]?.freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question32_aSelectedIds.length > 0 && !question32_aSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question31SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                    this.question33.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';

                    if (question32_cSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question32_c.responses?.[10]?.freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question32_cSelectedIds.length > 0 && !question32_cSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;
                    } else {
                        return false;
                    }
                }

            } else if (question30SelectedIds.length == 1 && question30SelectedIds.includes('Țigări electronice de unică folosință')) {
                this.question33.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';


                // console.log('question32_aSelectedIds.map(r => r.text):', question32_aSelectedIds)

                if (question32_aSelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question32_a.responses?.[30]?.freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question32_aSelectedIds.length > 0 && !question32_aSelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;
                } else {
                    return false;
                }

            } else {
                this.question33.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;
        }

        //k
        this.question34 = new Question(111, [this.question30.id],
            'În medie, câte sticluțe cu lichid pentru țigarete electronice reîncărcabile/Vaporizatoare/Țigarete electronice cu rezervor încorporat reîncărcabil, folosiți în medie pe săptămână? Număr de sticluțe cu lichid:',
            '',
            'free-number-warning-reset',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 0, max: 5 }

        );
        this.question34.render = () => {
            if (this.endgame == true) { return false; }

            let question30SelectedIds = this.question30.responses.filter(r => r.selected).map(resp => resp.text);
            let question32_aSelectedIds = this.question32_a.responses.filter(r => r.selected)

            let question32_bSelectedIds = this.question32_b.responses.filter(r => r.selected)
            let question32_cSelectedIds = this.question32_c.responses.filter(r => r.selected)
            let question33SelectedIds = parseInt(this.question33.responses?.[0].freeMessage);
            let question31SelectedIds = this.question31.responses.filter(r => r.selected).map(resp => resp.text);




            // if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
            //     return question33SelectedIds > 0;
            // } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
            //     return question32_aSelectedIds.length > 0 || question32_bSelectedIds.length > 0 || question32_cSelectedIds.length > 0
            // } else {
            //     this.question34.responses.forEach(r => {
            //         r.freeMessage = '';
            //     });
            // }
            // return false;

            if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid') && question31SelectedIds.length > 0) {
                if (question31SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                    this.question34.warning.min = 1
                } else {
                    this.question34.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';
                }
                if (question33SelectedIds >= 0) {
                    return true


                } else { return false; }

            } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question31SelectedIds.length > 0) {
                if (question31SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                    this.question34.warning.min = 1
                }
                else {
                    this.question34.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';

                }
                if (question33SelectedIds >= 0) {
                    return true
                } else { return false; }

            } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid') && question31SelectedIds.length > 0) {

                if (question31SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                    this.question34.warning.min = 1

                    if (question32_bSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question32_b.responses?.[9]?.freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question32_bSelectedIds.length > 0 && !question32_bSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question31SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                    this.question34.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';

                    if (question32_cSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question32_c.responses?.[10]?.freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question32_cSelectedIds.length > 0 && !question32_cSelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else if (question30SelectedIds.length == 1 && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                this.question34.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';

                if (question32_bSelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question32_b.responses?.[9]?.freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question32_bSelectedIds.length > 0 && !question32_bSelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;
                } else {
                    return false;
                }

            }

            else {
                this.question34.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;

        };

        //l
        this.question35 = new Question(112, [this.question30.id],
            'În medie, câte capsule folosești pe săptămână? Număr de capsule:',
            '',
            'free-number-warning-reset',
            [new Response(1, '')],
            false,
            'horizontal',
            { min: 0, max: 35 }

        );
        this.question35.render = () => {
            if (this.endgame == true) { return false; }

            let question30SelectedIds = this.question30.responses.filter(r => r.selected).map(resp => resp.text);
            let question31SelectedIds = this.question31.responses.filter(r => r.selected).map(resp => resp.text);

            let question32_aSelectedIds = this.question32_a.responses.filter(r => r.selected)
            let question32_bSelectedIds = this.question32_b.responses.filter(r => r.selected)
            let question32_cSelectedIds = this.question32_c.responses.filter(r => r.selected)
            let question34SelectedIds = parseInt(this.question34.responses?.[0].freeMessage);
            let question33SelectedIds = parseInt(this.question33.responses?.[0].freeMessage);

            let question33IsRendered = this.question33.render();
            let question34IsRendered = this.question34.render();



            if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid') && question31SelectedIds.length > 0) {
                if (question31SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                    this.question35.warning.min = 1
                } else {
                    this.question35.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';

                }
                if (question34SelectedIds >= 0) {
                    return true
                }

                else { return false; }

            } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid') && question31SelectedIds.length > 0) {
                if (question31SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                    this.question35.warning.min = 1
                }
                else {
                    this.question35.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';

                }
                if (question33SelectedIds >= 0) {
                    return true
                }
                else { return false; }

            } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid') && question31SelectedIds.length > 0) {
                if (question31SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                    this.question35.warning.min = 1
                } else {
                    this.question35.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';

                }
                if (question34SelectedIds >= 0) {
                    return true

                } else { return false; }

            } else if (question30SelectedIds.length == 1 && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                this.question35.description = 'Puteți scrie 0 dacă nu mai utilizați în prezent';

                if (question32_cSelectedIds.map(r => r.text).includes('Altă marcă')) {
                    if (this.question32_c.responses?.[10]?.freeMessage) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (question32_cSelectedIds.length > 0 && !question32_cSelectedIds.map(r => r.text).includes('Altă marcă')) {
                    return true;
                } else {
                    return false;
                }

            } else {
                this.question35.responses.forEach(r => {
                    r.freeMessage = '';
                });
            }
            return false;

        }
        // (3.1) MAIN BRAND OUT OF ALL BRANDS USED MENTIONED
        this.question36 = new Question(113, [this.question25.id, this.question27.id, this.question30.id, this.question32_a.id, this.question32_b.id, this.question32_c.id],
            'Ați menționat că folosiți următoarele mărci. Vă rugăm să selectați marca pe care o folosiți CEL MAI DES și pe care o considerați ca fiind marcă principală',
            'Te rugăm să selectezi o singură marcă',
            'radio',
            this.question36Responses,
            false,
            'vertical'
        );

        this.question36.render = () => {
            if (this.endgame === true) { return false; }


            const selectedIdsPloomQuestion4 = this.question4.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion4_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion4_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion4_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion4_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected);
            const selectedIdsiQuestion4_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected);
            const selectedIdsiQuestion4_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion4_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion4_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected);
            const selectedIdsQuestion4_lil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected);


            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            let question23SelectedIds = this.question23.responses.filter(r => r.selected)


            const hasChoosenQ18 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenQ17 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenQ16 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenQ15 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            const selectedAnswersQ25 = this.question25.responses.filter(r => r.selected);
            const selectedAnswersQ27 = this.question27.responses.filter(r => r.selected);
            const selectedAnswersQ29 = this.question29.responses.filter(r => r.selected);
            const selectedAnswersQ32_a = this.question32_a.responses.filter(r => r.selected);
            const selectedAnswersQ32_b = this.question32_b.responses.filter(r => r.selected);
            const selectedAnswersQ32_c = this.question32_c.responses.filter(r => r.selected);


            let question30SelectedIds = this.question30.responses.filter(r => r.selected).map(resp => resp.text);
            let question33SelectedIds = parseInt(this.question33.responses?.[0].freeMessage);
            let question34SelectedIds = parseInt(this.question34.responses?.[0].freeMessage);
            let question35SelectedIds = parseInt(this.question35.responses?.[0].freeMessage);
            let question25SelectedIds = this.question25.responses.filter(r => r.selected)
            let question27SelectedIds = this.question27.responses.filter(r => r.selected)
            let question29SelectedIds = this.question29.responses.filter(r => r.selected)




            let question14SelectedIds = this.question14.responses.filter(r => r.selected);
            let question14Selections = question14SelectedIds.map(resp => resp.text);
            let question3SelectedIds = this.question3.responses.filter(r => r.selected);
            let question3Selections = question3SelectedIds.map(resp => resp.text);


            const hasRender15 = this.question15.render()
            const hasResonseTo15 = this.question15.responses.filter(r => r.selected)


            if (selectedAnswersQ25.length > 0 && selectedAnswersQ25.map(r => r.text).includes('Altă marcă') && this.question25.responses?.[51].freeMessage) {

                this.question36Responses[160].text = this.question25.responses?.[51].freeMessage
            }


            if (selectedAnswersQ27.length > 0 && selectedAnswersQ27.map(r => r.text).includes('Altă marcă') && this.question27.responses?.[30].freeMessage) {

                this.question36Responses[161].text = this.question27.responses?.[30].freeMessage
            }


            if (selectedAnswersQ29.length > 0 && selectedAnswersQ29.map(r => r.text).includes('Altă marcă') && this.question29.responses?.[24].freeMessage) {

                this.question36Responses[162].text = this.question29.responses?.[24].freeMessage
            }


            if (selectedAnswersQ32_a.length > 0 && selectedAnswersQ32_a.map(r => r.text).includes('Altă marcă') && this.question32_a.responses?.[30].freeMessage && this.question33.render()) {

                this.question36Responses[163].text = this.question32_a.responses?.[30].freeMessage

            }


            if (selectedAnswersQ32_b.length > 0 && selectedAnswersQ32_b.map(r => r.text).includes('Altă marcă') && this.question32_b.responses?.[9].freeMessage && this.question34.render()) {

                this.question36Responses[163].text = this.question32_b.responses?.[9].freeMessage

            }

            if (selectedAnswersQ32_c.length > 0 && selectedAnswersQ32_c.map(r => r.text).includes('Altă marcă') && this.question32_c.responses?.[10].freeMessage && this.question35.render()) {

                this.question36Responses[163].text = this.question32_c.responses?.[10].freeMessage

            }


            for (let i = 0; i < this.question36Responses.length; i++) {
                this.question36Responses[i].render = () => false;

                if (question14Selections.includes('Țigarete (țigarete convenționale, în pachet)') && selectedAnswersQ25.length > 0) {
                    if (selectedAnswersQ25.map(resp => resp.text).includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }

                if (question14Selections.includes('Țigarete (țigarete convenționale, în pachet)') && selectedAnswersQ25.map(r => r.text).includes('Altă marcă') && this.question25.responses?.[51].freeMessage) {
                    if (this.question25.responses?.[51].freeMessage.includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }


                if (question14Selections.includes('Tutun rulat') && selectedAnswersQ27.length > 0) {
                    if (selectedAnswersQ27.map(resp => resp.text).includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }

                if (question14Selections.includes('Tutun rulat') && selectedAnswersQ27.map(r => r.text).includes('Altă marcă') && this.question27.responses?.[30].freeMessage) {
                    if (this.question27.responses?.[30].freeMessage.includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }

                if (question14Selections.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && selectedAnswersQ32_a.length > 0 && !selectedAnswersQ32_a.map(r => r.text).includes('Altă marcă')) {
                    if (selectedAnswersQ32_a.map(resp => resp.text).includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }

                if (question14Selections.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && selectedAnswersQ32_b.length > 0 && !selectedAnswersQ32_b.map(r => r.text).includes('Altă marcă')) {
                    if (selectedAnswersQ32_b.map(resp => resp.text).includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }

                if (question14Selections.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && selectedAnswersQ32_c.length > 0 && !selectedAnswersQ32_c.map(r => r.text).includes('Altă marcă')) {
                    if (selectedAnswersQ32_c.map(resp => resp.text).includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }

                if (question14Selections.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && selectedAnswersQ32_a.map(r => r.text).includes('Altă marcă') && this.question32_a.responses?.[30].freeMessage && this.question33.render()) {
                    if (this.question32_a.responses?.[30].freeMessage.includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }
                if (question14Selections.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && selectedAnswersQ32_b.map(r => r.text).includes('Altă marcă') && this.question32_b.responses?.[9].freeMessage && this.question34.render()) {
                    if (this.question32_b.responses?.[9].freeMessage.includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }


                if (question14Selections.includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri') && selectedAnswersQ32_c.map(r => r.text).includes('Altă marcă') && this.question32_c.responses?.[10].freeMessage && this.question35.render()) {
                    if (this.question32_c.responses?.[10].freeMessage.includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }



                if (question14Selections.includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)') && selectedAnswersQ29.length > 0) {
                    if (selectedAnswersQ29.map(resp => resp.text).includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }


                if (question14Selections.includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)') && selectedAnswersQ29.map(r => r.text).includes('Altă marcă') && this.question29.responses?.[24].freeMessage) {
                    if (this.question29.responses?.[24].freeMessage.includes(this.question36Responses[i].text)) {
                        this.question36Responses[i].render = () => true;

                    }
                }


                if (question3Selections.includes('Ploom') && selectedIdsPloomQuestion4.length > 0 && hasChoosenPloom) {
                    if (this.question36Responses[i].text.includes('Ploom')) {
                        this.question36Responses[i].render = () => true;
                    }
                }
                // if (question3Selections.includes('IQOS Iluma') && selectedIdsiQuestion4_iluma.length > 0 && hasChoosenIqos_iluma) {
                //     if (this.question36Responses[i].text.includes('IQOS Iluma')) {
                //         this.question36Responses[i].render = () => true;
                //     }
                // }
                // if (question3Selections.includes('IQOS Iluma One') && selectedIdsiQuestion4_one.length > 0 && hasChoosenIqos_iluma_one) {
                //     if (this.question36Responses[i].text.includes('IQOS Iluma One')) {
                //         this.question36Responses[i].render = () => true;
                //     }
                // }
                // if (question3Selections.includes('IQOS Iluma Prime') && selectedIdsQuestion4_prime.length > 0 && hasChoosenIqos_iluma_prime) {
                //     if (this.question36Responses[i].text.includes('IQOS Iluma Prime')) {
                //         this.question36Responses[i].render = () => true;
                //     }
                // }
                // if (question3Selections.includes('IQOS Original Duo') && selectedIdsQuestion4_duo.length > 0 && hasChoosenIqos_original_duo) {
                //     if (this.question36Responses[i].text.includes('IQOS Original Duo')) {
                //         this.question36Responses[i].render = () => true;
                //     }
                // }
                // if (question3Selections.includes('Glo Hyper + uniq') && selectedIdsQuestion4_uniq.length > 0 && hasChoosenGlo_uniq) {
                //     if (this.question36Responses[i].text.includes('Glo Hyper + uniq')) {
                //         this.question36Responses[i].render = () => true;
                //     }
                // }
                // if (question3Selections.includes('Glo Hyper X2 Air') && selectedIdsQuestion4_air.length > 0 && hasChoosenGlo_air) {
                //     if (this.question36Responses[i].text.includes('Glo Hyper X2 Air')) {
                //         this.question36Responses[i].render = () => true;
                //     }
                // }
                // if (question3Selections.includes('Glo Hyper X2') && selectedIdsQuestion4_x2.length > 0 && hasChoosenGlo_x2) {
                //     if (this.question36Responses[i].text.includes('Glo Hyper X2')) {
                //         this.question36Responses[i].render = () => true;
                //     }
                // }
                // if (question3Selections.includes('Glo Hyper Pro') && selectedIdsQuestion4_pro.length > 0 && hasChoosenGlo_pro) {
                //     if (this.question36Responses[i].text.includes('Glo Hyper Pro')) {
                //         this.question36Responses[i].render = () => true;
                //     }
                // }

                if (question3Selections.includes('Glo Hyper + uniq') && selectedIdsQuestion4_uniq.length > 0 && hasChoosenGlo_uniq) {
                    this.question36Responses.forEach(r => {
                        if (r.text === 'Glo Hyper + uniq') {
                            r.render = () => true;
                        }
                    });
                }
                if (question3Selections.includes('Glo Hyper X2') && selectedIdsQuestion4_x2.length > 0 && hasChoosenGlo_x2) {
                    this.question36Responses.forEach(r => {
                        if (r.text == 'Glo Hyper X2') {
                            r.render = () => true;
                        }
                    });
                }

                if (question3Selections.includes('Glo Hyper X2 Air') && selectedIdsQuestion4_air.length > 0 && hasChoosenGlo_air) {
                    this.question36Responses.forEach(r => {
                        if (r.text == 'Glo Hyper X2 Air') {
                            r.render = () => true;
                        }
                    });
                }


                if (question3Selections.includes('Glo Hyper Pro') && selectedIdsQuestion4_pro.length > 0 && hasChoosenGlo_pro) {
                    this.question36Responses.forEach(r => {
                        if (r.text === 'Glo Hyper Pro') {
                            r.render = () => true;
                        }
                    });
                }

                if (question3Selections.includes('Lil Solid EZ') && selectedIdsQuestion4_lil_solidez.length > 0 && hasChoosenLil_solidez) {
                    if (this.question36Responses[i].text.includes('Lil Solid EZ')) {
                        this.question36Responses[i].render = () => true;
                    }
                }


                if (question3Selections.includes('IQOS Iluma') && selectedIdsiQuestion4_iluma.length > 0 && hasChoosenIqos_iluma) {
                    this.question36Responses.forEach(r => {
                        if (r.text === 'IQOS Iluma') {
                            r.render = () => true;
                        }
                    });
                }

                if (question3Selections.includes('IQOS Iluma One') && selectedIdsiQuestion4_one.length > 0 && hasChoosenIqos_iluma_one) {
                    this.question36Responses.forEach(r => {
                        if (r.text === 'IQOS Iluma One') {
                            r.render = () => true;
                        }
                    });
                }

                if (question3Selections.includes('IQOS Iluma Prime') && selectedIdsQuestion4_prime.length > 0 && hasChoosenIqos_iluma_prime) {
                    this.question36Responses.forEach(r => {
                        if (r.text === 'IQOS Iluma Prime') {
                            r.render = () => true;
                        }
                    });
                }

                if (question3Selections.includes('IQOS Original Duo') && selectedIdsQuestion4_duo.length > 0 && hasChoosenIqos_original_duo) {
                    this.question36Responses.forEach(r => {
                        if (r.text === 'IQOS Original Duo') {
                            r.render = () => true;
                        }
                    });
                }

            }
            this.question36.responses = this.question36Responses.filter(r => r.text)


            // if (selectedAnswersQ32_c.length > 0 && selectedAnswersQ32_c.map(r => r.text).includes('Altă variantă') && this.question32_c.responses?.[10].freeMessage && this.question35.render()) {
            //     const newResponse = new Response(this.question36Responses.length + 2, this.question32_c.responses?.[10].freeMessage)
            //     console.log('********************************************************')
            //     console.log(this.question36Responses.length + 2)

            //     // newResponse.render = () => true;
            //     // this.question36.responses.push(newResponse);
            //     // this.question36.responses = [...this.question36Responses, newResponse];

            // }




            // const hasQ30BeenRendered = () => {
            //     const hasChoosenQ18 = this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            //     const hasChoosenQ17 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            //     const hasChoosenQ16 = this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            //     const hasChoosenQ15 = this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            //     let question23SelectedIds = this.question23.responses.filter(r => r.selected)
            //     let question25SelectedIds = this.question25.responses.filter(r => r.selected)
            //     let question27SelectedIds = this.question27.responses.filter(r => r.selected)
            //     // let question29SelectedIds = this.question29.responses.filter(r => r.selected)

            //     if (hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ15 && hasChoosenQ16) {
            //         return question27SelectedIds.length > 0
            //     } else if (hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ16) {
            //         return question27SelectedIds.length > 0
            //     } else if (hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ15) {
            //         return question25SelectedIds.length > 0
            //     } else if (hasChoosenQ17 && hasChoosenQ16 && hasChoosenQ15) {
            //         return question27SelectedIds.length > 0
            //     } else if (hasChoosenQ18 && hasChoosenQ17) {
            //         return question23SelectedIds.length > 0
            //     } else if (hasChoosenQ17 && hasChoosenQ16) {
            //         return question27SelectedIds.length > 0
            //     } else if (hasChoosenQ17 && hasChoosenQ15) {
            //         return question25SelectedIds.length > 0
            //     } else if (hasChoosenQ17) {
            //         return question23SelectedIds.length > 0
            //     } else {
            //         return false
            //     }
            // }

            // this.question36.responses.forEach(r => {
            //                     r.selected = false;
            //                 });


            if (hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ16 && hasChoosenQ15) {
                if (hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ16 && hasChoosenQ15 && this.question30.render()) {
                    if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință')) {
                        return question33SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else {
                        return false;
                    }
                }
            } else if (((hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ16) || (hasChoosenQ17 && hasChoosenQ16 && hasChoosenQ15) || (hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ15) || (hasChoosenQ15 && hasChoosenQ16 && hasChoosenQ18))) {

                if (hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ16 && this.question30.render()) {
                    if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință')) {
                        return question33SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else {
                        return false;
                    }

                } else if (hasChoosenQ17 && hasChoosenQ16 && hasChoosenQ15 && this.question30.render()) {
                    if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință')) {
                        return question33SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else {
                        return false;
                    }

                } else if (hasChoosenQ18 && hasChoosenQ17 && hasChoosenQ15 && this.question30.render()) {
                    if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință')) {
                        return question33SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else {
                        return false;
                    }

                } else if (hasChoosenQ15 && hasChoosenQ16 && hasChoosenQ18) {
                    if (question29SelectedIds.length > 0 && question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question29.responses?.[24].freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question29SelectedIds.length > 0 && !question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;

                    }
                } else {
                    return false;
                }
            } else if ((hasChoosenQ15 && hasChoosenQ16) || (hasChoosenQ15 && hasChoosenQ18) || (hasChoosenQ15 && hasChoosenQ17) || (hasChoosenQ16 && hasChoosenQ18) || (hasChoosenQ16 && hasChoosenQ17) || (hasChoosenQ17 && hasChoosenQ18)) {
                if (hasChoosenQ15 && hasChoosenQ16) {
                    if (question27SelectedIds.length > 0 && question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question27.responses?.[30].freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question27SelectedIds.length > 0 && !question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;

                    }
                } else if (hasChoosenQ15 && hasChoosenQ18) {
                    if (question29SelectedIds.length > 0 && question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question29.responses?.[24].freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question29SelectedIds.length > 0 && !question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;

                    }
                }
                else if (hasChoosenQ15 && hasChoosenQ17 && this.question30.render()) {
                    if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință')) {
                        return question33SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else {
                        return false;
                    }

                } else if (hasChoosenQ16 && hasChoosenQ18) {
                    if (question29SelectedIds.length > 0 && question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question29.responses?.[24].freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question29SelectedIds.length > 0 && !question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;

                    }
                }
                else if (hasChoosenQ17 && hasChoosenQ18 && this.question30.render()) {
                    if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință')) {
                        return question33SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else {
                        return false;
                    }
                } else if (hasChoosenQ17 && hasChoosenQ16 && this.question30.render()) {
                    if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds > 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință')) {
                        return question33SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else {
                        return false;
                    }
                }

                else {
                    return false;
                }

            } else if (hasChoosenQ15 || hasChoosenQ16 || hasChoosenQ17 || hasChoosenQ18) {

                if (hasChoosenQ18) {
                    if (question29SelectedIds.length > 0 && question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question29.responses?.[24].freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question29SelectedIds.length > 0 && !question29SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;

                    }
                } else if (hasChoosenQ17 && this.question30.render()) {
                    if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0
                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință') && question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigări electronice de unică folosință')) {
                        return question33SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil')) {
                        return question34SelectedIds >= 0

                    } else if (question30SelectedIds.includes('Țigarete electronice cu pod-uri/capsule cu lichid')) {
                        return question35SelectedIds >= 0

                    } else {
                        return false;
                    }
                } else if (hasChoosenQ16) {
                    if (question27SelectedIds.length > 0 && question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question27.responses?.[30].freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question27SelectedIds.length > 0 && !question27SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;

                    }
                } else if (hasChoosenQ15) {
                    if (question25SelectedIds.length > 0 && question25SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        if (this.question25.responses?.[51].freeMessage) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (question25SelectedIds.length > 0 && !question25SelectedIds.map(r => r.text).includes('Altă marcă')) {
                        return true;

                    }
                }
            }
            // else if (this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // } else if (this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // }
            // else if (this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // } else if (this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // } else if (this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // } else if (this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // } else if (this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // } else if (this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // } else if (this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id > 3 && this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // }
            // else if (this.question15.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // } else if (this.question16.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // } else if (this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // } else if (this.question18.responses?.filter(resp => resp?.selected)?.[0]?.id > 3) {
            //     return true;

            // }

            else {
                this.question36.responses.forEach(r => {
                    r.selected = false;
                });
            }




            // else if (hasChoosenQ17 || hasChoosenQ16 || hasChoosenQ15) {

            //     if (hasChoosenQ17 && this.question30.render()) {
            //         return question35SelectedIds > 0
            //     } else if (hasChoosenQ16 && this.question30.render()) {
            //         return selectedAnswersQ27.length > 0
            //     } else if (hasChoosenQ15 && this.question30.render()) {
            //         return selectedAnswersQ25.length > 0
            //     }

            // }
            return false;
        }

        // yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy

        //(3.2) PREVIOUS MOST OFTEN BRAND BEFORE PLOOM
        this.question37 = new Question(114, [this.question36.id],
            'Ce categorie ai utilizat CEL MAI DES ÎNAINTE de Ploom?',
            'Te rugăm să selectezi o singură marcă',
            'radio',
            [new Response(1, 'Țigarete (țigarete convenționale, în pachet)'),
            new Response(2, 'Tutun rulat'),
            new Response(3, 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri'),
            new Response(4, 'Pliculețe cu nicotină (Pouch-uri cu nicotină)'),
            new Response(5, 'Dispozitive de încălzit tutunul sau alte produse din plante cu nicotină')
            ],
            false,
            'horizontal'
        );


        this.question37.render = () => {
            if (this.endgame == true) { return false; }


            // let question37ResponseRenderer = (rsp: Response): boolean => {
            //     if (this.endgame == true) { return false; }
            //     let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(r => r.id);
            //     return question14SelectedIds.indexOf(rsp.id) >= 0;
            // }


            // this.question37.responses[0].render = question37ResponseRenderer;
            // this.question37.responses[1].render = question37ResponseRenderer;
            // this.question37.responses[2].render = question37ResponseRenderer;
            // this.question37.responses[3].render = question37ResponseRenderer;



            let question15SelectedIds = this.question15.responses.filter(r => r.selected);
            let question16SelectedIds = this.question16.responses.filter(r => r.selected);
            let question17SelectedIds = this.question17.responses.filter(r => r.selected);
            let question18SelectedIds = this.question18.responses.filter(r => r.selected);
            let question23SelectedIds = this.question23.responses.filter(r => r.selected).map(resp => resp.text);



            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion14 = this.question14.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion14.map(brand => {
                if (brand == 'Țigarete (țigarete convenționale, în pachet)' && question15SelectedIds.length != 0 && question15SelectedIds?.[0]?.id > 3) numberOfQuestionAnswered += 1;
                if (brand == 'Tutun rulat' && question16SelectedIds.length != 0 && question16SelectedIds?.[0]?.id > 3) numberOfQuestionAnswered += 1;
                if (brand == 'Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri' && question17SelectedIds.length != 0 && question17SelectedIds?.[0]?.id > 3) numberOfQuestionAnswered += 1;
                if (brand == 'Pliculețe cu nicotină (Pouch-uri cu nicotină)' && question18SelectedIds.length != 0 && question18SelectedIds?.[0]?.id > 3) numberOfQuestionAnswered += 1;

            })

            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion14.length;



            let question36SelectedIds = this.question36.responses.filter(r => r.selected);


            if (this.question36.render() && question36SelectedIds.length > 0) {
                return true;
            } else if (hasAnsweredAllQuestionsBeforeShowingThis && selectedBrandsAtQuestion14.length > 0) {
                return true;
            }
            // } else if (selectedBrandsAtQuestion14.length == 1 && selectedBrandsAtQuestion14.includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)') && question18SelectedIds.length != 0 && question18SelectedIds?.[0]?.id <= 3 && question23SelectedIds.length > 0) {
            //     return true;
            // }

            else {
                this.question37.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;


        }


        this.question37_a = new Question(115, [this.question37.id],
            'Ce marcă de țigarete (țigarete convenționale, în pachet) ai utilizat CEL MAI DES ÎNAINTE de Ploom? ',
            'Te rugăm să selectezi o singură marcă',
            'radio-free',
            this.question37aResponses,
            false,
            'vertical'
        );


        this.question37_a.render = () => {
            if (this.endgame == true) { return false; }
            let question37SelectedIds = this.question37.responses.filter(r => r.selected);

            let question37_aSelectedIds = this.question37_a.responses.filter(r => r.selected)

            if (!question37_aSelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question37_a.responses && this.question37_a.responses[51]) {
                    this.question37_a.responses[51].freeMessage = "";
                }
            }

            if (question37SelectedIds.length > 0 && question37SelectedIds.map(r => r.text).includes('Țigarete (țigarete convenționale, în pachet)')) {
                return true;
            } else {
                this.question37_a.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question37_b = new Question(116, [this.question37.id],
            'Ce marcă de tutun rulat ai utilizat CEL MAI DES ÎNAINTE de Ploom? ',
            'Te rugăm să selectezi o singură marcă',
            'radio-free',
            this.question37bResponses,
            false,
            'vertical'
        );


        this.question37_b.render = () => {
            if (this.endgame == true) { return false; }
            let question37SelectedIds = this.question37.responses.filter(r => r.selected);

            let question37_bSelectedIds = this.question37_b.responses.filter(r => r.selected)

            if (!question37_bSelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question37_b.responses && this.question37_b.responses[30]) {
                    this.question37_b.responses[30].freeMessage = "";
                }
            }

            if (question37SelectedIds.length > 0 && question37SelectedIds.map(r => r.text).includes('Tutun rulat')) {
                return true;
            } else {
                this.question37_b.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question37_c = new Question(117, [this.question37.id],
            'Ce marcă de țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri ai utilizat CEL MAI DES ÎNAINTE de Ploom? ',
            'Te rugăm să selectezi o singură marcă',
            'radio-free',
            this.evapeResponses,
            false,
            'vertical'
        );


        this.question37_c.render = () => {
            if (this.endgame == true) { return false; }
            let question37SelectedIds = this.question37.responses.filter(r => r.selected);
            let question37_cSelectedIds = this.question37_c.responses.filter(r => r.selected)

            if (!question37_cSelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question37_c.responses && this.question37_c.responses[49]) {
                    this.question37_c.responses[49].freeMessage = "";
                }
            }
            if (question37SelectedIds.length > 0 && question37SelectedIds.map(r => r.text).includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri')) {
                return true;
            } else {
                this.question37_c.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question37_d = new Question(118, [this.question37.id],
            'Ce marcă de dispozitive de încălzit tutunul sau alte produse din plante cu nicotină ai utilizat CEL MAI DES ÎNAINTE de Ploom? ',
            'Te rugăm să selectezi o singură marcă',
            'radio-free',
            this.htDeviceResponses,
            false,
            'vertical'
        );


        this.question37_d.render = () => {
            if (this.endgame == true) { return false; }
            let question37SelectedIds = this.question37.responses.filter(r => r.selected);

            let question37_dSelectedIds = this.question37_d.responses.filter(r => r.selected)

            if (!question37_dSelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question37_d.responses && this.question37_d.responses[10]) {
                    this.question37_d.responses[10].freeMessage = "";
                }
            }
            if (question37SelectedIds.length > 0 && question37SelectedIds.map(r => r.text).includes('Dispozitive de încălzit tutunul sau alte produse din plante cu nicotină')) {
                return true;
            } else {
                this.question37_d.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question37_e = new Question(119, [this.question37.id],
            'Ce marcă de pliculețe cu nicotină (Pouch-uri cu nicotină) ai utilizat CEL MAI DES ÎNAINTE de Ploom? ',
            'Te rugăm să selectezi o singură marcă',
            'radio-free',
            this.nicotinePouches,
            false,
            'vertical'
        );


        this.question37_e.render = () => {
            if (this.endgame == true) { return false; }
            let question37SelectedIds = this.question37.responses.filter(r => r.selected);

            let question37_eSelectedIds = this.question37_e.responses.filter(r => r.selected)

            if (!question37_eSelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question37_e.responses && this.question37_e.responses[24]) {
                    this.question37_e.responses[24].freeMessage = "";
                }
            }

            if (question37SelectedIds.length > 0 && question37SelectedIds.map(r => r.text).includes('Pliculețe cu nicotină (Pouch-uri cu nicotină)')) {
                return true;
            } else {
                this.question37_e.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }




        // (3.3) MOST OFTEN RRP DEVICE IF USED MORE THAN 2
        this.question38 = new Question(120, [this.question32_a.id, this.question32_b.id, this.question32_c.id, this.question14.id, this.question3.id],
            'Pentru că folosești mai mult de un dispozitiv, te rog să ne spui pe care dintre ele îl folosești CEL MAI DES.',
            'Te rugăm să selectezi o singură marcă',
            'radio',
            this.question38Responses,
            false,
            'vertical'
        );

        this.question38.render = () => {
            if (this.endgame == true) { return false; }


            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);
            let question17SelectedIds = this.question17.responses.filter(r => r.selected);



            const hasChoosenPloom = this.question4.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_uniq = this.question4_glo_hyper_uniq.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_air = this.question4_glo_hyper_x2_air.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_x2 = this.question4_glo_hyper_x2.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenGlo_pro = this.question4_glo_hyper_pro.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma = this.question4_iqos_iluma.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_one = this.question4_iqos_iluma_one.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_iluma_prime = this.question4_iqos_iluma_prime.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenIqos_original_duo = this.question4_iqos_iluma_original_duo.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;
            const hasChoosenLil_solidez = this.question4_lil_solidez.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            let question14SelectedIds = this.question14.responses.filter(r => r.selected).map(resp => resp.text).includes('Țigarete electronice de unică folosință sau cu cartuș, cu capsule/pod-uri');
            const hasChoosenQ17 = this.question17.responses?.filter(resp => resp?.selected)?.[0]?.id <= 3;

            let question32_aSelectedIds = this.question32_a.responses.filter(r => r.selected);
            let question32_bSelectedIds = this.question32_b.responses.filter(r => r.selected);
            let question32_cSelectedIds = this.question32_c.responses.filter(r => r.selected);

            let question3SelectedIds = this.question3.responses.filter(r => r.selected);

            if (question32_aSelectedIds.length > 0 && question32_aSelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question32_a.responses?.[30].freeMessage) {
                    this.question38Responses[57].text = this.question32_a.responses?.[30].freeMessage
                    this.excludeBrands.push(this.question32_a.responses?.[30].freeMessage)

                }

            }

            if (question32_bSelectedIds.length > 0 && question32_bSelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question32_b.responses?.[9].freeMessage) {
                    this.question38Responses[57].text = this.question32_b.responses?.[9].freeMessage
                    this.excludeBrands.push(this.question32_b.responses?.[9].freeMessage)


                }

            }

            if (question32_cSelectedIds.length > 0 && question32_cSelectedIds.map(r => r.text).includes('Altă marcă')) {
                if (this.question32_c.responses?.[10].freeMessage) {
                    this.question38Responses[57].text = this.question32_c.responses?.[10].freeMessage
                    this.excludeBrands.push(this.question32_c.responses?.[10].freeMessage)


                }

            }



            // console.log("************************************************1");
            // console.log(this.question38Responses)

            const brandsWithSameIds = { 1: [], 2: [], 3: [] };

            //@ts-ignore
            if (hasChoosenIqos_iluma) brandsWithSameIds[question4_iqos_ilumaSelectedIds?.[0]?.id].push('IQOS Iluma')
            //@ts-ignore
            if (hasChoosenIqos_iluma_one) brandsWithSameIds[question4_iqos_iluma_oneSelectedIds?.[0]?.id].push('IQOS Iluma One')
            //@ts-ignore
            if (hasChoosenIqos_iluma_prime) brandsWithSameIds[question4_iqos_iluma_primeSelectedIds?.[0]?.id].push('IQOS Iluma Prime')
            //@ts-ignore
            if (hasChoosenIqos_original_duo) brandsWithSameIds[question4_iqos_iluma_duoSelectedIds?.[0]?.id].push('IQOS Original Duo')
            //@ts-ignore
            if (hasChoosenPloom) brandsWithSameIds[question4SelectedIds?.[0]?.id].push('Ploom')
            //@ts-ignore
            if (hasChoosenGlo_uniq) brandsWithSameIds[question4_glo_uniqSelectedIds?.[0]?.id].push('Glo Hyper + uniq')
            //@ts-ignore
            if (hasChoosenGlo_air) brandsWithSameIds[question4_glo_x2_airSelectedIds?.[0]?.id].push('Glo Hyper X2 Air')
            //@ts-ignore
            if (hasChoosenGlo_x2) brandsWithSameIds[question4_glo_x2SelectedIds?.[0]?.id].push('Glo Hyper X2')
            //@ts-ignore
            if (hasChoosenGlo_pro) brandsWithSameIds[question4_glo_proSelectedIds?.[0]?.id].push('Glo Hyper Pro')
            //@ts-ignore
            if (hasChoosenLil_solidez) brandsWithSameIds[question4_lil_solidezSelectedIds?.[0]?.id].push('Lil Solid EZ')

            if (hasChoosenQ17 && ((question32_aSelectedIds.length > 0 && !question32_aSelectedIds.map(r => r.text).includes('Altă marcă')) || (question32_bSelectedIds.length > 0 && !question32_bSelectedIds.map(r => r.text).includes('Altă marcă')) || (question32_cSelectedIds.length > 0 && !question32_cSelectedIds.map(r => r.text).includes('Altă marcă')))) {
                //@ts-ignore
                brandsWithSameIds[question17SelectedIds?.[0]?.id] = [...brandsWithSameIds[question17SelectedIds?.[0]?.id], ...(question32_aSelectedIds.map(resp => resp.text)), ...(question32_bSelectedIds.map(resp => resp.text)), ...(question32_cSelectedIds.map(resp => resp.text))]
            }

            if (hasChoosenQ17 && (question32_aSelectedIds.length > 0 && (question32_aSelectedIds.map(r => r.text).includes('Altă marcă') && this.question32_a.responses?.[30].freeMessage))) {
                //@ts-ignore
                brandsWithSameIds[question17SelectedIds?.[0]?.id] = [...brandsWithSameIds[question17SelectedIds?.[0]?.id], (this.question32_a.responses?.[30].freeMessage)]
            }
            if (hasChoosenQ17 && (question32_bSelectedIds.length > 0 && question32_bSelectedIds.map(r => r.text).includes('Altă marcă') && this.question32_b.responses?.[9].freeMessage)) {
                //@ts-ignore
                brandsWithSameIds[question17SelectedIds?.[0]?.id] = [...brandsWithSameIds[question17SelectedIds?.[0]?.id], (this.question32_b.responses?.[9].freeMessage)]
            }

            if (hasChoosenQ17 && (question32_cSelectedIds.length > 0 && question32_cSelectedIds.map(r => r.text).includes('Altă marcă') && this.question32_c.responses?.[10].freeMessage)) {
                //@ts-ignore
                brandsWithSameIds[question17SelectedIds?.[0]?.id] = [...brandsWithSameIds[question17SelectedIds?.[0]?.id], (this.question32_c.responses?.[10].freeMessage)]
            }
            console.log('brandsWithSameIds', brandsWithSameIds);


            for (let i = 0; i < this.question38Responses.length; i++) {
                this.question38Responses[i].render = () => false;
            }
            // if (hasChoosenPloom && question4SelectedIds.length > 0) {
            //     if (this.question38Responses[i].text.includes('Ploom')) { this.question38Responses[i].render = () => true; }
            // }

            // if (hasChoosenGlo_uniq && question4_glo_uniqSelectedIds.length > 0) {
            //     if (this.question38Responses[i].text.includes('Glo Hyper + uniq')) { this.question38Responses[i].render = () => true; console.log(i) }
            // }

            // if (hasChoosenGlo_air && question4_glo_x2_airSelectedIds.length > 0) {
            //     if (this.question38Responses[i].text.includes('Glo Hyper X2 Air')) { this.question38Responses[i].render = () => true; console.log(i) }
            // }

            // if (hasChoosenGlo_x2 && question4_glo_x2SelectedIds.length > 0) {
            //     if (this.question38Responses[i].text.includes('Glo Hyper X2')) { this.question38Responses[i].render = () => true; console.log(i) }
            // }

            // if (hasChoosenGlo_pro && question4_glo_proSelectedIds.length > 0) {
            //     if (this.question38Responses[i].text.includes('Glo Hyper Pro')) { this.question38Responses[i].render = () => true; }
            // }

            // if (hasChoosenIqos_iluma && question4_iqos_ilumaSelectedIds.length > 0) {
            //     if (this.question38Responses[i].text.includes('IQOS Iluma')) { this.question38Responses[i].render = () => true; }
            // }

            // if (hasChoosenIqos_iluma_one && question4_iqos_iluma_oneSelectedIds.length > 0) {
            //     if (this.question38Responses[i].text.includes('IQOS Iluma One')) { this.question38Responses[i].render = () => true; }
            // }

            // if (hasChoosenIqos_iluma_prime && question4_iqos_iluma_primeSelectedIds.length > 0) {
            //     if (this.question38Responses[i].text.includes('IQOS Iluma Prime')) { this.question38Responses[i].render = () => true; }
            // }

            // if (hasChoosenIqos_original_duo && question4_iqos_iluma_duoSelectedIds.length > 0) {
            //     if (this.question38Responses[i].text.includes('IQOS Original Duo')) { this.question38Responses[i].render = () => true; }
            // }

            // if (hasChoosenLil_solidez && question4_lil_solidezSelectedIds.length > 0) {
            //     if (this.question38Responses[i].text.includes('Lil Solid EZ')) { this.question38Responses[i].render = () => true; }
            // }

            // if (question14SelectedIds && hasChoosenQ17 && question32SelectedIds.length > 0) {
            //     if (question32SelectedIds.map(resp => resp.text).includes(this.question38Responses[i].text)) { this.question38Responses[i].render = () => true; console.log(i) }
            // }


            // }

            let existsMultipleSameIds = false;
            for (let key = 1; key <= 3; key++) {
                //@ts-ignore
                const brandsWithSameScoreAsKey = brandsWithSameIds[key];
                console.log('brandsWithSameScoreAsKey', brandsWithSameScoreAsKey)

                if (question14SelectedIds) {
                    if (brandsWithSameScoreAsKey.length >= 2 && question17SelectedIds?.[0]?.id == key) {
                        existsMultipleSameIds = true;
                        //@ts-ignore
                        brandsWithSameScoreAsKey.forEach(brand => {
                            const answerThatShouldBeRendered = this.question38Responses.find(resp => resp.text == brand)
                            if (answerThatShouldBeRendered) {
                                answerThatShouldBeRendered.render = () => true;
                            }
                        })
                    }
                } else {
                    if (brandsWithSameScoreAsKey.length >= 2) {

                        existsMultipleSameIds = true;
                        //@ts-ignore
                        brandsWithSameScoreAsKey.forEach(brand => {
                            const answerThatShouldBeRendered = this.question38Responses.find(resp => resp.text == brand)
                            if (answerThatShouldBeRendered) {
                                answerThatShouldBeRendered.render = () => true;
                            }
                        })
                    }
                }

            }


            let question36SelectedIds = this.question36.responses.filter(r => r.selected);
            const hasSelectedOneAbove = this.excludeBrands.includes(question36SelectedIds?.[0]?.text);

            let selectedQuestion37_a = this.question37_a.responses.filter(r => r.selected);
            let selectedQuestion37_b = this.question37_b.responses.filter(r => r.selected);
            let selectedQuestion37_c = this.question37_c.responses.filter(r => r.selected);
            let selectedQuestion37_d = this.question37_d.responses.filter(r => r.selected);
            let selectedQuestion37_e = this.question37_e.responses.filter(r => r.selected);



            let q37_a = selectedQuestion37_a.map(r => r.text).includes('Altă marcă')
            let q37_b = selectedQuestion37_b.map(r => r.text).includes('Altă marcă')
            let q37_c = selectedQuestion37_c.map(r => r.text).includes('Altă marcă')
            let q37_d = selectedQuestion37_d.map(r => r.text).includes('Altă marcă')
            let q37_e = selectedQuestion37_e.map(r => r.text).includes('Altă marcă')


            if (question36SelectedIds.length > 0 && !hasSelectedOneAbove && question3SelectedIds.length > 0 && existsMultipleSameIds) {
                if (this.question37_a.responses.filter(resp => resp.selected).length > 0 && q37_a) {
                    if (this.question37_a.responses?.[51].freeMessage) {
                        return true
                    } else {
                        return false;
                    }
                } else if (this.question37_a.responses.filter(resp => resp.selected).length > 0 && !q37_a) {

                    return true
                }


                if (this.question37_b.responses.filter(resp => resp.selected).length > 0 && q37_b) {
                    if (this.question37_b.responses?.[30].freeMessage) {
                        return true
                    } else {
                        return false;
                    }
                } else if (this.question37_b.responses.filter(resp => resp.selected).length > 0 && !q37_b) {

                    return true
                }

                if (this.question37_c.responses.filter(resp => resp.selected).length > 0 && q37_c) {
                    if (this.question37_c.responses?.[49].freeMessage) {
                        return true
                    } else {
                        return false;
                    }
                } else if (this.question37_c.responses.filter(resp => resp.selected).length > 0 && !q37_c) {

                    return true
                }

                if (this.question37_d.responses.filter(resp => resp.selected).length > 0 && q37_d) {
                    if (this.question37_d.responses?.[10].freeMessage) {
                        return true
                    } else {
                        return false;
                    }
                } else if (this.question37_d.responses.filter(resp => resp.selected).length > 0 && !q37_d) {

                    return true
                }

                if (this.question37_e.responses.filter(resp => resp.selected).length > 0 && q37_e) {
                    if (this.question37_e.responses?.[24].freeMessage) {
                        return true
                    } else {
                        return false;
                    }
                } else if (this.question37_e.responses.filter(resp => resp.selected).length > 0 && !q37_e) {

                    return true
                }


            } else {
                this.question38.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.questionsShuffleIndexes = {
            // 'question39': this.generateUniqueNumber(this.firstShuffleIndex, this.maxFirstShuffleIndex),
            'question40': this.generateUniqueNumber(this.firstShuffleIndex, this.maxFirstShuffleIndex),
            'question41': this.generateUniqueNumber(this.firstShuffleIndex, this.maxFirstShuffleIndex),
            'question42': this.generateUniqueNumber(this.firstShuffleIndex, this.maxFirstShuffleIndex),
            'question43': this.generateUniqueNumber(this.firstShuffleIndex, this.maxFirstShuffleIndex),
            'question44': this.generateUniqueNumber(this.firstShuffleIndex, this.maxFirstShuffleIndex),
            'question45': this.generateUniqueNumber(this.firstShuffleIndex, this.maxFirstShuffleIndex),
        }

        // this.questionsShuffleIndexes = {
        //     'question39': 4,
        //     'question40': 7,
        //     'question41': 3,
        //     'question42': 2,
        //     'question43': 1,
        //     'question44': 6,
        //     'question45': 5,
        // }

        //(4.1) PLOOM CONSUMER SATISFACTION
        this.question39 = new Question(121, [this.question38.id, this.question37_a.id],
            `Te rugăm să ne spui cât de mulțumit/ă ești de dispozitivul Ploom în general?`,
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă')
            ],
            false,
            'horizontal'
        );


        this.question39.render = () => {
            if (this.endgame == true) { return false; }
            let q18hasRendered = false;
            let question38SelectedIds = this.question38.responses.filter(r => r.selected);
            // if (this.hasQ38BeenRendered) {
            //     q18hasRendered = true;
            // }
            let selectedQuestion37_a = this.question37_a.responses.filter(r => r.selected);
            let selectedQuestion37_b = this.question37_b.responses.filter(r => r.selected);
            let selectedQuestion37_c = this.question37_c.responses.filter(r => r.selected);
            let selectedQuestion37_d = this.question37_d.responses.filter(r => r.selected);
            let selectedQuestion37_e = this.question37_e.responses.filter(r => r.selected);



            let q37_a = selectedQuestion37_a.map(r => r.text).includes('Altă marcă')
            let q37_b = selectedQuestion37_b.map(r => r.text).includes('Altă marcă')
            let q37_c = selectedQuestion37_c.map(r => r.text).includes('Altă marcă')
            let q37_d = selectedQuestion37_d.map(r => r.text).includes('Altă marcă')
            let q37_e = selectedQuestion37_e.map(r => r.text).includes('Altă marcă')

            if (this.question38.render()) {
                return question38SelectedIds.length > 0
            } else if (!this.question38.render()) {
                if (this.question37_a.responses.filter(resp => resp.selected).length > 0 && q37_a) {
                    if (this.question37_a.responses?.[51].freeMessage) {
                        return true
                    } else {
                        return false;
                    }
                } else if (this.question37_a.responses.filter(resp => resp.selected).length > 0 && !q37_a) {

                    return true
                }


                if (this.question37_b.responses.filter(resp => resp.selected).length > 0 && q37_b) {
                    if (this.question37_b.responses?.[30].freeMessage) {
                        return true
                    } else {
                        return false;
                    }
                } else if (this.question37_b.responses.filter(resp => resp.selected).length > 0 && !q37_b) {

                    return true
                }

                if (this.question37_c.responses.filter(resp => resp.selected).length > 0 && q37_c) {
                    if (this.question37_c.responses?.[49].freeMessage) {
                        return true
                    } else {
                        return false;
                    }
                } else if (this.question37_c.responses.filter(resp => resp.selected).length > 0 && !q37_c) {

                    return true
                }

                if (this.question37_d.responses.filter(resp => resp.selected).length > 0 && q37_d) {
                    if (this.question37_d.responses?.[10].freeMessage) {
                        return true
                    } else {
                        return false;
                    }
                } else if (this.question37_d.responses.filter(resp => resp.selected).length > 0 && !q37_d) {

                    return true
                }

                if (this.question37_e.responses.filter(resp => resp.selected).length > 0 && q37_e) {
                    if (this.question37_e.responses?.[24].freeMessage) {
                        return true
                    } else {
                        return false;
                    }
                } else if (this.question37_e.responses.filter(resp => resp.selected).length > 0 && !q37_e) {

                    return true
                }
            } else {
                this.question39.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;

        }


        this.question40 = new Question(122, [this.getLastQuestionId(this.currentIndexToRender, 'question40', this.question39.id)],
            'Te rugăm să ne spui cat de mulțumit/ă ești de imaginea mărcii Ploom?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă')
            ],
            false,
            'horizontal'
        );
        this.question40.render = () => {
            if (this.endgame == true) { return false; }
            let question39SelectedIds = this.question39.responses.filter(r => r.selected);
            const key = Object.keys(this.questionsShuffleIndexes).find(key => this.questionsShuffleIndexes[key] === this.questionsShuffleIndexes['question40'] - 1);
            //@ts-ignore
            const hasAnsweredToPrevQuestion = key ? this[key]?.responses?.filter(r => r.selected)?.length > 0 : question39SelectedIds.length > 0 ? true : false;
            const shouldBeRendered = this.currentIndexToRender >= this.questionsShuffleIndexes['question40'] && hasAnsweredToPrevQuestion;
            if (shouldBeRendered) this.currentIndexToRender += 1;
            if (shouldBeRendered) {
                return true
            } else {
                this.question40.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question41 = new Question(123, [this.getLastQuestionId(this.currentIndexToRender, 'question41', this.question39.id)],
            'Te rugăm să ne spui cat de mulțumit/ă ești de savoarea gustului în general?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă')
            ],
            false,
            'horizontal'
        );
        this.question41.render = () => {
            if (this.endgame == true) { return false; }
            let question40SelectedIds = this.question40.responses.filter(r => r.selected);
            let question39SelectedIds = this.question39.responses.filter(r => r.selected);
            const key = Object.keys(this.questionsShuffleIndexes).find(key => this.questionsShuffleIndexes[key] === this.questionsShuffleIndexes['question41'] - 1);
            //@ts-ignore
            const hasAnsweredToPrevQuestion = key ? this[key]?.responses?.filter(r => r.selected)?.length > 0 : question39SelectedIds.length > 0 ? true : false;
            const shouldBeRendered = this.currentIndexToRender >= this.questionsShuffleIndexes['question41'] && hasAnsweredToPrevQuestion;
            if (shouldBeRendered) this.currentIndexToRender += 1;
            if (shouldBeRendered) {
                return true
            } else {
                this.question41.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question42 = new Question(124, [this.getLastQuestionId(this.currentIndexToRender, 'question42', this.question39.id)],
            'Te rugăm să ne spui cat de mulțumit/ă ești de miros în general?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă')
            ],
            false,
            'horizontal'
        );
        this.question42.render = () => {
            if (this.endgame == true) { return false; }
            let question41SelectedIds = this.question41.responses.filter(r => r.selected);
            let question39SelectedIds = this.question39.responses.filter(r => r.selected);
            const key = Object.keys(this.questionsShuffleIndexes).find(key => this.questionsShuffleIndexes[key] === this.questionsShuffleIndexes['question42'] - 1);

            //@ts-ignore
            const hasAnsweredToPrevQuestion = key ? this[key]?.responses?.filter(r => r.selected)?.length > 0 : question39SelectedIds.length > 0 ? true : false;
            const shouldBeRendered = this.currentIndexToRender >= this.questionsShuffleIndexes['question42'] && hasAnsweredToPrevQuestion;

            if (shouldBeRendered) this.currentIndexToRender += 1;
            if (shouldBeRendered) {
                return true
            } else {
                this.question42.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question43 = new Question(125, [this.getLastQuestionId(this.currentIndexToRender, 'question43', this.question39.id)],
            'Te rugăm să ne spui cat de mulțumit/ă ești de ușurința utilizării dispozitivului?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă')
            ],
            false,

            'horizontal'
        );
        this.question43.render = () => {
            if (this.endgame == true) { return false; }
            let question42SelectedIds = this.question42.responses.filter(r => r.selected);
            let question39SelectedIds = this.question39.responses.filter(r => r.selected);
            const key = Object.keys(this.questionsShuffleIndexes).find(key => this.questionsShuffleIndexes[key] === this.questionsShuffleIndexes['question43'] - 1);
            //@ts-ignore
            const hasAnsweredToPrevQuestion = key ? this[key]?.responses?.filter(r => r.selected)?.length > 0 : question39SelectedIds.length > 0 ? true : false;
            const shouldBeRendered = this.currentIndexToRender >= this.questionsShuffleIndexes['question43'] && hasAnsweredToPrevQuestion;
            if (shouldBeRendered) this.currentIndexToRender += 1;
            if (shouldBeRendered) {
                return true
            } else {
                this.question43.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        this.question44 = new Question(126, [this.getLastQuestionId(this.currentIndexToRender, 'question44', this.question39.id)],
            'Te rugăm să ne spui cat de mulțumit/ă ești de design-ul dispozitivului?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă')
            ],
            false,
            'horizontal'
        );
        this.question44.render = () => {
            if (this.endgame == true) { return false; }
            let question43SelectedIds = this.question43.responses.filter(r => r.selected);
            let question39SelectedIds = this.question39.responses.filter(r => r.selected);
            const key = Object.keys(this.questionsShuffleIndexes).find(key => this.questionsShuffleIndexes[key] === this.questionsShuffleIndexes['question44'] - 1);
            //@ts-ignore
            const hasAnsweredToPrevQuestion = key ? this[key]?.responses?.filter(r => r.selected)?.length > 0 : question39SelectedIds.length > 0 ? true : false;
            const shouldBeRendered = this.currentIndexToRender >= this.questionsShuffleIndexes['question44'] && hasAnsweredToPrevQuestion;
            if (shouldBeRendered) this.currentIndexToRender += 1;
            if (shouldBeRendered) {
                return true
            } else {
                this.question44.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question45 = new Question(127, [this.getLastQuestionId(this.currentIndexToRender, 'question45', this.question39.id)],
            'Te rugăm să ne spui cat de mulțumit/ă ești de modul de execuție al accesoriilor?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă')
            ],
            false,
            'horizontal'
        );
        this.question45.render = () => {
            if (this.endgame == true) { return false; }
            let question44SelectedIds = this.question44.responses.filter(r => r.selected);
            let question39SelectedIds = this.question39.responses.filter(r => r.selected);
            const key = Object.keys(this.questionsShuffleIndexes).find(key => this.questionsShuffleIndexes[key] === this.questionsShuffleIndexes['question45'] - 1);
            //@ts-ignore
            const hasAnsweredToPrevQuestion = key ? this[key]?.responses?.filter(r => r.selected)?.length > 0 : question39SelectedIds.length > 0 ? true : false;
            const shouldBeRendered = this.currentIndexToRender >= this.questionsShuffleIndexes['question45'] && hasAnsweredToPrevQuestion;
            if (shouldBeRendered) this.currentIndexToRender += 1;
            if (shouldBeRendered) {
                return true
            } else {
                this.question45.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (4.2) PLOOM TOUCHPOINTS & ITS CSAT

        this.question46 = new Question(128, [this.question39.id, this.question40.id, this.question41.id, this.question42.id, this.question43.id, this.question44.id, this.question45.id],
            'Pe care dintre aceste servicii/experiențe Ploom le-ai încercat/folosit în ultimele 4 săptămâni?',
            'Te rugăm să bifezi toate variantele care ți se aplică',
            'checkbox',
            this.question46Responses,
            true,
            'vertical'
        );
        this.question46.render = () => {
            if (this.endgame == true) { return false; }
            const keyOfMaxValue = Object.keys(this.questionsShuffleIndexes).reduce((a, b) =>
                this.questionsShuffleIndexes[a] > this.questionsShuffleIndexes[b] ? a : b
            );
            //@ts-ignore
            let selectedIdsLastAnsweredQuestion = this[keyOfMaxValue].responses.filter(r => r.selected)

            if (selectedIdsLastAnsweredQuestion.length > 0) {
                return true;

            } else {
                this.question46.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        this.question47 = new Question(129, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența vizitării site-ului Ploom?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'
        );
        this.question47.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am vizitat site-ul Ploom (www.ploom.ro)')) {
                return true;
            } else {
                this.question47.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question48 = new Question(130, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența vizitării paginii de Instagram Ploom?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question48.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am vizitat pagina de Instagram Ploom')) {
                return true;
            } else {
                this.question48.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question49 = new Question(131, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența primirii de emailuri/SMS-uri din partea Ploom?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question49.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am primit emailuri/SMS-uri din partea Ploom (inclusiv oferte)')) {
                return true;
            } else {
                this.question49.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question50 = new Question(132, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența achiziționărilor de pe site-ul mărcii Ploom (www.ploom.ro)?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question50.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am făcut achiziții de pe site-ul mărcii Ploom (www.ploom.ro)')) {
                return true;
            } else {
                this.question50.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question51 = new Question(133, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența contactului cu serviciul de asistență pentru clienți Ploom (soluționare problemelor, informații)?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question51.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am fost în contact cu serviciul de asistență pentru clienți Ploom (soluționare problemelor, informații)')) {
                return true;
            } else {
                this.question51.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question52 = new Question(134, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența participării la evenimente organizate sau sponsorizate de Ploom?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question52.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am participat la evenimente organizate sau sponsorizate de Ploom')) {
                return true;
            } else {
                this.question52.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question53 = new Question(135, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența interacțiunii cu brand ambasadoare/ambasadori ai mărcii Ploom (sesiuni de încercare asistate, oferte speciale și informații despre produsele Ploom)?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question53.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Interacțiuni cu brand ambasadoare/ambasadori ai mărcii Ploom (sesiuni de încercare asistate, oferte speciale și informații despre produsele Ploom)')) {
                return true;
            } else {
                this.question53.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question54 = new Question(136, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența achiziționărilor dintr-un magazin specializat al mărcii Ploom/O insulă Ploom din Mall?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question54.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am făcut achiziții dintr-un magazin specializat al mărcii Ploom/O insulă Ploom din Mall')) {
                return true;
            } else {
                this.question54.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question55 = new Question(137, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența serviciilor/experiențelor la magazinele/insulele Ploom din Mall (excluzând achizițiile)?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question55.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Servicii/experiențe la magazinele/insulele Ploom din Mall (excluzând achizițiile)')) {
                return true;
            } else {
                this.question55.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }

        this.question56 = new Question(138, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența reclamelor Ploom online sau în afara mediului online (panouri publicitare, videoclipuri pe mașini etc.?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question56.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Reclame Ploom online sau în afara mediului online (panouri publicitare, videoclipuri pe mașini etc.)')) {
                return true;
            } else {
                this.question56.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question57 = new Question(139, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența informațiilor de la vânzători în magazine (inclusiv oferte speciale și informații despre produsele Ploom)?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question57.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Informații de la vânzători în magazine (inclusiv oferte speciale și informații despre produsele Ploom)')) {
                return true;
            } else {
                this.question57.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        this.question58 = new Question(140, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența reclamelor la benzinării sau magazine/chioșcuri?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question58.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am văzut reclame la benzinării sau magazine/chioșcuri')) {
                return true;
            } else {
                this.question58.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        this.question59 = new Question(141, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența citirii de informații pe site-uri de știri sau forumuri pe internet?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question59.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am citit informații pe site-uri de știri sau forumuri pe internet')) {
                return true;
            } else {
                this.question59.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        this.question60 = new Question(142, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența vizionării unui videoclip pe YouTube?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question60.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am văzut un videoclip pe YouTube')) {
                return true;
            } else {
                this.question60.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        this.question61 = new Question(143, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența interacțiunii cu un stand al mărcii Ploom la un festival?',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question61.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am văzut un stand al mărcii Ploom la un festival')) {
                return true;
            } else {
                this.question61.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.question62 = new Question(144, [this.question46.id],
            'Cât de mulțumit/ă ai fost cu experiența observării marcii Ploom pe un afiș al unui eveniment (sponsor al evenimentului)',
            '',
            'radio-inline',
            [new Response(1, 'Foarte nemulțumit/ă'),
            new Response(2, 'Nemulțumit/ă'),
            new Response(3, 'Neutru'),
            new Response(4, 'Mulțumit/ă'),
            new Response(5, 'Foarte mulțumit/ă'),

            ],
            false,
            'horizontal'

        );
        this.question62.render = () => {
            if (this.endgame == true) { return false; }
            let question46SelectedIds = this.question46.responses.filter(r => r.selected).map(r => r.text);
            if (question46SelectedIds.length > 0 && question46SelectedIds.includes('Am văzut marcă Ploom pe un afiș al unui eveniment (sponsor al evenimentului)')) {
                return true;
            } else {
                this.question62.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        this.question63 = new Question(145, [this.question46.id, this.question47.id, this.question48.id, this.question49.id, this.question50.id, this.question51.id, this.question52.id, this.question53.id, this.question54.id, this.question55.id, this.question56.id, this.question57.id, this.question58.id, this.question59.id, this.question60.id, this.question61.id, this.question62.id],
            'Cât de probabil este să recomanzi Ploom unui alt consumator existent adult, fumător sau utilizator de dispozitive de încălzit tutunul sau alte produse din plante cu nicotină (de exemplu, unui prieten sau coleg)?',
            '0 înseamnă ”Cu siguranță nu voi recomanda” și 10 înseamnă ”Cu siguranță voi recomanda”',
            'radio-inline',
            [new Response(0, '0'),
            new Response(1, '1'),
            new Response(2, '2'),
            new Response(3, '3'),
            new Response(4, '4'),
            new Response(5, '5'),
            new Response(6, '6'),
            new Response(7, '7'),
            new Response(8, '8'),
            new Response(9, '9'),
            new Response(10, '10')

            ],
            false,
            'horizontal'

        );
        this.question63.render = () => {
            if (this.endgame == true) { return false; }

            let question47SelectedIds = this.question47.responses.filter(r => r.selected);
            let question48SelectedIds = this.question48.responses.filter(r => r.selected);
            let question49SelectedIds = this.question49.responses.filter(r => r.selected);
            let question50SelectedIds = this.question50.responses.filter(r => r.selected);
            let question51SelectedIds = this.question51.responses.filter(r => r.selected);
            let question52SelectedIds = this.question52.responses.filter(r => r.selected);
            let question53SelectedIds = this.question53.responses.filter(r => r.selected);
            let question54SelectedIds = this.question54.responses.filter(r => r.selected);
            let question55SelectedIds = this.question55.responses.filter(r => r.selected);
            let question56SelectedIds = this.question56.responses.filter(r => r.selected);
            let question57SelectedIds = this.question57.responses.filter(r => r.selected);
            let question58SelectedIds = this.question58.responses.filter(r => r.selected);
            let question59SelectedIds = this.question59.responses.filter(r => r.selected);
            let question60SelectedIds = this.question60.responses.filter(r => r.selected);
            let question61SelectedIds = this.question61.responses.filter(r => r.selected);
            let question62SelectedIds = this.question62.responses.filter(r => r.selected);


            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion46 = this.question46.responses.filter(rsp => rsp.selected).map(resp => resp.text);
            let selectedAtQuestion46 = this.question46.responses.filter(rsp => rsp.selected);


            selectedBrandsAtQuestion46.map(brand => {
                if (brand == 'Am vizitat site-ul Ploom (www.ploom.ro)' && question47SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Am vizitat pagina de Instagram Ploom' && question48SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Am primit emailuri/SMS-uri din partea Ploom (inclusiv oferte)' && question49SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Am făcut achiziții de pe site-ul mărcii Ploom (www.ploom.ro)' && question50SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Am fost în contact cu serviciul de asistență pentru clienți Ploom (soluționare problemelor, informații)' && question51SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Am participat la evenimente organizate sau sponsorizate de Ploom' && question52SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Interacțiuni cu brand ambasadoare/ambasadori ai mărcii Ploom (sesiuni de încercare asistate, oferte speciale și informații despre produsele Ploom)' && question53SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Am făcut achiziții dintr-un magazin specializat al mărcii Ploom/O insulă Ploom din Mall' && question54SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Servicii/experiențe la magazinele/insulele Ploom din Mall (excluzând achizițiile)' && question55SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Reclame Ploom online sau în afara mediului online (panouri publicitare, videoclipuri pe mașini etc.)' && question56SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Informații de la vânzători în magazine (inclusiv oferte speciale și informații despre produsele Ploom)' && question57SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Am văzut reclame la benzinării sau magazine/chioșcuri' && question58SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Am citit informații pe site-uri de știri sau forumuri pe internet' && question59SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Am văzut un videoclip pe YouTube' && question60SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Am văzut un stand al mărcii Ploom la un festival' && question61SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Am văzut marcă Ploom pe un afiș al unui eveniment (sponsor al evenimentului)' && question62SelectedIds.length != 0) numberOfQuestionAnswered += 1;

            })

            // console.log(this.question63.responses.filter(r => r.selected).map(r => r.id))
            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion46.length;
            if (hasAnsweredAllQuestionsBeforeShowingThis && selectedAtQuestion46.length > 0) {
                return true;
            } else {
                this.question63.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
            // return true;

        }



        // (4.4) PLOOM IMPROVEMENT
        this.question64 = new Question(146, [this.question63.id],
            'Ce ar putea fi îmbunătățit pentru a crește nota dată?',
            'Te rugăm să selectezi toate afirmațiile care se aplică',
            'checkbox-free',
            [new Response(1, 'Creșterea varietății sortimentelor de tutun aromatic la rezerve/ stick-urile cu tutun de încălzit'),
            new Response(2, 'Reducerea prețului pachetelor de rezerve/ stick-urile cu tutun de încălzit'),
            new Response(3, 'Dispariția senzației neplăcute (ex: dificultatea de a trage, senzația de încălzire a buzelor etc)'),
            new Response(4, 'Reducerea mirosului neplăcut'),
            new Response(5, 'Creșterea duratei unei sesiuni de utilizare'),
            new Response(6, 'Existența unei baterii mai puternice'),
            new Response(7, 'Îmbunătățirea gustului per total'),
            new Response(8, 'Același gust de la început până la sfârșit/ Îmbunătățirea consecvenței gustului pe parcursul utilizării rezervei / stick-ului cu tutun de încălzit'),
            new Response(9, 'Oferirea mai multor opțiuni pentru personalizare (Ex. culori ale dispozitivului, ediții limitate de dispozitiv, accesorii pentru dispozitiv etc)'),
            new Response(10, 'Reducerea prețului dispozitivului'),
            new Response(11, 'Îmbunătățirea ușurinței de întreținere a dispozitivului'),
            new Response(12, 'Îmbunătățirea design-ului dispozitivului (Ex. materiale, formă, dimensiune, ușor de purtat etc)'),
            new Response(13, 'Îmbunătățirea utilizării dispozitivului'),
            new Response(14, 'Imaginea mărcii Ploom să devină mai relevantă pentru mine'),
            new Response(15, 'Oferirea mai multor servicii suplimentare (Ex. spații speciale Ploom, invitații la evenimente, programe de loialitate etc)'),
            new Response(16, 'Dovezi că produsul reduce riscurile asociate cu fumatul'),
            new Response(17, 'Organizarea mai multor locuri în care produsul poate fi utilizat'),
            new Response(18, 'Altele')],
            true,
            'vertical'
        );

        this.question64.render = () => {
            if (this.endgame == true) { return false; }
            let question63SelectedSel = this.question63.responses.filter(r => r.selected);

            let question64SelectedIds = this.question64.responses.filter(r => r.selected)

            if (!question64SelectedIds.map(r => r.text).includes('Altele')) {
                if (this.question64.responses && this.question64.responses[17]) {
                    this.question64.responses[17].freeMessage = "";
                }
            }
            if (question63SelectedSel.length > 0 && question63SelectedSel[0].id >= 0 && question63SelectedSel[0].id <= 6) {
                return true
            } else {
                this.question64.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        // (4.4.1) PLOOM IMPROVEMENT
        this.question65 = new Question(147, [this.question63.id],
            'Ce ar putea fi îmbunătățit pentru a oferi o notă mai mare (9 sau 10)?',
            'Te rugăm să selectezi toate afirmațiile care se aplică',
            'checkbox-free',
            [new Response(1, 'Creșterea varietății sortimentelor de tutun aromatic la rezerve/ stick-urile cu tutun de încălzit'),
            new Response(2, 'Raportul bun calitate-preț al pachetelor de rezerve/ stick-uri cu tutun de încălzitReducerea prețului pachetelor de rezerve/ stick-urile cu tutun de încălzit'),
            new Response(3, 'Dispariția senzației neplăcute (ex: dificultatea de a trage, senzația de încălzire a buzelor etc)'),
            new Response(4, 'Reducerea mirosului neplăcut'),
            new Response(5, 'Creșterea duratei unei sesiuni de utilizare'),
            new Response(6, 'Existența unei baterii mai puternice'),
            new Response(7, 'Îmbunătățirea gustului per total'),
            new Response(8, 'Același gust de la început până la sfârșit / Îmbunătățirea consecvenței gustului pe parcursul utilizării rezervei / stick-ului cu tutun de încălzit'),
            new Response(9, 'Oferirea mai multor opțiuni pentru personalizare (Ex. culori ale dispozitivului, ediții limitate de dispozitiv, accesorii pentru dispozitiv etc)'),
            new Response(10, 'Reducerea prețului dispozitivului'),
            new Response(11, 'Îmbunătățirea ușurinței de întreținere a dispozitivului'),
            new Response(12, 'Îmbunătățirea design-ului dispozitivului (Ex. materiale, formă, dimensiune, ușor de purtat etc)'),
            new Response(13, 'Îmbunătățirea utilizării dispozitivului'),
            new Response(14, 'Imaginea mărcii Ploom să devină mai relevantă pentru mine'),
            new Response(15, 'Oferirea mai multor servicii suplimentare (Ex. spații speciale Ploom, invitații la evenimente, programe de loialitate etc) '),
            new Response(16, 'Dovezi că produsul reduce riscurile asociate cu fumatul'),
            new Response(17, 'Organizarea mai multor locuri în care produsul poate fi utilizat'),
            new Response(18, 'Altele')],
            true,
            'vertical'
        );

        this.question65.render = () => {
            if (this.endgame == true) { return false; }
            let question63SelectedSel = this.question63.responses.filter(r => r.selected);
            let question65SelectedIds = this.question65.responses.filter(r => r.selected)

            if (!question65SelectedIds.map(r => r.text).includes('Altele')) {
                if (this.question65.responses && this.question65.responses[17]) {
                    this.question65.responses[17].freeMessage = "";
                }
            }
            if (question63SelectedSel.length > 0 && question63SelectedSel[0].id >= 7 && question63SelectedSel[0].id <= 8) {
                return true
            } else {
                this.question65.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        // (4.4.1) PLOOM IMPROVEMENT
        this.question66 = new Question(148, [this.question63.id],
            'Care sunt motivele pentru care ai recomanda Ploom unui alt fumător adult, sau utilizator de dispozitive de încălzit tutunul sau alte produse din plante cu nicotină (de exemplu, unui prieten sau coleg)?',
            'Te rugăm să selectezi toate afirmațiile care se aplică',
            'checkbox-free',
            [new Response(1, 'Îmi place varietatea de sortimente cu tutun aromatic'),
            new Response(2, 'Raportul bun calitate-preț al pachetelor de rezerve/ stick-uri cu tutun de încălzit'),
            new Response(3, 'Senzație plăcută (Ex. ușurința de a trage, fără senzație de încălzire a buzelor etc)'),
            new Response(4, 'Miros plăcut'),
            new Response(5, 'Durata unei sesiuni de utilizare este suficient de lungă pentru mine'),
            new Response(6, 'Are o baterie puternică'),
            new Response(7, 'Îmi place savoarea gustului per total'),
            new Response(8, 'Are același gust de la început până la sfârșit/ gust uniform pe parcursului utilizării rezervei/stick-ului cu tutun de încălzit'),
            new Response(9, 'Are multe opțiuni de personalizare (Ex. opțiuni de culori ale dispozitivului, ediții limitate de dispozitiv, accesorii pentru dispozitiv etc)'),
            new Response(10, 'Raportul calitate preț al dispozitivului este unul bun'),
            new Response(11, 'Dispozitivul se întreține ușor'),
            new Response(12, 'Îmi place design-ul dispozitivului (Ex. materiale, formă, dimensiune, ușor de purtat etc)'),
            new Response(13, 'Dispozitivul este ușor de folosit'),
            new Response(14, 'Imaginea mărcii dispozitivului este relevantă pentru mine'),
            new Response(15, 'Ploom oferă servicii suplimentare (Ex. spații create/ oferite de către Ploom, invitații la evenimente, programe de loialitate etc)'),
            new Response(16, 'Simt mai puțină presiune socială prin utilizarea acestui produs decât atunci când fumez/ fumam țigarete (țigarete convenționale, în pachet)'),
            new Response(17, 'Poate fi folosit în locuri in care de obicei nu pot fuma țigarete (țigarete convenționale, în pachet)'),
            new Response(18, 'Sunt potențial mai puțin dăunătoare pentru sănătate decât fumatul de țigarete (țigarete convenționale, în pachet)'),
            new Response(19, 'Altele')],
            true,
            'vertical'
        );

        this.question66.render = () => {
            if (this.endgame == true) { return false; }
            let question63SelectedSel = this.question63.responses.filter(r => r.selected);

            let question66SelectedIds = this.question66.responses.filter(r => r.selected)

            if (!question66SelectedIds.map(r => r.text).includes('Altele')) {
                if (this.question66.responses && this.question66.responses[18]) {
                    this.question66.responses[18].freeMessage = "";
                }
            }
            if (question63SelectedSel.length > 0 && question63SelectedSel[0].id >= 9 && question63SelectedSel[0].id <= 10) {
                return true
            } else {
                this.question66.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }



        // (5,1) PLOOM NO LONGER USAGE
        this.question67 = new Question(149, [this.question4.id],
            'Ai bifat că nu mai utilizezi Ploom. Care sunt motivele?',
            'Te rugăm să selectezi toate afirmațiile care se aplică',
            'checkbox-free',
            [new Response(1, 'Varietate limitată a sortimentelor de tutun aromatic la rezerve/ stick-uri  cu tutun de încălzit'),
            new Response(2, 'Pachetele de rezerve/ stick-uri cu tutun de încălzit sunt foarte scumpe'),
            new Response(3, 'Senzație neplăcută (Ex. dificultatea de a trage, senzație de încălzire a buzelor etc)'),
            new Response(4, 'Miros neplăcut'),
            new Response(5, 'Durata scăzută/ limitată a unei sesiuni de utilizare'),
            new Response(6, 'Baterie slabă/ nu tine suficient de mult'),
            new Response(7, 'Nu mi-a plăcut gustul'),
            new Response(8, 'Nu e același gust de la început până la sfârșit / gust diferit pe parcursul utilizării unei rezerve/ unui stick cu tutun de încălzit'),
            new Response(9, 'Nu sunt suficiente opțiuni de personalizare (Ex. opțiuni de culori ale dispozitivului, ediții limitate de dispozitiv, accesorii pentru dispozitiv etc)'),
            new Response(10, 'Raportul calitate-preț al dispozitivului nu este satisfăcător'),
            new Response(11, 'Întreținerea dispozitivului este complexă și greoaie'),
            new Response(12, 'Nu îmi place design-ul dispozitivului (Ex materiale, formă, dimensiune, greu de purtat etc)'),
            new Response(13, 'Dispozitiv dificil de utilizat'),
            new Response(14, 'Imaginea mărcii dispozitivului este irelevantă pentru mine'),
            new Response(15, 'Ploom nu oferă suficiente servicii suplimentare (Ex spații create de către Ploom, invitații la evenimente, programe de loialitate etc)'),
            new Response(16, 'Presiune socială din cauza consumului de nicotină'),
            new Response(17, 'Nu sunt suficiente locuri în care produsul poate fi folosit'),
            new Response(18, 'Nu sunt sigur/ă că este cu potențial mai puțin dăunător pentru sănătatea mea'),
            new Response(19, 'Am cumpărat/ primit un alt dispozitiv și îl folosesc pe acela'),
            new Response(20, 'Prefer să fumez în continuare țigarete (țigarete convenționale, în pachet)/ tutun rulat'),
            new Response(21, 'Am renunțat la fumat și vapat'),
            new Response(22, 'Nu doresc să îl folosesc'),
            new Response(23, 'Folosesc alte produse cu tutun, (Ex. pliculețe cu nicotină, narghilea, cigarillos etc)'),
            new Response(24, 'Altele')],
            true,
            'vertical'
        );

        this.question67.render = () => {
            if (this.endgame == true) { return false; }

            // let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            // let question3SelectedIds = this.question3.responses.filter(r => r.selected).map(r => r.text);

            let question4SelectedIds = this.question4.responses.filter(r => r.selected);
            let question4_glo_uniqSelectedIds = this.question4_glo_hyper_uniq.responses.filter(r => r.selected);
            let question4_glo_x2_airSelectedIds = this.question4_glo_hyper_x2_air.responses.filter(r => r.selected);
            let question4_glo_x2SelectedIds = this.question4_glo_hyper_x2.responses.filter(r => r.selected);
            let question4_glo_proSelectedIds = this.question4_glo_hyper_pro.responses.filter(r => r.selected);
            let question4_iqos_ilumaSelectedIds = this.question4_iqos_iluma.responses.filter(r => r.selected);
            let question4_iqos_iluma_oneSelectedIds = this.question4_iqos_iluma_one.responses.filter(r => r.selected);
            let question4_iqos_iluma_primeSelectedIds = this.question4_iqos_iluma_prime.responses.filter(r => r.selected);
            let question4_iqos_iluma_duoSelectedIds = this.question4_iqos_iluma_original_duo.responses.filter(r => r.selected);
            let question4_lil_solidezSelectedIds = this.question4_lil_solidez.responses.filter(r => r.selected);



            let question67SelectedIds = this.question67.responses.filter(r => r.selected)

            if (!question67SelectedIds.map(r => r.text).includes('Altele')) {
                if (this.question67.responses && this.question67.responses[23]) {
                    this.question67.responses[23].freeMessage = "";
                }
            }

            this.last_question_number_ploom_1 = this.question5.id;
            let numberOfQuestionAnswered = 0;
            let selectedBrandsAtQuestion3 = this.question3.responses.filter(rsp => rsp.selected).map(resp => resp.text);

            selectedBrandsAtQuestion3.map(brand => {
                if (brand == 'Ploom' && question4SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma' && question4_iqos_ilumaSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma One' && question4_iqos_iluma_oneSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Iluma Prime' && question4_iqos_iluma_primeSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'IQOS Original Duo' && question4_iqos_iluma_duoSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper + uniq' && question4_glo_uniqSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2 Air' && question4_glo_x2_airSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper X2' && question4_glo_x2SelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Glo Hyper Pro' && question4_glo_proSelectedIds.length != 0) numberOfQuestionAnswered += 1;
                if (brand == 'Lil Solid EZ' && question4_lil_solidezSelectedIds.length != 0) numberOfQuestionAnswered += 1;
            })

            // answer to all questions => numberOfQuestionAnswered = selectedBrandsAtQuestion3.length
            const hasAnsweredAllQuestionsBeforeShowingThis = numberOfQuestionAnswered == selectedBrandsAtQuestion3.length;
            if (selectedBrandsAtQuestion3.includes('Ploom') && question4SelectedIds.length > 0 && question4SelectedIds?.[0]?.id >= 4 && question4SelectedIds?.[0]?.id <= 5 && hasAnsweredAllQuestionsBeforeShowingThis) {
                return true;
            } else {
                this.question67.responses.forEach(r => {
                    r.selected = false;
                });
            }
            return false;
        }


        this.questions = [this.questionGateAge,
        this.question1, this.question2, this.question3,
        this.question4_iqos_iluma, this.question4_iqos_iluma_one, this.question4_iqos_iluma_prime, this.question4_iqos_iluma_original_duo, this.question4, this.question4_glo_hyper_uniq,
        this.question4_glo_hyper_x2_air, this.question4_glo_hyper_x2, this.question4_glo_hyper_pro, this.question4_lil_solidez,
        this.question5_1_iqos_iluma, this.question5_1_iqos_iluma_one, this.question5_1_iqos_iluma_prime, this.question5_1_iqos_iluma_original_duo, this.question5_1_Ploom, this.question5_1_glo_uniq, this.question5_1_glo_air,
        this.question5_1_glo_x2, this.question5_1_glo_pro, this.question5_1_lil_solidez,
        this.question5_2_iqos_iluma, this.question5_2_iqos_iluma_one, this.question5_2_iqos_iluma_prime, this.question5_2_iqos_iluma_original_duo, this.question5_2_Ploom, this.question5_2_glo_uniq, this.question5_2_glo_air,
        this.question5_2_glo_x2, this.question5_2_glo_pro, this.question5_2_lil_solidez,
        this.question5_iqos_iluma_one, this.question5_iqos_iluma_prime, this.question5_iqos_iluma_original_duo, this.question5_lil_solidez, this.question5, this.question5_glo_uniq, this.question5_glo_air, this.question5_glo_x2, this.question5_glo_pro, this.question5_iqos_iluma,
        this.question6, this.question7_iqos_iluma, this.question7_iqos_iluma_one, this.question7_iqos_iluma_prime, this.question7_iqos_original_duo, this.question7_ploomx, this.question7_glo_uniq, this.question7_glo_air, this.question7_glo_x2, this.question7_glo_pro, this.question7_lil_solidez,
        this.question8_iluma, this.question8_iluma_one, this.question8_iluma_prime, this.question8_duo, this.question8_ploom, this.question8_uniq, this.question8_air, this.question8_x2, this.question8_pro, this.question8_lil,
        this.question9, this.question10_Sobranie, this.question10_Terea, this.question10_Levia, this.question10_HEETS, this.question10_DELIA, this.question10_Dunhill, this.question10_veo, this.question10_neo, this.question10_Kent, this.question10_Fiit, this.question10_Nuso,
        this.question11, this.question12, this.question13, this.question14, this.question15,
        this.question16, this.question17, this.question18, this.question15_1,
        this.question16_1, this.question17_1, this.question18_1,
        this.question15_2,
        this.question16_2, this.question17_2, this.question18_2,
        this.question19, this.question20, this.question21, this.question22, this.question23,
        this.question24, this.question25, this.question26, this.question27,
        this.question28, this.question29,
        this.question30, this.question31, this.question32_a, this.question32_b, this.question32_c,
        this.question33, this.question34, this.question35, this.question36, this.question37, this.question37_a, this.question37_b, this.question37_c, this.question37_d, this.question37_e, this.question38, this.question39,
        //@ts-ignore
        ...Object.keys(this.questionsShuffleIndexes).sort((a, b) => this.questionsShuffleIndexes[a] - this.questionsShuffleIndexes[b]).map(key => this[key]), this.question46, this.question47, this.question48, this.question49, this.question50,
        this.question51, this.question52, this.question53, this.question54,
        this.question55, this.question56, this.question57, this.question58, this.question59, this.question60, this.question61, this.question62, this.question63, this.question64, this.question65, this.question66, this.question67
        ];

        // console.log(this.questions)

    }

    getQuestions(): Array<Question> {
        return this.questions;
    }






    question18Responses = [new Response(1, "Camel Filters (galben, scurte)/ Camel Yellow (scurte)"),
    new Response(2, "Camel Filters (galben, lungi)/ / Camel Yellow (lungi)"),
    new Response(3, "Camel Compact negru (lungi)"),
    new Response(4, "Camel Compact albastru (lungi)"),
    new Response(5, "Camel Caster (lungi)"),
    new Response(6, "Camel 1913 Original Filters (galben, cu camila neagra, lungi)"),
    new Response(7, "Camel 1913 Original Blue (albastru deschis, cu camila neagra, lungi)"),
    new Response(8, "Camel 1913 Original Black (negru, cu camila galbena, lungi)"),
    new Response(9, "Davidoff Classic (lungi, normale, pachet rosu inchis)"),
    new Response(10, "Davidoff Gold normale (lungi, pachet auriu)"),
    new Response(11, "Davidoff Gold SL-Line (subtiri, lungi, pachet auriu)"),
    new Response(12, "Davidoff Magenta (subtiri, lungi, pachet mov)"),
    new Response(13, "Davidoff SSL-Line Lilac subtiri (negru cu mici forme geometrice in colturi, lungi)"),
    new Response(14, "Davidoff SSL-Line Rose subtiri (roz, lungi)"),
    new Response(15, "Davidoff Silver normale (argintiu, lungi)"),
    new Response(16, "Davidoff Silver SL-Line (subtiri, lungi, pachet argintiu)"),
    new Response(17, "Davidoff Classic SL-Line subtiri (lungi, pachet rosu inchis)"),
    new Response(18, "Davidoff White subtiri (alb, lungi)"),
    new Response(19, "Davidoff District Negru (normale, lungi, cu filtru negru)"),
    new Response(20, "Davidoff District Gold (subtiri, lungi, cu filtru auriu, pachet auriu cu un colt alb)"),
    new Response(21, "Davidoff Teal (negru cu mici forme geometrice in colturi, tigareta cu filtru verde)"),
    new Response(22, "Dunhill Evoque Blue (lungi, pachet cu mix de nuante de albastru si putin rosu in stanga)"),
    new Response(23, "Dunhill Evoque Bronze (lungi, pachet mix de culori pastelate)"),
    new Response(24, "Dunhill Evoque SS (subtiri, lungi, pachet verde inchis cu o fasie rosu cu maro deschis)"),
    new Response(25, "Dunhill Evoque SS (subtiri, lungi, pachet roz inchis cu o fasie rosu cu maro deschis)"),
    new Response(26, "Dunhill Evoque SS (subtiri, lungi, pachet alb cu o fasie rosu cu maro deschis)"),
    new Response(27, "Dunhill Opus Enigma Black (lungi, pachet negru, tigarete cu filtru negru)"),
    new Response(28, "Dunhill Opus Enigma Blue (lungi, pachet mix nuante de albastru si linii aurii/ flori de gheata)"),
    new Response(29, "Dunhill albastru (lungi, pachet albastru complet)"),
    new Response(30, "Dunhill Blonde Blend (lungi, pachet cu bej deschis si bej inschis)"),
    new Response(31, "Dunhill negru (lungi, albe, pachet negru complet)"),
    new Response(32, "Dunhill alb Fine Cut (lungi, pachet alb complet)"),
    new Response(33, "Dunhill Fine Cut (tigarete negre, lungi, in pachet rosu cu puncte si putin negru)"),
    new Response(34, "Dunhill Signature Turquoise (lungi, pachet turcois)"),
    new Response(35, "Dunhill Signature Purple (lungi, pachet mov)"),
    new Response(36, "Dunhill Signature Black (lungi, tigarete cu filtru negru, pachet negru complet)"),
    new Response(37, "Dunhill Signature White (lungi, pachet alb complet, tigarete cu dunga aurie sau rosie pe filtru)"),
    new Response(38, "Kent Core Black (lungi, pachet negru)"),
    new Response(39, "Kent Core Blue/Kent 8 ( scurte, pachet albastru)"),
    new Response(40, "Kent Core Blue/Kent 8 (lungi, pachet albastru)"),
    new Response(41, "Kent Core Silver (scurte, pachet gri)"),
    new Response(42, "Kent Core Silver (lungi, pachet gri))"),
    new Response(43, "Kent Core White (lungi, pachet alb)"),
    new Response(44, "Kent Mode Blue (lungi, pachet cu albastru deschis si albatsru inchis)"),
    new Response(45, "Kent Mode Silver (lungi, pachet cu gri si albastru)"),
    new Response(46, "Kent Mode Lumina (lungi, pachet negru cu model fagure albastru)"),
    new Response(47, "Kent Mode Eklipse Burgundy (subtiri, pachet cu visiniu)"),
    new Response(48, "Kent Mode Eklipse Sage Green (subtiri, pachet verde inchis cu verde mai deschis)"),
    new Response(49, "Kent Mode Komet Azure (lungi, pachet albastru deschis cu albastru azur si stelute in stanga)"),
    new Response(50, "Kent Mode Komet Blue (lungi, pachet albastru deschis cu albastru inchis si stelute in stanga)"),
    new Response(51, "Kent Mode Komet Navy Blue (lungi, pachet albastru inchis cu stelute in stanga)"),
    new Response(52, "Kent Nano Silver (subtiri, scurte, in pachet negru cu model de romburi mici)"),
    new Response(53, "Kent Nano White (subtiri, scurte, in pachet negru cu gri si model de romburi mici)"),
    new Response(54, "Kent lungi, fostul pachet necartonat/ pachet alb cu castel"),
    new Response(55, "Lucky Strike alb cu bulina rosie ( scurte)"),
    new Response(56, "Marlboro Gold scurte"),
    new Response(57, "Marlboro Gold lungi"),
    new Response(58, "Marlboro rosu lungi"),
    new Response(59, "Marlboro rosu scurte"),
    new Response(60, "Marlboro Filter Plus (lungi)"),
    new Response(61, "Marlboro Filter Plus ( scurte)"),
    new Response(62, "Marlboro Fine Touch albastru deschis ( scurte)"),
    new Response(63, "Marlboro Fine Touch XL albastru deschis (lungi)"),
    new Response(64, "Marlboro Gold Touch XL (pachet cu auriu)"),
    new Response(65, "Marlboro Red Touch XL (pachet negru)"),
    new Response(66, "Marlboro Touch albastru inchis ( scurte)"),
    new Response(67, "Marlboro Touch Plus XL (pachet albastru deschis, lungi)"),
    new Response(68, "Marlboro Touch XL albastru inchis (lungi)"),
    new Response(69, "Marlboro Micro Touch Green (subtiri, pachet verde)"),
    new Response(70, "Marlboro Micro Fine Touch albastru deschis (subtiri)"),
    new Response(71, "Marlboro Micro Touch albastru inchis (subtiri)"),
    new Response(72, "Pall Mall albastru (scurte, in pachet albastru-inchis cu 2 dungi albastru-deschis in mijloc)"),
    new Response(73, "Pall Mall Extra Cut Blue (lungi, pachet gri-inchis cu 2 dungi albastru-deschis in mijloc)"),
    new Response(74, "Pall Mall Extra Cut White (lungi, pachet gri cu 2 dungi gri-deschis in mijloc)"),
    new Response(75, "Pall Mall Extra Cut Black (lungi, pachet negru cu 2 dungi albastru-inchis in mijloc)"),
    new Response(76, "Pall Mall S-Line Purple (subtiri, pachet mov deschis)"),
    new Response(77, "Pall Mall S-Line Rose (subtiri, pachet roz deschis)"),
    new Response(78, "Pall Mall S-Line turcoaz (subtiri, pachet turcoaz)"),
    new Response(79, "Pall Mall Ascend Black (lungi, pachet negru cu 2 dungi negre la mijloc, tigarete cu filtru negru)"),
    new Response(80, "Pall Mall Ascend Rose Gold (lungi, pachet bej cu 2 dungi maro la mijloc, tigarete cu filtru bej)"),
    new Response(81, "Parliament Aqua Blue lungi"),
    new Response(82, "Parliament Aqua Blue scurte"),
    new Response(83, "Parliament Reserve Premium (subtiri, lungi)"),
    new Response(84, "Parliament Manhattan NYC Night (albastru inchis)"),
    new Response(85, "Parliament Manhattan NYC Aqua (albastru deschis)"),
    new Response(86, "Rothmans - alb cu albastru"),
    new Response(87, "Rothmans Classic Blue (lungi, pachet albastru-inchis)"),
    new Response(88, "Rothmans Classic Black (lungi, pachet negru)"),
    new Response(89, "Rothmans Classic Red (lungi, pachet rosu)"),
    new Response(90, "Rothmans Classic Azure (lungi, pachet albastru-deschis)"),
    new Response(91, "Rothmans International Black (subtiri, pachet negru, tigarete cu filtru negru)"),
    new Response(92, "Rothmans International Blue (subtiri, pachet albastru, tigarete cu filtru albastru)"),
    new Response(93, "Sobranie Black (scurte, pachet negru)"),
    new Response(94, "Sobranie Redefined Black (negru, lungi)"),
    new Response(95, "Sobranie Redefined Blue (albastru, lungi)"),
    new Response(96, "Sobranie Redefined Chrome (gri, lungi)"),
    new Response(97, "Sobranie Redefined White (alb, lungi)"),
    new Response(98, "Sobranie Redefined Rosu (pachet negru cu rosu)"),
    new Response(99, "Sobranie Super S Black (subtiri, pachet negru, tigarete albe)"),
    new Response(100, "Sobranie Super S Pink (subtiri, pachet roz)"),
    new Response(101, "Sobranie Super S White (subtiri, pachet alb)"),
    new Response(102, "Sobranie Super S Cocktail (subtiri, pachet roz deschis, tigarete colorate)"),
    new Response(103, "Sobranie Super S Christmas (subtiri, pachet negru cu puncte aurii)"),
    new Response(104, "Sobranie Collection negru (subtiri, lungi, pachet lat negru, tigarete albe, filtru negru)"),
    new Response(105, "Sobranie Collection Gold (subtiri, lungi, pachet lat roz si alb, tigarete cu filtru auriu)"),
    new Response(106, "Sobranie Collection alb (subtiri, lungi, pachet lat alb, tigarete cu filtru auriu)"),
    new Response(107, "Sobranie Collection Red (subtiri, lungi, pachet lat negru cu rosu, tigarete negre)"),
    new Response(108, "Sobranie Collection Lumia (subtiri, lungi, pachet lat crem cu maro, tigarete cu filtru maro)"),
    new Response(109, "Sobranie Collection albastru (subtiri, lungi, pachet lat negru cu albastru, tigarete cu filtru albastru)"),
    new Response(110, "Vogue La cigarette Bleue (subtiri, lungi, pachet mov)"),
    new Response(111, "Vogue La cigarette Ivoire (subtiri, lungi, pachet crem)"),
    new Response(112, "Vogue La cigarette Lilas (subtiri, lungi, pachet roz)"),
    new Response(113, "Vogue La cigarette Bleue Unique (subtiri, lungi, pachet negru, tigarete cu filtru albastru-deschis)"),
    new Response(114, "Vogue La cigarette Rose Unique (subtiri, lungi, pachet negru, tigarete cu filtru roz)"),
    new Response(115, "Winston Blue lungi (pachet alb cu albastru)"),
    new Response(116, "Winston Blue scurte (pachet alb cu albastru)"),
    new Response(117, "Winston Classic rosu (lungi)"),
    new Response(118, "Winston Classic rosu ( scurte)"),
    new Response(119, "Winston Silver (scurte, pachet alb cu gri)"),
    new Response(120, "Winston Super Line Blue (subtiri, pachet alb cu puncte albastre in stanga)"),
    new Response(121, "Winston Super Line Silver (subtiri, pachet alb cu puncte albastre in stanga)"),
    new Response(122, "Winston Caster Super Line (subtiri, lungi, pachet auriu inchis)"),
    new Response(123, "Winston Nova Blue (lungi, pachet albastru complet cu puncte albastre)"),
    new Response(124, "Winston Nova Gold (lungi, pachet auriu cu puncte aurii)"),
    new Response(125, "Winston Plus Red (lungi, pachet negru cu puncte gri inchis)"),
    new Response(126, "Winston XSpression (lungi, pachet albastru deshis si albastru inchis)"),
    new Response(127, "Winston Xspression Super Line (subtiri, lungi, pachet alb cu albastru deschis)"),
    new Response(128, "Winston Caster (lungi, pachet alb cu aramiu dungi si puncte aramii)"),
    new Response(129, "Winston Selection Night (lungi, maro inchis)"),
    new Response(130, "Winston Selection Sunrise (lungi, verde inchis)"),
    new Response(131, "Winston Selection Sunset (lungi, portocaliu inchis)"),
    new Response(132, "Winston Selection Skylite (lungi, albastru cu o parte portocalie)"),
    new Response(133, "Altă variantă")];


    question25Responses =
        [
            new Response(1, "Allure",),
            new Response(2, "Ashima"),
            new Response(3, "Austin"),
            new Response(4, "Bentley"),
            new Response(5, "Brass"),
            new Response(6, "Camel"),
            new Response(7, "Carpati"),
            new Response(8, "Chapman Classic"),
            new Response(9, "CHE"),
            new Response(10, "CHESTERFIELD"),
            new Response(11, "Cigaronne"),
            new Response(12, "Cohiba"),
            new Response(13, "Corset"),
            new Response(14, "Davidoff"),
            new Response(15, "De Santis"),
            new Response(16, "Denim"),
            new Response(17, "Dubao"),
            new Response(18, "Dune"),
            new Response(19, "Dunhill"),
            new Response(20, "Esse"),
            new Response(21, "Fast Revolution"),
            new Response(22, "Fuyan"),
            new Response(23, "George Karelias & Sons"),
            new Response(24, "Golden Monkey"),
            new Response(25, "Goldfield"),
            new Response(26, "Karelia"),
            new Response(27, "Kent"),
            new Response(28, "L&M"),
            new Response(29, "Lucky Strike"),
            new Response(30, "Marble"),
            new Response(31, "Marlboro"),
            new Response(32, "Morgan"),
            new Response(33, "Ome"),
            new Response(34, "Pall Mall"),
            new Response(35, "Pannonia"),
            new Response(36, "Parliament"),
            new Response(37, "Pueblo"),
            new Response(38, "Rothmans"),
            new Response(39, "SILVERADO"),
            new Response(40, "Skull American Blend"),
            new Response(41, "Snagov"),
            new Response(42, "Sobranie"),
            new Response(43, "Souveran"),
            new Response(44, "Swift"),
            new Response(45, "Tennesie"),
            new Response(46, "The King"),
            new Response(47, "Viceroy"),
            new Response(48, "Vogue"),
            new Response(49, "WEST"),
            new Response(50, "Winchester"),
            new Response(51, "Winston"),
            new Response(52, 'Altă marcă')
        ]


    question27Responses =
        [
            new Response(1, "ALTORA"),
            new Response(2, "Bali Shag"),
            new Response(3, "Bronx"),
            new Response(4, "Casablanca"),
            new Response(5, "Che"),
            new Response(6, "Chesterfield"),
            new Response(7, "Choice"),
            new Response(8, "D&B"),
            new Response(9, "Django"),
            new Response(10, "Drum"),
            new Response(11, "Eastwood"),
            new Response(12, "Firicel"),
            new Response(13, "Flandria"),
            new Response(14, "Golden Virginia"),
            new Response(15, "Look Out"),
            new Response(16, "Mac Baren"),
            new Response(17, "Marlboro"),
            new Response(18, "Primus"),
            new Response(19, "PUEBLO"),
            new Response(20, "Red Bull"),
            new Response(21, "Red Field"),
            new Response(22, "RioTabak"),
            new Response(23, "Sauvage"),
            new Response(24, "SENATOR"),
            new Response(25, "Silverado"),
            new Response(26, "Stanley"),
            new Response(27, "The Turner"),
            new Response(28, "Tilbury"),
            new Response(29, "VaBanque"),
            new Response(30, "West"),
            new Response(31, 'Altă marcă')

        ]




    question29Responses = [
        new Response(1, "Altora"),
        new Response(2, "Baron"),
        new Response(3, "Camo"),
        new Response(4, "Cuba"),
        new Response(5, "Drooly"),
        new Response(6, "EOS"),
        new Response(7, "Grant"),
        new Response(8, "HIT"),
        new Response(9, "Iceberg"),
        new Response(10, "Killa"),
        new Response(11, "Klint"),
        new Response(12, "Niccos"),
        new Response(13, "Pablo"),
        new Response(14, "POP"),
        new Response(15, "Senator"),
        new Response(16, "SNO"),
        new Response(17, "Strom"),
        new Response(18, "Thunder"),
        new Response(19, "V & YOU & Boost"),
        new Response(20, "Velo"),
        new Response(21, "White FOX"),
        new Response(22, "XQS"),
        new Response(23, "ZYN"),
        new Response(24, "77"),
        new Response(25, "Altă marcă")
    ];


    question30Responses = [
        new Response(1, "Țigări electronice de unică folosință", [], './assets/images/folosinta.png'),
        new Response(2, "Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil", [], './assets/images/vaporizatoare.png'),
        new Response(3, "Țigarete electronice cu pod-uri/capsule cu lichid", [], './assets/images/poduri.png')
    ];// de completat

    question31Responses = [new Response(1, "Țigări electronice de unică folosință"),
    new Response(2, "Vaporizatoare/Țigări electronice cu rezervor încorporat re-încărcabil"),
    new Response(3, "Țigarete electronice cu pod-uri/capsule cu lichid")]; // de completat



    question32_aResponses =
        [

            new Response(1, 'AK by Atomic'),
            new Response(2, 'Blu Bar'),
            new Response(3, 'Bro Twist'),
            new Response(4, 'Cool Play'),
            new Response(5, 'Elf Bar'),
            new Response(6, 'FlerBar'),
            new Response(7, 'Fumz'),
            new Response(8, 'Geek Bar'),
            new Response(9, 'Izy'),
            new Response(10, 'Lost Mary'),
            new Response(11, 'Luuv'),
            new Response(12, 'MiniVape'),
            new Response(13, 'One Puff'),
            new Response(14, 'Only1'),
            new Response(15, 'Oops'),
            new Response(16, 'Oree'),
            new Response(17, 'Rebelliq'),
            new Response(18, 'Ske Crystal Bar'),
            new Response(19, 'Uno (Veevo)'),
            new Response(20, 'Vaal'),
            new Response(21, 'Vapepro'),
            new Response(22, 'Vapeurs'),
            new Response(23, 'Vapy'),
            new Response(24, 'Veeba'),
            new Response(25, 'Veev NOW'),
            new Response(26, 'Voom'),
            new Response(27, 'Vozol'),
            new Response(28, 'Vuse GO'),
            new Response(29, 'Waka'),
            new Response(30, 'Wiip'),
            new Response(31, 'Altă marcă')
        ];


    question32_bResponses =
        [

            new Response(1, 'Bloss'),
            new Response(2, 'Hangsen'),
            new Response(3, 'Elf Bar'),
            new Response(4, 'Innokin'),
            new Response(5, 'Liqua'),
            new Response(6, 'Relx'),
            new Response(7, 'Ske Crystal Bar'),
            new Response(8, 'Smok'),
            new Response(9, 'Smokemania'),
            new Response(10, 'Altă marcă')
        ];


    question32_cResponses =
        [

            new Response(1, 'Caliburn G.'),
            new Response(2, 'Elf Bar'),
            new Response(3, 'Eleaf'),
            new Response(4, 'Innokin'),
            new Response(5, 'Joyetech'),
            new Response(6, 'Vaporesso'),
            new Response(7, 'Veev ONE'),
            new Response(8, 'Vozol Switch'),
            new Response(9, 'Zeep Pod'),
            new Response(10, 'Yoop'),
            new Response(11, 'Altă marcă')
        ];



    question36Responses =
        [
            new Response(1, "Allure", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(2, "Ashima", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(3, "Austin", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(4, "Bentley", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(5, "Brass", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(6, "Camel", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(7, "Carpati", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(8, "Chapman Classic", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(9, "CHE", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(10, "CHESTERFIELD", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(11, "Cigaronne", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(12, "Cohiba", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(13, "Corset", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(14, "Davidoff", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(15, "De Santis", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(16, "Denim", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(17, "Dubao", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(18, "Dune", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(19, "Dunhill", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(20, "Esse", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(21, "Fast Revolution", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(22, "Fuyan", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(23, "George Karelias & Sons", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(24, "Golden Monkey", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(25, "Goldfield", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(26, "Karelia", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(27, "Kent", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(28, "L&M", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(29, "Lucky Strike", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(30, "Marble", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(31, "MARLBORO", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(32, "Morgan", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(33, "Ome", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(34, "Pall Mall", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(35, "Pannonia", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(36, "Parliament", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(37, "Pueblo", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(38, "Rothmans", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(39, "SILVERADO", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(40, "Skull American Blend", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(41, "Snagov", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(42, "Sobranie", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(43, "Souveran", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(44, "Swift", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(45, "Tennesie", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(46, "The King", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(47, "Viceroy", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(48, "Vogue", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(49, "WEST", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(50, "Winchester", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(51, "Winston", undefined, undefined, undefined, undefined, 'RMC'),
            new Response(52, "ALTORA", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(53, "Bali Shag", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(54, "Bronx", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(55, "Casablanca", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(56, "Che", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(57, "Chesterfield", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(58, "Choice", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(59, "D&B", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(60, "Django", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(61, "Drum", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(62, "Eastwood", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(63, "Firicel", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(64, "Flandria", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(65, "Golden Virginia", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(66, "Look Out", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(67, "Mac Baren", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(68, "Marlboro", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(69, "Primus", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(70, "PUEBLO", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(71, "Red Bull", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(72, "Red Field", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(73, "RioTabak", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(74, "Sauvage", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(75, "SENATOR", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(76, "Silverado", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(77, "Stanley", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(78, "The Turner", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(79, "Tilbury", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(80, "VaBanque", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(81, "West", undefined, undefined, undefined, undefined, 'FCT'),
            new Response(82, "Altora", undefined, undefined, undefined, undefined, 'NP'),
            new Response(83, "Baron", undefined, undefined, undefined, undefined, 'NP'),
            new Response(84, "Camo", undefined, undefined, undefined, undefined, 'NP'),
            new Response(85, "Cuba", undefined, undefined, undefined, undefined, 'NP'),
            new Response(86, "Drooly", undefined, undefined, undefined, undefined, 'NP'),
            new Response(87, "EOS", undefined, undefined, undefined, undefined, 'NP'),
            new Response(88, "Grant", undefined, undefined, undefined, undefined, 'NP'),
            new Response(89, "HIT", undefined, undefined, undefined, undefined, 'NP'),
            new Response(90, "Iceberg", undefined, undefined, undefined, undefined, 'NP'),
            new Response(91, "Killa", undefined, undefined, undefined, undefined, 'NP'),
            new Response(92, "Klint", undefined, undefined, undefined, undefined, 'NP'),
            new Response(93, "Niccos", undefined, undefined, undefined, undefined, 'NP'),
            new Response(94, "Pablo", undefined, undefined, undefined, undefined, 'NP'),
            new Response(95, "POP", undefined, undefined, undefined, undefined, 'NP'),
            new Response(96, "Senator", undefined, undefined, undefined, undefined, 'NP'),
            new Response(97, "SNO", undefined, undefined, undefined, undefined, 'NP'),
            new Response(98, "Strom", undefined, undefined, undefined, undefined, 'NP'),
            new Response(99, "Thunder", undefined, undefined, undefined, undefined, 'NP'),
            new Response(100, "V & YOU & Boost", undefined, undefined, undefined, undefined, 'NP'),
            new Response(101, "Velo", undefined, undefined, undefined, undefined, 'NP'),
            new Response(102, "White FOX", undefined, undefined, undefined, undefined, 'NP'),
            new Response(103, "XQS", undefined, undefined, undefined, undefined, 'NP'),
            new Response(104, "ZYN", undefined, undefined, undefined, undefined, 'NP'),
            new Response(105, "77", undefined, undefined, undefined, undefined, 'NP'),
            new Response(106, 'AK by Atomic', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(107, 'Blu Bar', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(108, 'Bro Twist', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(109, 'Cool Play', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(110, 'Elf Bar', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(111, 'FlerBar', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(112, 'Fumz', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(113, 'Geek Bar', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(114, 'Izy', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(115, 'Lost Mary', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(116, 'Luuv', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(117, 'MiniVape', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(118, 'One Puff', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(119, 'Only1', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(120, 'Oops', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(121, 'Oree', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(122, 'Rebelliq', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(123, 'Ske Crystal Bar', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(124, 'Uno (Veevo)', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(125, 'Vaal', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(126, 'Vapepro', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(127, 'Vapeurs', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(128, 'Vapy', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(129, 'Veeba', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(130, 'Veev NOW', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(131, 'Voom', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(132, 'Vozol', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(133, 'Vuse GO', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(134, 'Waka', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(135, 'Wiip', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(136, 'Bloss', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(137, 'Hangsen', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(138, 'Innokin', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(139, 'Liqua', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(140, 'Relx', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(141, 'Smok', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(142, 'Smokemania', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(143, 'Caliburn G.', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(144, 'Eleaf', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(145, 'Joyetech', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(146, 'Vaporesso', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(147, 'Veev ONE', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(148, 'Vozol Switch', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(149, 'Zeep Pod', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(150, 'Yoop', undefined, undefined, undefined, undefined, 'E-vape'),
            new Response(151, 'Glo Hyper + uniq', undefined, undefined, undefined, undefined, 'HT'),
            new Response(152, 'Glo Hyper Pro', undefined, undefined, undefined, undefined, 'HT'),
            new Response(153, 'Glo Hyper X2', undefined, undefined, undefined, undefined, 'HT'),
            new Response(154, 'Glo Hyper X2 Air', undefined, undefined, undefined, undefined, 'HT'),
            new Response(155, 'IQOS Iluma', undefined, undefined, undefined, undefined, 'HT'),
            new Response(156, 'IQOS Iluma One', undefined, undefined, undefined, undefined, 'HT'),
            new Response(157, 'IQOS Iluma Prime', undefined, undefined, undefined, undefined, 'HT'),
            new Response(158, 'IQOS Original Duo', undefined, undefined, undefined, undefined, 'HT'),
            new Response(159, 'Lil Solid EZ', undefined, undefined, undefined, undefined, 'HT'),
            new Response(160, 'Ploom', undefined, undefined, undefined, undefined, 'HT'),

            new Response(161, ''),
            new Response(162, ''),
            new Response(163, ''),
            new Response(164, ''),

        ]

    question38Responses = [

        new Response(1, 'AK by Atomic'),
        new Response(2, 'Blu Bar'),
        new Response(3, 'Bro Twist'),
        new Response(4, 'Cool Play'),
        new Response(5, 'Elf Bar'),
        new Response(6, 'FlerBar'),
        new Response(7, 'Fumz'),
        new Response(8, 'Geek Bar'),
        new Response(9, 'Izy'),
        new Response(10, 'Lost Mary'),
        new Response(11, 'Luuv'),
        new Response(12, 'MiniVape'),
        new Response(13, 'One Puff'),
        new Response(14, 'Only1'),
        new Response(15, 'Oops'),
        new Response(16, 'Oree'),
        new Response(17, 'Rebelliq'),
        new Response(18, 'Ske Crystal Bar'),
        new Response(19, 'Uno (Veevo)'),
        new Response(20, 'Vaal'),
        new Response(21, 'Vapepro'),
        new Response(22, 'Vapeurs'),
        new Response(23, 'Vapy'),
        new Response(24, 'Veeba'),
        new Response(25, 'Veev NOW'),
        new Response(26, 'Voom'),
        new Response(27, 'Vozol'),
        new Response(28, 'Vuse GO'),
        new Response(29, 'Waka'),
        new Response(30, 'Wiip'),


        new Response(31, 'Bloss'),
        new Response(32, 'Hangsen'),
        new Response(33, 'Elf Bar'),
        new Response(34, 'Innokin'),
        new Response(35, 'Liqua'),
        new Response(36, 'Relx'),
        new Response(37, 'Ske Crystal Bar'),
        new Response(38, 'Smok'),
        new Response(39, 'Smokemania'),


        new Response(40, 'Caliburn G.'),
        new Response(41, 'Elf Bar'),
        new Response(42, 'Eleaf'),
        new Response(43, 'Innokin'),
        new Response(44, 'Joyetech'),
        new Response(45, 'Vaporesso'),
        new Response(46, 'Veev ONE'),
        new Response(47, 'Vozol Switch'),
        new Response(48, 'Zeep Pod'),
        new Response(49, 'Yoop'),

        new Response(50, 'Glo Hyper + uniq'),
        new Response(51, 'Glo Hyper Pro'),
        new Response(52, 'Glo Hyper X2'),
        new Response(53, 'Glo Hyper X2 Air'),
        new Response(54, 'IQOS Iluma'),
        new Response(55, 'IQOS Iluma One'),
        new Response(56, 'IQOS Iluma Prime'),
        new Response(57, 'IQOS Original Duo'),
        new Response(58, 'Lil Solid EZ'),
        new Response(59, 'Ploom'),
        new Response(60, ''),

    ]



    question46Responses = [
        new Response(1, 'Am vizitat site-ul Ploom (www.ploom.ro)'),
        new Response(2, 'Am vizitat pagina de Instagram Ploom'),
        new Response(3, 'Am primit emailuri/SMS-uri din partea Ploom (inclusiv oferte)'),
        new Response(4, 'Am făcut achiziții de pe site-ul mărcii Ploom (www.ploom.ro)'),
        new Response(5, 'Am fost în contact cu serviciul de asistență pentru clienți Ploom (soluționare problemelor, informații)'),
        new Response(6, 'Am participat la evenimente organizate sau sponsorizate de Ploom'),
        new Response(7, 'Interacțiuni cu brand ambasadoare/ambasadori ai mărcii Ploom (sesiuni de încercare asistate, oferte speciale și informații despre produsele Ploom)'),
        new Response(8, 'Am făcut achiziții dintr-un magazin specializat al mărcii Ploom/O insulă Ploom din Mall'),
        new Response(9, 'Servicii/experiențe la magazinele/insulele Ploom din Mall (excluzând achizițiile)'),
        new Response(10, 'Reclame Ploom online sau în afara mediului online (panouri publicitare, videoclipuri pe mașini etc.)'),
        new Response(11, 'Informații de la vânzători în magazine (inclusiv oferte speciale și informații despre produsele Ploom)'),
        new Response(12, 'Am văzut reclame la benzinării sau magazine/chioșcuri'),
        new Response(13, 'Am citit informații pe site-uri de știri sau forumuri pe internet'),
        new Response(14, 'Am văzut un videoclip pe YouTube'),
        new Response(15, 'Am văzut un stand al mărcii Ploom la un festival'),
        new Response(16, 'Am văzut marcă Ploom pe un afiș al unui eveniment (sponsor al evenimentului)')

    ];


    evapeResponses =
        [new Response(1, 'AK by Atomic', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(2, 'Blu Bar', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(3, 'Bro Twist', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(4, 'Cool Play', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(5, 'Elf Bar', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(6, 'FlerBar', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(7, 'Fumz', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(8, 'Geek Bar', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(9, 'Izy', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(10, 'Lost Mary', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(11, 'Luuv', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(12, 'MiniVape', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(13, 'One Puff', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(14, 'Only1', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(15, 'Oops', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(16, 'Oree', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(17, 'Rebelliq', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(18, 'Ske Crystal Bar', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(19, 'Uno (Veevo)', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(20, 'Vaal', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(21, 'Vapepro', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(22, 'Vapeurs', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(23, 'Vapy', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(24, 'Veeba', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(25, 'Veev NOW', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(26, 'Voom', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(27, 'Vozol', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(28, 'Vuse GO', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(29, 'Waka', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(30, 'Wiip', undefined, undefined, undefined, undefined, 'E-vape'),


        new Response(31, 'Bloss', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(32, 'Hangsen', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(33, 'Elf Bar', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(34, 'Innokin', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(35, 'Liqua', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(36, 'Relx', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(37, 'Ske Crystal Bar', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(38, 'Smok', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(39, 'Smokemania', undefined, undefined, undefined, undefined, 'E-vape'),


        new Response(40, 'Caliburn G.', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(41, 'Elf Bar', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(42, 'Eleaf', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(43, 'Innokin', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(44, 'Joyetech', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(45, 'Vaporesso', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(46, 'Veev ONE', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(47, 'Vozol Switch', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(48, 'Zeep Pod', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(49, 'Yoop', undefined, undefined, undefined, undefined, 'E-vape'),
        new Response(50, 'Altă marcă', undefined, undefined, undefined, undefined, 'E-vape'),


        ]


    htDeviceResponses = [
        new Response(1, 'Glo Hyper + uniq'),
        new Response(2, 'Glo Hyper Pro'),
        new Response(3, 'Glo Hyper X2'),
        new Response(4, 'Glo Hyper X2 Air'),
        new Response(5, 'IQOS Iluma'),
        new Response(6, 'IQOS Iluma One'),
        new Response(7, 'IQOS Iluma Prime'),
        new Response(8, 'IQOS Original Duo'),
        new Response(9, 'Lil Solid EZ'),
        // new Response(10, 'Ploom'),
        new Response(11, 'Altă marcă')
    ];


    nicotinePouches =
        [
            new Response(1, "Altora", undefined, undefined, undefined, undefined, 'NP'),
            new Response(2, "Baron", undefined, undefined, undefined, undefined, 'NP'),
            new Response(3, "Camo", undefined, undefined, undefined, undefined, 'NP'),
            new Response(4, "Cuba", undefined, undefined, undefined, undefined, 'NP'),
            new Response(5, "Drooly", undefined, undefined, undefined, undefined, 'NP'),
            new Response(6, "EOS", undefined, undefined, undefined, undefined, 'NP'),
            new Response(7, "Grant", undefined, undefined, undefined, undefined, 'NP'),
            new Response(8, "HIT", undefined, undefined, undefined, undefined, 'NP'),
            new Response(9, "Iceberg", undefined, undefined, undefined, undefined, 'NP'),
            new Response(10, "Killa", undefined, undefined, undefined, undefined, 'NP'),
            new Response(11, "Klint", undefined, undefined, undefined, undefined, 'NP'),
            new Response(12, "Niccos", undefined, undefined, undefined, undefined, 'NP'),
            new Response(13, "Pablo", undefined, undefined, undefined, undefined, 'NP'),
            new Response(14, "POP", undefined, undefined, undefined, undefined, 'NP'),
            new Response(15, "Senator", undefined, undefined, undefined, undefined, 'NP'),
            new Response(16, "SNO", undefined, undefined, undefined, undefined, 'NP'),
            new Response(17, "Strom", undefined, undefined, undefined, undefined, 'NP'),
            new Response(18, "Thunder", undefined, undefined, undefined, undefined, 'NP'),
            new Response(19, "V & YOU & Boost", undefined, undefined, undefined, undefined, 'NP'),
            new Response(20, "Velo", undefined, undefined, undefined, undefined, 'NP'),
            new Response(21, "White FOX", undefined, undefined, undefined, undefined, 'NP'),
            new Response(22, "XQS", undefined, undefined, undefined, undefined, 'NP'),
            new Response(23, "ZYN", undefined, undefined, undefined, undefined, 'NP'),
            new Response(24, "77", undefined, undefined, undefined, undefined, 'NP'),
            new Response(25, 'Altă marcă', undefined, undefined, undefined, undefined, 'NP')

        ]


    excludeBrands = [
        'AK by Atomic',
        'Blu Bar',
        'Bro Twist',
        'Cool Play',
        'Elf Bar',
        'FlerBar',
        'Fumz',
        'Geek Bar',
        'Izy',
        'Lost Mary',
        'Luuv',
        'MiniVape',
        'One Puff',
        'Only1',
        'Oops',
        'Oree',
        'Rebelliq',
        'Ske Crystal Bar',
        'Uno (Veevo)',
        'Vaal',
        'Vapepro',
        'Vapeurs',
        'Vapy',
        'Veeba',
        'Veev NOW',
        'Voom',
        'Vozol',
        'Vuse GO',
        'Waka',
        'Wiip',
        'Innokin',
        'Vozol Switch',
        'Veev ONE',
        'Joyetech',
        'Vaporesso',
        'Yoop',
        'Eleaf',
        'Zeep Pod',
        'Caliburn G.',
        'Bloss',
        'Hangsen',
        'Liqua',
        'Relx',
        'Smokemania',
        'Smok',
        'Glo Hyper + uniq',
        'Glo Hyper Pro',
        'Glo Hyper X2',
        'Glo Hyper X2 Air',
        'IQOS Iluma',
        'IQOS Iluma One',
        'IQOS Iluma Prime',
        'IQOS Original Duo',
        'Lil Solid EZ',
        'Ploom',
    ];




    question10ResponsesSobranie = [
        new Response(1, 'SOBRANIE BRONZE', undefined, undefined, 'Regular Tobacco', 'Sobranie'),
        new Response(2, 'SOBRANIE GARNET', undefined, undefined, 'Regular Sensorial', 'Sobranie'),
        new Response(3, 'SOBRANIE GOLD', undefined, undefined, 'Regular Tobacco', 'Sobranie'),
        new Response(4, 'SOBRANIE SILVER', undefined, undefined, 'Regular Tobacco', 'Sobranie'),
        new Response(5, 'SOBRANIE TAN', undefined, undefined, 'Regular Tobacco', 'Sobranie'),
        new Response(6, 'SOBRANIE TEAL', undefined, undefined, 'Regular Sensorial', 'Sobranie'),
        new Response(7, 'SOBRANIE YELLOW', undefined, undefined, 'Regular Sensorial', 'Sobranie'),
        new Response(8, 'SOBRANIE GREEN', undefined, undefined, 'Regular Tobacco', 'Sobranie'),
        new Response(9, "Altă variantă", undefined, undefined, undefined, 'Sobranie')  // Opțiune pentru Altă variantă, dacă este necesar.
    ];
    question10ResponsesTerea = [
        new Response(1, 'TEREA AMARELO FUSE', undefined, undefined, 'Regular Sensorial', 'Terea'),
        new Response(2, 'TEREA AMBER', undefined, undefined, 'Regular Tobacco', 'Terea'),
        new Response(3, 'TEREA BLUE', undefined, undefined, 'Regular Sensorial', 'Terea'),
        new Response(4, 'TEREA BRONZE', undefined, undefined, 'Regular Tobacco', 'Terea'),
        new Response(5, 'TEREA KELLY', undefined, undefined, 'Regular Sensorial', 'Terea'),
        new Response(6, 'TEREA MAUVE WAVE', undefined, undefined, 'Regular Sensorial', 'Terea'),
        new Response(7, 'TEREA RUBY FUSE', undefined, undefined, 'Regular Sensorial', 'Terea'),
        new Response(8, 'TEREA RUSSET', undefined, undefined, 'Regular Tobacco', 'Terea'),
        new Response(9, 'TEREA SIENNA', undefined, undefined, 'Regular Tobacco', 'Terea'),
        new Response(10, 'TEREA SILVER', undefined, undefined, 'Regular Tobacco', 'Terea'),
        new Response(11, 'TEREA TEAK', undefined, undefined, 'Regular Tobacco', 'Terea'),
        new Response(12, 'TEREA TURQUOISE', undefined, undefined, 'Regular Sensorial', 'Terea'),
        new Response(13, 'TEREA WIND FUSE', undefined, undefined, 'Regular Sensorial', 'Terea'),
        new Response(14, 'TEREA YELLOW', undefined, undefined, 'Regular Tobacco', 'Terea'),
        new Response(15, "Altă variantă", undefined, undefined, undefined, 'Terea')  // Opțiune pentru Altă variantă, dacă este necesar.
    ];

    question10ResponsesLevia = [
        new Response(1, 'LEVIA ZERO TOBACCO ELECTRO ROUGE', undefined, undefined, 'Paper Based', 'Levia'),
        new Response(2, 'LEVIA ZERO TOBACCO ISLAND BEAT', undefined, undefined, 'Paper Based', 'Levia'),
        new Response(3, "Altă variantă", undefined, undefined, undefined, 'Levia')  // Opțiune pentru Altă variantă, dacă este necesar.
    ];
    question10ResponsesHeets = [
        new Response(1, 'HEETS ABORA PEARL', undefined, undefined, 'Regular Sensorial', 'HEETS'),
        new Response(2, 'HEETS AMBER', undefined, undefined, 'Regular Tobacco', 'HEETS'),
        new Response(3, 'HEETS AMELIA PEARL', undefined, undefined, 'Regular Sensorial', 'HEETS'),
        new Response(4, 'HEETS AMMIL DIMENSIONS', undefined, undefined, 'Regular Tobacco', 'HEETS'),
        new Response(5, 'HEETS APRICITY DIMENSIONS', undefined, undefined, 'Regular Sensorial', 'HEETS'),
        new Response(6, 'HEETS BLUE', undefined, undefined, 'Regular Sensorial', 'HEETS'),
        new Response(7, 'HEETS BRONZE', undefined, undefined, 'Regular Tobacco', 'HEETS'),
        new Response(8, 'HEETS KELLY', undefined, undefined, 'Regular Sensorial', 'HEETS'),
        new Response(9, 'HEETS LAGUNA SWIFT', undefined, undefined, 'Regular Sensorial', 'HEETS'),
        new Response(10, 'HEETS MAUVE WAVE', undefined, undefined, 'Regular Sensorial', 'HEETS'),
        new Response(11, 'HEETS NOOR DIMENSIONS', undefined, undefined, 'Regular Tobacco', 'HEETS'),
        new Response(12, 'HEETS RUBY FUSE', undefined, undefined, 'Regular Sensorial', 'HEETS'),
        new Response(13, 'HEETS RUSSET SELECTION', undefined, undefined, 'Regular Tobacco', 'HEETS'),
        new Response(14, 'HEETS SIENNA', undefined, undefined, 'Regular Tobacco', 'HEETS'),
        new Response(15, 'HEETS SIENNA CAPS', undefined, undefined, 'Regular Tobacco', 'HEETS'),
        new Response(16, 'HEETS SILVER', undefined, undefined, 'Regular Tobacco', 'HEETS'),
        new Response(17, 'HEETS TEAK SELECTION', undefined, undefined, 'Regular Tobacco', 'HEETS'),
        new Response(18, 'HEETS TURQUOISE', undefined, undefined, 'Regular Sensorial', 'HEETS'),
        new Response(19, 'HEETS YELLOW', undefined, undefined, 'Regular Tobacco', 'HEETS'),
        new Response(20, "Altă variantă", undefined, undefined, undefined, 'HEETS')  // Dacă dorești o opțiune pentru Altă variantă.
    ];

    question10ResponsesDelia = [
        new Response(1, 'DELIA CLASSIC SILVER', undefined, undefined, 'Regular Tobacco', 'DELIA'),
        new Response(2, 'DELIA CLASSIC RED', undefined, undefined, 'Regular Tobacco', 'DELIA'),
        new Response(3, 'DELIA CLASSIC GOLD', undefined, undefined, 'Regular Tobacco', 'DELIA'),
        new Response(4, "Altă variantă", undefined, undefined, undefined, 'DELIA')  // Opțiune pentru Altă variantă, dacă este necesar.
    ];


    question10ResponsesDunhill = [
        new Response(1, 'DUNHILL NEOSTICKS COPPER TOBACCO', undefined, undefined, 'Regular Tobacco', 'Dunhill'),
        new Response(2, 'DUNHILL NEOSTICKS EMERALD TOBACCO', undefined, undefined, 'Regular Sensorial', 'Dunhill'),
        new Response(3, 'DUNHILL NEOSTICKS OBSIDIAN TOBACCO', undefined, undefined, 'Regular Tobacco', 'Dunhill'),
        new Response(4, 'DUNHILL NEOSTICKS TOPAZ TOBACCO', undefined, undefined, 'Regular Tobacco', 'Dunhill'),
        new Response(5, "Altă variantă", undefined, undefined, undefined, 'Dunhill')
    ];



    question10ResponsesVeo = [
        new Response(1, 'VEO FRESCO CLICK', undefined, undefined, 'Plant Based', 'veo'),
        new Response(2, 'VEO ICE CLICK', undefined, undefined, 'Plant Based', 'veo'),
        new Response(3, 'VEO PURPLE CLICK', undefined, undefined, 'Plant Based', 'veo'),
        new Response(4, 'VEO SCARLET CLICK', undefined, undefined, 'Plant Based', 'veo'),
        new Response(5, 'VEO SUNSET CLICK', undefined, undefined, 'Plant Based', 'veo'),
        new Response(6, "Altă variantă", undefined, undefined, undefined, 'veo')  // Opțiune pentru Altă variantă, dacă este necesar.
    ];

    question10ResponsesNeo = [
        new Response(1, 'NEO ARCTIC CLICK', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(2, 'NEO BLUE CLICK', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(3, 'NEO CLASSIC TOBACCO', undefined, undefined, 'Regular Tobacco', 'neo'),
        new Response(4, 'NEO DESIGNED AZURE', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(5, 'NEO DESIGNED GREEN', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(6, 'NEO DESIGNED PURPLE', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(7, 'NEO DESIGNED SCARLET', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(8, 'NEO GOLDEN TOBACCO', undefined, undefined, 'Regular Tobacco', 'neo'),
        new Response(9, 'NEO GREEN CLICK', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(10, 'NEO MIDNIGHT SUN', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(11, 'NEO PURPLE CLICK', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(12, 'NEO PURPLE TROPIC MIX CLICK', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(13, 'NEO SCARLET CLICK', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(14, 'NEO SUMMER CLICK', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(15, 'NEO SUNSET SWING', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(16, 'NEO TERRACOTTA TOBACCO', undefined, undefined, 'Regular Tobacco', 'neo'),
        new Response(17, 'NEO TROPIC CLICK', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(18, 'NEO TWILIGHT DANCE', undefined, undefined, 'Regular Sensorial', 'neo'),
        new Response(19, "Altă variantă", undefined, undefined, undefined, 'neo')  // Opțiune pentru Altă variantă, dacă este necesar.
    ];
    question10ResponsesKent = [
        new Response(1, 'KENT NEOSTIKS BERYL CLICK', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(2, 'KENT NEOSTIKS BLUE', undefined, undefined, 'Regular Tobacco', 'Kent'),
        new Response(3, 'KENT NEOSTIKS DARK BLUE', undefined, undefined, 'Regular Tobacco', 'Kent'),
        new Response(4, 'KENT NEOSTIKS DESIGNED GREEN', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(5, 'KENT NEOSTIKS DESIGNED VIOLET', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(6, 'KENT NEOSTIKS ELECTRIC BLUE', undefined, undefined, 'Regular Tobacco', 'Kent'),
        new Response(7, 'KENT NEOSTIKS GREEN', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(8, 'KENT NEOSTIKS MIDNIGHT BLUE', undefined, undefined, 'Regular Tobacco', 'Kent'),
        new Response(9, 'KENT NEOSTIKS MYX GREEN', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(10, 'KENT NEOSTIKS MYX NEON', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(11, 'KENT NEOSTIKS MYX PURPLE', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(12, 'KENT NEOSTIKS MYX SCARLET', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(13, 'KENT NEOSTIKS PURPLE', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(14, 'KENT NEOSTIKS SWITCH GREEN', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(15, 'KENT NEOSTIKS SWITCH RUBY', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(16, 'KENT NEOSTIKS SWITCH YELLOW', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(17, 'KENT NEOSTIKS TOBACCO', undefined, undefined, 'Regular Tobacco', 'Kent'),
        new Response(18, 'KENT NEOSTIKS VELVETY GREEN', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(19, 'KENT NEOSTIKS VIOLET CLICK', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(20, 'KENT NEOSTIKS YELLOW', undefined, undefined, 'Regular Sensorial', 'Kent'),
        new Response(21, "Altă variantă", undefined, undefined, undefined, 'Kent')  // Opțiune pentru Altă variantă, dacă este necesar.
    ];
    question10ResponsesFiit = [
        new Response(1, 'FIIT ELEMENT CAY', undefined, undefined, 'Regular Sensorial', 'Fiit'),
        new Response(2, 'FIIT ELEMENT FALL', undefined, undefined, 'Regular Sensorial', 'Fiit'),
        new Response(3, 'FIIT MARINE', undefined, undefined, 'Regular Sensorial', 'Fiit'),
        new Response(4, 'FIIT REGULAR', undefined, undefined, 'Regular Tobacco', 'Fiit'),
        new Response(5, 'FIIT REGULAR DEEP', undefined, undefined, 'Regular Sensorial', 'Fiit'),
        new Response(6, 'FIIT REGULAR SKY', undefined, undefined, 'Regular Sensorial', 'Fiit'),
        new Response(7, "Altă variantă", undefined, undefined, undefined, 'Fiit')  // Dacă dorești o opțiune pentru Altă variantă.
    ];
    question10ResponsesNuso = [
        new Response(1, 'NUSO TOBACCO BLUE', undefined, undefined, 'Regular Tobacco', 'Nuso'),
        new Response(2, 'NUSO TOBACCO BROWN', undefined, undefined, 'Regular Tobacco', 'Nuso'),
        new Response(3, 'NUSO TOBACCO GREEN', undefined, undefined, 'Regular Sensorial', 'Nuso'),
        new Response(4, 'NUSO TOBACCO PURPLE', undefined, undefined, 'Regular Sensorial', 'Nuso'),
        new Response(5, 'NUSO TOBACCO YELLOW', undefined, undefined, 'Regular Tobacco', 'Nuso'),
        new Response(6, "Altă variantă", undefined, undefined, undefined, 'Nuso')  // Opțiune pentru Altă variantă, dacă este necesar.
    ];



    question37aResponses =
        [
            new Response(1, "Allure",),
            new Response(2, "Ashima"),
            new Response(3, "Austin"),
            new Response(4, "Bentley"),
            new Response(5, "Brass"),
            new Response(6, "Camel"),
            new Response(7, "Carpati"),
            new Response(8, "Chapman Classic"),
            new Response(9, "CHE"),
            new Response(10, "CHESTERFIELD"),
            new Response(11, "Cigaronne"),
            new Response(12, "Cohiba"),
            new Response(13, "Corset"),
            new Response(14, "Davidoff"),
            new Response(15, "De Santis"),
            new Response(16, "Denim"),
            new Response(17, "Dubao"),
            new Response(18, "Dune"),
            new Response(19, "Dunhill"),
            new Response(20, "Esse"),
            new Response(21, "Fast Revolution"),
            new Response(22, "Fuyan"),
            new Response(23, "George Karelias & Sons"),
            new Response(24, "Golden Monkey"),
            new Response(25, "Goldfield"),
            new Response(26, "Karelia"),
            new Response(27, "Kent"),
            new Response(28, "L&M"),
            new Response(29, "Lucky Strike"),
            new Response(30, "Marble"),
            new Response(31, "Marlboro"),
            new Response(32, "Morgan"),
            new Response(33, "Ome"),
            new Response(34, "Pall Mall"),
            new Response(35, "Pannonia"),
            new Response(36, "Parliament"),
            new Response(37, "Pueblo"),
            new Response(38, "Rothmans"),
            new Response(39, "SILVERADO"),
            new Response(40, "Skull American Blend"),
            new Response(41, "Snagov"),
            new Response(42, "Sobranie"),
            new Response(43, "Souveran"),
            new Response(44, "Swift"),
            new Response(45, "Tennesie"),
            new Response(46, "The King"),
            new Response(47, "Viceroy"),
            new Response(48, "Vogue"),
            new Response(49, "WEST"),
            new Response(50, "Winchester"),
            new Response(51, "Winston"),
            new Response(52, 'Altă marcă')
        ]


    question37bResponses =
        [

            new Response(1, "ALTORA"),
            new Response(2, "Bali Shag"),
            new Response(3, "Bronx"),
            new Response(4, "Casablanca"),
            new Response(5, "Che"),
            new Response(6, "Chesterfield"),
            new Response(7, "Choice"),
            new Response(8, "D&B"),
            new Response(9, "Django"),
            new Response(10, "Drum"),
            new Response(11, "Eastwood"),
            new Response(12, "Firicel"),
            new Response(13, "Flandria"),
            new Response(14, "Golden Virginia"),
            new Response(15, "Look Out"),
            new Response(16, "Mac Baren"),
            new Response(17, "Marlboro"),
            new Response(18, "Primus"),
            new Response(19, "PUEBLO"),
            new Response(20, "Red Bull"),
            new Response(21, "Red Field"),
            new Response(22, "RioTabak"),
            new Response(23, "Sauvage"),
            new Response(24, "SENATOR"),
            new Response(25, "Silverado"),
            new Response(26, "Stanley"),
            new Response(27, "The Turner"),
            new Response(28, "Tilbury"),
            new Response(29, "VaBanque"),
            new Response(30, "West"),
            new Response(31, 'Altă marcă')


        ]


}